(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["checkout-flow"] && !Shopify.designMode) return;
  try {
    

let cookiePostUpsell = false;
  
// FREE FIGURE SELECTION
document.querySelectorAll('.free-figure-wrapper').forEach(wrapper => {
    wrapper.addEventListener('click', function () {
        document.querySelectorAll('.free-figure-wrapper').forEach(el => el.classList.remove('selected'));
        this.classList.add('selected');
        const dataId = this.querySelector('.free-figure-name').getAttribute('data-id');
        document.querySelector('#free-figure-id').value = dataId;
        const dataCombination = this.getAttribute('data-combination');
        document.querySelectorAll('.free-figure').forEach(el => {
          el.classList.remove('active');
        });
        document.querySelectorAll('.free-figure[data-combination="' + dataCombination + '"]').forEach(el => {
          el.classList.add('active');
        });
        //document.querySelectorAll('.bonus-free-figure').forEach(el => {
        //  el.classList.remove('active');
        //});
        //document.querySelector('.bonus-free-figure[data-combination="' + dataCombination + '"]').classList.add('active');
        document.querySelector('.checkout-flow-free-btn').removeAttribute('disabled');
    });
});
// FREE FIGURE SELECTION BUTTON
document.querySelector('.checkout-flow-free-btn').addEventListener('click', function () {

    if (document.querySelector('.checkout-flow-plan-btn').classList.contains('plan-selection-btn')) {
      document.querySelector('.checkout-flow-plan-btn').setAttribute('disabled', 'disabled');
    }
  
    document.querySelector('#free-figures-step').classList.remove('active');
    document.querySelector('#plan-selection-step').classList.add('active');
    document.querySelector('.checkout-flow-wrapper').classList.add('plan-selection-wrapper');
    document.querySelector('body').classList.add('show-scroll');

    document.querySelector('.checkout-flow-plan-btn').classList.remove('plan-selection-btn');
    document.querySelectorAll('.plan-selection-boxes').forEach(el => el.classList.remove('active'));
    document.querySelector('.single-plan-selection').classList.add('active');
  
});
// PLAN SELECTION
document.querySelectorAll('.plan-selection-box').forEach(wrapper => {
    wrapper.addEventListener('click', function () {
        document.querySelectorAll('.plan-selection-box').forEach(el => el.classList.remove('selected'));
        this.classList.add('selected');
        const plan_btn = document.querySelector('.checkout-flow-plan-btn');
        const img_wrapper = document.querySelector('.checkout-flow-image-wrapper');  
        if (this.classList.contains('plan-selection-box-monthly-offer')) {
          plan_btn.classList.add('monthly-plan-btn');
          plan_btn.classList.remove('three-plan-btn');
          plan_btn.classList.remove('six-plan-btn');
          plan_btn.classList.remove('annual-plan-btn');
          img_wrapper.classList.add('monthly-plan-img');
          img_wrapper.classList.remove('three-plan-img');
          img_wrapper.classList.remove('six-plan-img');
          img_wrapper.classList.remove('annual-plan-img');
          document.querySelector('#monthly-offer-plan').classList.add('active');
          document.querySelectorAll('.single-plan-wrapper').forEach(el => {
              el.classList.remove('active');
          });
          document.querySelector('#monthly-offer-plan').classList.add('active');

          document.querySelectorAll('.freebies-wrapper').forEach(el => {
              el.classList.remove('active');
          });
          document.querySelector('#monthly-freebies').classList.add('active');
          plan_btn.classList.add('scale-figure-plan-btn');
          plan_btn.classList.remove('tshirt-plan-btn');
        }
    });
});
// PLAN SELECTION BUTTON  
document.querySelector('.checkout-flow-plan-btn').addEventListener('click', function () {
    if (this.classList.contains('change-btn')) {
        this.classList.remove('change-btn');
        document.querySelectorAll('.single-plan-step').forEach(element => {
            if (element.classList.contains('single-plan-change')) {
                element.classList.add('selected');
                element.classList.remove('single-plan-change');
            }
        });
    } else if (this.classList.contains('plan-selection-btn')) {
        this.classList.remove('plan-selection-btn');
        this.setAttribute('disabled', 'disabled');
        document.querySelectorAll('.plan-selection-boxes').forEach(el => el.classList.remove('active'));
        document.querySelector('.single-plan-selection').classList.add('active');
        document.querySelector('.checkout-flow-back').classList.add('plan-selection-back');  
        document.querySelector('.plan-title').textContent = 'Build Your Box';
    } else if ( this.classList.contains('monthly-plan-btn') && this.classList.contains('scale-figure-plan-btn') ) {
        this.classList.remove('scale-figure-plan-btn');
        this.classList.add('tshirt-plan-btn');
        this.setAttribute('disabled', 'disabled');
        document.querySelector('#monthly-offer-plan .scale-figure-step').classList.add('selected');
        document.querySelector('#monthly-offer-plan .tshirt-step').classList.add('active');
    } else if ( this.classList.contains('monthly-plan-btn') && this.classList.contains('tshirt-plan-btn') ) {
        this.classList.remove('tshirt-plan-btn');
        this.classList.add('box-plan-btn');
        this.setAttribute('disabled', 'disabled');
        document.querySelector('#monthly-offer-plan .tshirt-step').classList.add('selected');
        document.querySelector('#monthly-offer-plan .box-step').classList.add('active');
    } else if ( this.classList.contains('box-plan-btn') ) {
        const freeFigureIdInput = document.querySelector('#free-figure-id').value;
        const scaleFigureIdInput = document.querySelector('#scale-figure-id').value;
        const scaleFigurePlanInput = document.querySelector('#scale-figure-id-plan').value;
        const tshirtIdInput = document.querySelector('#t-shirt-id').value;
        const tshirtPlanInput = document.querySelector('#t-shirt-id-plan').value;
        const boxIdInput = document.querySelector('#box-id').value;
        const boxPlanInput = document.querySelector('#box-id-plan').value;
        let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
        if ( freeFigureIdInput != '' ) {
          checkout_url = checkout_url + "items[][id]=" + freeFigureIdInput + "%26items[][quantity]=1%26";
        }
        if ( ( scaleFigureIdInput != '' ) && ( scaleFigurePlanInput != '' ) ){
          checkout_url = checkout_url + "items[][id]=" + scaleFigureIdInput + "%26items[][quantity]=1%26items[][selling_plan]=" + scaleFigurePlanInput + "%26";
        }
        if ( ( tshirtIdInput != '' ) && ( tshirtPlanInput != '' ) ){
          checkout_url = checkout_url + "items[][id]=" + tshirtIdInput + "%26items[][quantity]=1%26items[][selling_plan]=" + tshirtPlanInput + "%26";
        }
        if ( ( boxIdInput != '' ) && ( boxPlanInput != '' ) ){
          checkout_url = checkout_url + "items[][id]=" + boxIdInput + "%26items[][quantity]=1%26items[][selling_plan]=" + boxPlanInput + "%26";
        }
        if ( ( boxIdInput != '' ) && ( boxPlanInput == '' ) ){
          checkout_url = checkout_url + "items[][id]=" + boxIdInput + "%26items[][quantity]=1%26";
        }
        if (document.querySelector('#monthly-freebies').classList.contains('active')) {
            const freebieInputs = document.querySelector('#monthly-freebies').querySelectorAll('input.freebie-id');
            freebieInputs.forEach(input => {
                checkout_url = checkout_url + "items[][id]=" + input.value + "%26items[][quantity]=1%26";
            });
        }

        cookieExpiry = new Date(Date.now() + 86400e3).toUTCString(); // Set expiry to one day
        document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=.theotakubox.com;path=/;expires=${cookieExpiry};SameSite=None; Secure`;
        document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=theotakubox.com;expires=${cookieExpiry};SameSite=None; Secure`;
      
        checkout_url = checkout_url + "return_to=/checkout";
        fetch('/cart/clear.js', {
            method: 'POST',
        })
        .then(response => response.json())
        .then(data => {
            // You can handle the response here if needed
        })
        .catch(error => {
            console.error('Error:', error);
        });
        setTimeout(function(){  $(".the-otaku-box-spinner").show(); $("body").addClass("fixed"); }, 100);
        setTimeout(function(){  window.location.href = checkout_url; }, 500);
    }
});
// SINGLE PLAN SELECTION SCALE FIGURE
document.querySelectorAll('#monthly-offer-plan .scale-figure-step .single-plan-step-questions-select').forEach(element => {
    element.addEventListener('click', function () {
        const inputIdValue = this.querySelector('.single-plan-step-questions-select-input-id').value;
        const inputPlanValue = this.querySelector('.single-plan-step-questions-select-input-selling-plan').value;
        document.querySelector('#scale-figure-id').value = inputIdValue;
        document.querySelector('#scale-figure-id-plan').value = inputPlanValue;
        document.querySelector('.checkout-flow-plan-btn').removeAttribute("disabled");   
        if (this.classList.contains('no-option')) {
            this.closest('#monthly-offer-plan .single-plan-step').classList.add('deny-offer');
            document.querySelectorAll('.secondary-img.scale-figure').forEach(el => el.classList.remove('active'));
            if (document.querySelector('#monthly-offer-plan .scale-figure-step .yes-option.selected')) {
              let price1 = parseFloat(document.querySelector('#monthly-offer-plan .scale-figure-step .yes-option .single-plan-step-questions-select-inner').getAttribute('data-price'));
              let price2 = parseFloat(document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').getAttribute('data-price'));
              let totalPrice = price2 - price1;
              document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').setAttribute('data-price', totalPrice);
              document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').textContent = `$${totalPrice.toFixed(2)}`;
            }
            document.querySelectorAll('#monthly-offer-plan .scale-figure-step .single-plan-step-questions-select').forEach(el => el.classList.remove('selected'));
            this.classList.add('selected');
        } else {
            this.closest('#monthly-offer-plan .single-plan-step').classList.remove('deny-offer');
            document.querySelectorAll('.secondary-img.scale-figure').forEach(el => el.classList.add('active'));
            if (!document.querySelector('#monthly-offer-plan .scale-figure-step .yes-option.selected')) {
              let price1 = parseFloat(document.querySelector('#monthly-offer-plan .scale-figure-step .yes-option .single-plan-step-questions-select-inner').getAttribute('data-price'));
              let price2 = parseFloat(document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').getAttribute('data-price'));
              let totalPrice = price1 + price2;
              document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').setAttribute('data-price', totalPrice);
              document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').textContent = `$${totalPrice.toFixed(2)}`;
            }
            document.querySelectorAll('#monthly-offer-plan .scale-figure-step .single-plan-step-questions-select').forEach(el => el.classList.remove('selected'));
            this.classList.add('selected');
        }
        //document.querySelector('.checkout-flow-plan-btn').scrollIntoView({ behavior: 'smooth' });
        window.scrollTo({ top: document.querySelector('.checkout-flow-plan-btn').getBoundingClientRect().top + window.scrollY - window.innerHeight + 100, behavior: 'smooth' });
    });
});
// SINGLE PLAN SELECTION TSHIRT
document.querySelectorAll('#monthly-offer-plan .tshirt-step .single-plan-step-questions-select').forEach(element => {
    element.addEventListener('click', function () {
        const inputIdValue = this.querySelector('.single-plan-step-questions-select-input-id').value;
        const inputPlanValue = this.querySelector('.single-plan-step-questions-select-input-selling-plan').value;
        document.querySelector('#t-shirt-id').value = inputIdValue;
        document.querySelector('#t-shirt-id-plan').value = inputPlanValue;
        document.querySelector('.checkout-flow-plan-btn').removeAttribute("disabled");
        if (this.classList.contains('no-option')) {
            this.closest('#monthly-offer-plan .single-plan-step').classList.add('deny-offer');
            document.querySelectorAll('.secondary-img.tshirt-figure').forEach(el => el.classList.remove('active'));
            if (document.querySelector('#monthly-offer-plan .tshirt-step .yes-option.selected')) {
              let price1 = parseFloat(document.querySelector('#monthly-offer-plan .tshirt-step .yes-option .single-plan-step-questions-select-inner').getAttribute('data-price'));
              let price2 = parseFloat(document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').getAttribute('data-price'));
              let totalPrice = price2 - price1;
              document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').setAttribute('data-price', totalPrice);
              document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').textContent = `$${totalPrice.toFixed(2)}`;
              document.querySelectorAll('#monthly-offer-plan .tshirt-step .single-plan-step-questions-select').forEach(el => el.classList.remove('selected'));
            } 
            this.classList.add('selected');
        } else {
            this.closest('#monthly-offer-plan .single-plan-step').classList.remove('deny-offer');
            document.querySelectorAll('.secondary-img.tshirt-figure').forEach(el => el.classList.add('active'));
            if (!document.querySelector('#monthly-offer-plan .tshirt-step .yes-option.selected')) {
              let price1 = parseFloat(document.querySelector('#monthly-offer-plan .tshirt-step .yes-option .single-plan-step-questions-select-inner').getAttribute('data-price'));
              let price2 = parseFloat(document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').getAttribute('data-price'));
              let totalPrice = price1 + price2;
              document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').setAttribute('data-price', totalPrice);
              document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').textContent = `$${totalPrice.toFixed(2)}`;
            }
            document.querySelectorAll('#monthly-offer-plan .tshirt-step .single-plan-step-questions-select').forEach(el => el.classList.remove('selected'));
            this.classList.add('selected');
        }
        //document.querySelector('.checkout-flow-plan-btn').scrollIntoView({ behavior: 'smooth' });   
      window.scrollTo({ top: document.querySelector('.checkout-flow-plan-btn').getBoundingClientRect().top + window.scrollY - window.innerHeight + 100, behavior: 'smooth' });

    });
});
// SINGLE PLAN SELECTION BOX
document.querySelectorAll('#monthly-offer-plan .box-step .single-plan-step-questions-select').forEach(element => {
    element.addEventListener('click', function () {
        document.querySelectorAll('#monthly-offer-plan .box-step .single-plan-step-questions-select').forEach(el => el.classList.remove('selected'));
        this.classList.add('selected');
        const inputIdValue = this.querySelector('.single-plan-step-questions-select-input-id').value;
        const inputPlanValue = this.querySelector('.single-plan-step-questions-select-input-selling-plan').value;
        document.querySelector('#box-id').value = inputIdValue;
        document.querySelector('#box-id-plan').value = inputPlanValue;
        document.querySelector('.checkout-flow-plan-btn').removeAttribute("disabled");
        if (this.classList.contains('no-option')) {
            this.closest('#monthly-offer-plan .single-plan-step').classList.add('deny-offer');
        } else {
            this.closest('#monthly-offer-plan .single-plan-step').classList.remove('deny-offer');
        }
        //document.querySelector('.checkout-flow-plan-btn').scrollIntoView({ behavior: 'smooth' });
        window.scrollTo({ top: document.querySelector('.checkout-flow-plan-btn').getBoundingClientRect().top + window.scrollY - window.innerHeight + 100, behavior: 'smooth' });
    });
});   
// CHANGE BTN
document.querySelectorAll('.single-plan-step-change').forEach(element => {
    element.addEventListener('click', function () {
        document.querySelector('.checkout-flow-plan-btn').classList.add('change-btn');
        this.closest('.single-plan-step').classList.remove('selected');
        this.closest('.single-plan-step').classList.add('single-plan-change');
    });
}); 
// BACK BTN
document.querySelector('.checkout-flow-back').addEventListener('click', function () {
    if (this.classList.contains('plan-selection-back')) {
        document.querySelector('.checkout-flow-plan-btn').classList.add('plan-selection-btn');
        document.querySelector('.checkout-flow-plan-btn').classList.remove('box-plan-btn');
        document.querySelector('.checkout-flow-plan-btn').classList.remove('tshirt-plan-btn');
        document.querySelector('.checkout-flow-plan-btn').classList.remove('scale-figure-plan-btn');
        document.querySelector('.plan-title').textContent = 'Select Your Plan';
        if ( document.querySelector('.plan-selection-box-monthly-offer.selected') || document.querySelector('.plan-selection-box-three-months-offer.selected') ) {
          document.querySelector('.checkout-flow-plan-btn').classList.add('scale-figure-plan-btn');
        } else {
          document.querySelector('.checkout-flow-plan-btn').classList.add('tshirt-plan-btn');  
        }   
        document.querySelector('.checkout-flow-plan-btn').removeAttribute("disabled");
        document.querySelector('.plan-selection-boxes').classList.add('active');
        document.querySelector('.single-plan-selection').classList.remove('active');
        document.querySelector('.checkout-flow-back').classList.remove('plan-selection-back');  
        const stepsMonthly = document.querySelectorAll('#monthly-offer-plan .single-plan-step');
        stepsMonthly.forEach(step => {
            step.classList.remove('active', 'selected');
        }); 
        if (stepsMonthly.length > 0) {
            stepsMonthly[0].classList.add('active');
        }
        const stepsThree = document.querySelectorAll('#three-offer-plan .single-plan-step');
        stepsThree.forEach(step => {
            step.classList.remove('active', 'selected');
        });
        
        if (stepsThree.length > 0) {
            stepsThree[0].classList.add('active');
        }
        const stepsSix = document.querySelectorAll('#six-offer-plan .single-plan-step');
        stepsSix.forEach(step => {
            step.classList.remove('active', 'selected');
        });
        if (stepsSix.length > 0) {
            stepsSix[0].classList.add('active');
        }
        const stepsAnnual = document.querySelectorAll('#annual-offer-plan .single-plan-step');
        stepsAnnual.forEach(step => {
            step.classList.remove('active', 'selected');
        });
        if (stepsAnnual.length > 0) {
            stepsAnnual[0].classList.add('active');
        }
        const selects = document.querySelectorAll('.single-plan-step-questions-select');
        selects.forEach(select => {
            select.classList.remove('selected');
        });
        document.querySelector('#scale-figure-id').value = '';
        document.querySelector('#scale-figure-id-plan').value = '';
        document.querySelector('#t-shirt-id').value = '';
        document.querySelector('#scale-figure-id-plan').value = '';
        document.querySelector('#box-id').value = '';
        document.querySelector('#box-id-plan').value = '';
        let original_price_m = parseFloat(document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').getAttribute('data-original-price'));
        let original_price_t = parseFloat(document.querySelector('#three-offer-plan .single-plan-price-wrapper').getAttribute('data-original-price'));
        document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').setAttribute('data-price', original_price_m);
        document.querySelector('#monthly-offer-plan .single-plan-price-wrapper').textContent = `$${original_price_m.toFixed(2)}`;
        document.querySelector('#three-offer-plan .single-plan-price-wrapper').setAttribute('data-price', original_price_t);
        document.querySelector('#three-offer-plan .single-plan-price-wrapper').textContent = `$${original_price_t.toFixed(2)}`;       
    } else if (this.classList.contains('free-figures-back')) {
        document.querySelector('#free-figures-step').classList.add('active');
        document.querySelector('#plan-selection-step').classList.remove('active');
        document.querySelector('.checkout-flow-wrapper').classList.remove('plan-selection-wrapper');
        document.querySelector('body').classList.remove('show-scroll');
    }  
});  
$(document).ready(function() {
  function generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  const urgencyNote = $('.urgency-note');
  if (urgencyNote.length > 0) {
    const randomNumber = generateRandomNumber(100, 150);
    urgencyNote.find('span').text(randomNumber);
  }
});   
// Select the element
const freeFigures = document.querySelector('.free-figures');
// Add a scroll event listener
freeFigures.addEventListener('scroll', function() {
    // Add the 'scrolling' class when scrolling starts
    if (freeFigures.scrollTop > 0) {
        freeFigures.classList.add('scrolling');
    } else {
        // freeFigures.classList.remove('scrolling');
    }
});
document.addEventListener("DOMContentLoaded", function() {
  const urlParams = new URLSearchParams(window.location.search);
  const figure = urlParams.get("figure");
  if (figure !== null) {
    const combination = {
      "first": "1",
      "second": "2",
      "third": "3",
      "fourth": "4",
      "fifth": "5",
      "sixth": "6"
    }[figure];
    if (combination) {
      document.getElementById("free-figures-step").style.display = "none";
      document.querySelector(`.free-figure-wrapper[data-combination='${combination}']`).click();
      setTimeout(function() {
        document.querySelector(".checkout-flow-free-btn").click();
      }, 10);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-et_initial_offer"] && !Shopify.designMode) return;
  try {
    
$( document ).ready(function() {
  $( ".otaku-box-survey-status-next-init" ).click(function( ) {
	if ( $("#yes-offer").closest(".otaku-boxanswer-select-container").hasClass("selected")  ) {
      $(this).closest(".shopify-section").remove();
      $(".monthly-offeer-hidden.show-monthly-offer").show();
      $(".monthly-offeer-hidden.show-monthly-offer").removeClass("monthly-offeer-hidden");
      $("html, body").animate({scrollTop: 0}, 1000);
    } else {
	  window.location.href = $("#no-offer").attr("data-href");
    }
 });
}); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-tob_initial_offer"] && !Shopify.designMode) return;
  try {
    
$( document ).ready(function() {
  $( "#annual-offer" ).click(function() {
	$(".monthly-offeer-hidden").closest(".shopify-section").remove();
	$(".annual-offeer-hidden").removeClass("annual-offeer-hidden");
    $(this).closest(".shopify-section").remove();
    $("html, body").animate({scrollTop: 0}, 1000);
  });
  $( "#monthly-offer" ).click(function() {
	$(".annual-offeer-hidden").closest(".shopify-section").remove();
	$(".monthly-offeer-hidden").removeClass("monthly-offeer-hidden");
    $(this).closest(".shopify-section").remove();
    $("html, body").animate({scrollTop: 0}, 1000);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-tob_offer_01"] && !Shopify.designMode) return;
  try {
    
$( document ).ready(function() {
  $( ".otaku-boxanswer-select-container" ).click(function() {
    if ( $(this).hasClass("selected") ) {
      $(this).removeClass("selected");
      $(".otaku-box-survey-status-nav button").attr("disabled","disabled");	
      $(this).closest(".otaku-box-surveys-question-container").find(".otaku-box-step-select-input-id").eq(0).val("");
      $(this).closest(".otaku-box-surveys-question-container").find(".otaku-box-step-select-input-selling-plan").eq(0).val("");
      $("#otaku-box-footer-index").text("0");
    } else if ( !$(this).hasClass("otaku-boxanswer-select-container-initial") ) {  
      $(this).closest(".otaku-box-surveys-question-answers").find(".otaku-boxanswer-select-container").removeClass("selected");
      $(this).addClass("selected");
      $(".otaku-box-survey-status-nav button").removeAttr("disabled");
      $(this).closest(".otaku-box-surveys-question-container").find(".otaku-box-step-select-input-id").eq(0).val( $(this).find(".otaku-box-answer-select-input-id").val() );
      $(this).closest(".otaku-box-surveys-question-container").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).find(".otaku-box-answer-select-input-selling-plan").val() );
	  $("#otaku-box-footer-index").text("1");
      let current_step = parseInt($(".otaku-box-stepper-step-outer.active").attr("step"));
      $(".otaku-box-stepper-step-outer[step=" + current_step + "]").addClass("completed");	 
	  if ( ( $(this).closest(".otaku-box-surveys-question-container").find(".otaku-box-step-option-name").length != -1 ) && 
         ( $(this).find(".otaku-box-answer-select-box-option-name").length != -1 ) ) {	
        $(this).closest(".otaku-box-surveys-question-container").find(".otaku-box-step-option-name").val( $(this).find(".otaku-box-answer-select-box-option-name").val() );
	  }
    }
    if ( $(this).closest(".otaku-box-surveys-question-container").hasClass("tob-variant-final") ) {
      let combined_options = '';
      $( ".otaku-box-surveys-question-container" ).each(function() {
	    if ( ( $(this).closest(".otaku-box-surveys-question-container").find( ".otaku-box-step-option-name" ).val() != '' ) &&
		     ( $(this).closest(".otaku-box-surveys-question-container").find( ".otaku-box-step-option-name" ).val() != null ) ) {
          combined_options = combined_options + $(this).closest(".otaku-box-surveys-question-container").find( ".otaku-box-step-option-name" ).val();
        }
      });


      $(this).closest(".otaku-box-surveys-question-container").find(".otaku-box-step-select-input-id").eq(0).val( $(this).closest(".otaku-box-surveys-question-container").find(".otaku-box-answer-select-input-id.variant-title-" + combined_options ).val() );
      $(this).closest(".otaku-box-surveys-question-container").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).closest(".otaku-box-surveys-question-container").find(".otaku-box-answer-select-input-selling-plan.variant-title-" + combined_options).val() );
    }
  });
});
$( document ).ready(function() {
  $( ".otaku-box-survey-status-next" ).click(function() {
    if ( $(this).hasClass("otaku-box-survey-status-finish") ) {

	  let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $( ".otaku-box-surveys-question-container" ).each(function() {

	    if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();
        }
        if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }

		if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {

          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }

          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }

		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	

          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	

          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	

		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }		

          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	

		}

      });

      checkout_url = checkout_url + "return_to=/checkout?step=contact_information";

	  jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });	

      window.location.href = checkout_url;
      

    } else {
	  let current_step = parseInt($(".otaku-box-stepper-step-outer.active").attr("step"));
	  let last_step = parseInt($("#last-step").val());
	  let next_step = current_step + 1;
	  $(".otaku-box-stepper-step-outer.active").removeClass("active");
	  $(".otaku-box-stepper-step-outer[step=" + next_step + "]").addClass("active");
      $(".otaku-box-stepper-step-outer[step=" + current_step + "]").addClass("completed");
      if ( current_step != last_step ) {
        $(".otaku-box-stepper-step-outer[step=" + current_step + "]").find(".otaku-box-stepper-step span").text("✓");
      }
	  $(".otaku-box-surveys-question-container.selected").removeClass("selected");
	  $(".otaku-box-surveys-question-container[step=" + next_step + "]").addClass("selected");
      if ( $(".otaku-box-surveys-question-container[step=" + next_step + "] .otaku-boxanswer-select-container").hasClass("selected") ) {
      } else {
	    $(".otaku-box-survey-status-next").attr("disabled","disabled");
	    $("#otaku-box-footer-index").text("0");
      }
	  if ( next_step == last_step ) {
		$(".otaku-box-survey-status-next").text("Save Choices");
		$(".otaku-box-survey-status-next").addClass("otaku-box-survey-status-finish");
	  }
	  $(".otaku-box-survey-status-previous").removeClass("hide-previous");

      $("html, body").animate({scrollTop: 0}, 1000);
	}
  });
});
$( document ).ready(function() {
  $( ".otaku-box-stepper-step-outer" ).click(function() {
    if ( $(this).hasClass("completed") ) {
      let navigation_step = parseInt( $(this).attr("step") );
      let last_step = parseInt($("#last-step").val());
      $(".otaku-box-stepper-step-outer").removeClass("active");
      $(this).addClass("active");
      $(this).find(".otaku-box-stepper-step span").text(navigation_step);
      $(".otaku-box-stepper-step-outer.completed:not(.active)").find(".otaku-box-stepper-step span").text("✓");
      $(".otaku-box-stepper-step-outer[step=" + last_step + "]").find(".otaku-box-stepper-step span").text(last_step);
      $(".otaku-box-surveys-question-container.selected").removeClass("selected");
      $(".otaku-box-surveys-question-container[step=" + navigation_step + "]").addClass("selected");
      $(".otaku-box-survey-status-nav button").removeAttr("disabled");
      $("#otaku-box-footer-index").text("1");
      $(".otaku-box-survey-status-next").text("Next Step");
	  $(".otaku-box-survey-status-next").removeClass("otaku-box-survey-status-finish");
	  if ( navigation_step == last_step ) {
		$(".otaku-box-survey-status-next").text("Save Choices");
		$(".otaku-box-survey-status-next").addClass("otaku-box-survey-status-finish");
      }	
      if ( navigation_step == 1 ) {
		$(".otaku-box-survey-status-previous").addClass("hide-previous");
      } else {
        $(".otaku-box-survey-status-previous").removeClass("hide-previous");
      }
    }
  });
});
$( document ).ready(function() {
  $( ".otaku-box-survey-status-previous" ).click(function() {
    let current_step = parseInt($(".otaku-box-stepper-step-outer.active").attr("step"));
	let previous_step = current_step - 1;
    $(".otaku-box-stepper-step-outer.active").removeClass("active");
	$(".otaku-box-stepper-step-outer[step=" + previous_step + "]").addClass("active");
    $(".otaku-box-surveys-question-container.selected").removeClass("selected");
	$(".otaku-box-surveys-question-container[step=" + previous_step + "]").addClass("selected");
    $(".otaku-box-survey-status-nav button").removeAttr("disabled");
    $("#otaku-box-footer-index").text("1");
    $(".otaku-box-survey-status-next").text("Next Step");
    $(".otaku-box-survey-status-next").removeClass("otaku-box-survey-status-finish");
    if ( previous_step == 1 ) {
      $(".otaku-box-survey-status-previous").addClass("hide-previous");
    }
  });
});
$( document ).ready(function() {
  $( ".otaku-box-pre-purchase-offer-accept" ).click(function( event ) {
    event.preventDefault();
	$(".show-monthly-offer").removeClass("show-monthly-offer");
	$(".hide-otaky-box-initial-offer").removeClass("hide-otaky-box-initial-offer");
    $(".otaku-box-body.otaku-box-has-pre-purchase").removeClass("otaku-box-has-pre-purchase");
    $(this).closest(".otaku-box-body").addClass("otaku-box-has-pre-purchase");
    $("html, body").animate({scrollTop: 0}, 1000);
    
  });
  $( ".otaku-box-pre-purchase-offer-reject" ).click(function( event ) {
    event.preventDefault();
    $(".otaku-box-body.otaku-box-has-pre-purchase").removeClass("otaku-box-has-pre-purchase");
    $(this).closest(".otaku-box-body").addClass("otaku-box-has-pre-purchase");
	$(".otaku-box-pre-purchase .otaku-box-step-select-input-id").eq(0).val("");
	$(".otaku-box-pre-purchase .otaku-box-step-select-input-selling-plan").eq(0).val("");
    
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-tob_offer_02"] && !Shopify.designMode) return;
  try {
    
$( document ).ready(function() { 
  $( ".otaku-box-offer-btn" ).click(function() {
    if ( $(this).hasClass("otaku-box-offer-btn-initial") ) {
   	  $(".otaku-box-offer-boxes").remove();   
      $(".otaku-box-offer-info").remove();
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info").addClass("selected");
      $(this).removeClass("otaku-box-offer-btn-initial");
      $(this).addClass("otaku-box-offer-btn-next");
      $(this).attr("disabled","disabled");	
    } else if ( $(this).hasClass("otaku-box-offer-btn-show-retail-price") ) {
      $(this).removeClass("otaku-box-offer-btn-show-retail-price");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select.show-retail-price").removeClass("show-retail-price");
      $(this).html("Checkout");
      $(".retail-price-step").addClass("selected");
      $(".retail-price-section").addClass("show");
      $(".otaku-box-selected-offer-info-footer-price").addClass("show");
      $(".otaku-box-offer-footer").addClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").remove();
    } else if ( $(this).hasClass("otaku-box-offer-btn-pre-purchase") ) {
      $(this).html("Next");
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-edit"); 
	  $(this).closest(".the-otaku-box-body").find(".btn-start-pre-purchase").click();
      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $( ".otaku-box-selected-offer-step" ).each(function() {
        if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();
        }
        if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }		
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		}
      });
      let checkout_local_url = $("#local_url").val();
      let checkout_digtial_all_url = ''; 
      $( ".the-otaku-box-body.selected .digital-step" ).each(function() {
        checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-answer-select-main-input-id" ).val() + "%26items[][quantity]=1%26";
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
          checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
          checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() + "%26items[][quantity]=1%26";
        }
      });
      checkout_digtial_all_url = checkout_url + checkout_digtial_all_url + "return_to=" + checkout_local_url + "checkout?step=contact_information";
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout?step=contact_information";
      jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });
      $("#digital-all").attr("href", checkout_digtial_all_url); 
      $(".otaku-box-offer-footer-cancel-digital").attr("href", checkout_url);   
    } else if ( $(this).hasClass("otaku-box-offer-btn-edit") ) {
      $(".otaku-box-selected-offer-step.edit").removeClass("edit");
      $(this).removeClass("otaku-box-offer-btn-edit");
      if ( $(".otaku-box-selected-offer-step.active").find(".otaku-box-questions-select.selected").length == 0 ) {
	    $(this).attr("disabled","disabled");
      }
    } else if ( $(this).hasClass("otaku-box-offer-btn-final") ) {
      setTimeout(function(){  $(".the-otaku-box-spinner").show();  }, 100);
      $(this).attr("style","pointer-events:none;")
      $(".otaku-box-selected-offer-info-header-digital").addClass("finished-test");
      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $(this).closest(".the-otaku-box-body").find( ".otaku-box-selected-offer-step" ).each(function() {
       if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();
        }
        if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }		
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		}
      });
      let checkout_local_url = $("#local_url").val();
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout?step=contact_information";
	  jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });	
      window.location.href = checkout_url;
    } else if ( $(this).hasClass("otaku-box-offer-btn-next") ) {
      $(this).attr("disabled","disabled");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").addClass("selected");
 	  $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").next().addClass("active");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active.selected").removeClass("active");
    }
 });
});  
$( document ).ready(function() {
  $( ".otaku-box-questions-select" ).click(function() {
    let current_step = 	$(this).closest(".otaku-box-selected-offer-step").attr("data-step");
    if ( $(this).hasClass("otaku-box-questions-select-pre-step") ) {
      let combination_step = $(this).attr("data-combination");
      $( ".the-otaku-box-container" ).each(function() {
        $( this ).find( ".free-pre-step .otaku-box-questions-combination .otaku-box-questions-select[data-combination=" + combination_step + "]" ).click();
      });
      $(".otaku-box-selected-offer-step[data-step='2']").addClass("active");
      $(".otaku-box-offer-pre-btn").removeAttr("disabled");
    } else if ( $(this).hasClass("no-option") ) {
	  $(this).closest(".otaku-box-selected-offer-step").addClass("deny-offer");
      setTimeout(function(){  $('.step-image[data-step=' + current_step + ']').removeClass("show-image");  }, 500);
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
	  if ( $('.step-image-remove[data-step=' + current_step + ']').length > 0 ) {
        setTimeout(function(){  $('.step-image-remove[data-step=' + current_step + ']').removeClass("remove-image");  }, 500);
        $('.step-image-remove[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
	  }
    } else if ( $(this).hasClass("otaku-box-combination-product") ) {
	  let current_combination = 	$(this).attr("data-combination");
      $('.step-image-combination').removeClass("show-image");
      $('.step-image-combination').removeAttr( 'style' );
      $('.step-image[data-step_' + current_combination + '=' + current_step + ']').addClass("show-image");
	  $('.step-image[data-step_' + current_combination + '=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
    } else {
	  $(this).closest(".otaku-box-selected-offer-step").removeClass("deny-offer");
	  $('.step-image[data-step=' + current_step + ']').addClass("show-image");
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
	  if ( $('.step-image-remove[data-step=' + current_step + ']').length > 0 ) {
        $('.step-image-remove[data-step=' + current_step + ']').addClass("remove-image");
        $('.step-image-remove[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
	   }
    }
    if ( $(this).hasClass("otaku-box-questions-select-variations") ) {
      let selected_var_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price") ); 
      if ( $(this).hasClass("otaku-box-questions-select-variations-quarterly") ) {
        selected_var_price = selected_var_price / 3;
        selected_var_price = selected_var_price.toFixed(2);
      }
      if ( selected_var_price == 0 ) {
        selected_var_price = "0.00";
      }
      $(this).closest(".otaku-box-selected-offer-step-info").find(".otaku-box-selected-offer-step-price span").text("$" + selected_var_price.toString());
    }
    if ( $(this).hasClass("otaku-box-questions-select-pre-step") ) {
      $(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select" ).removeClass("selected");
      $(this).addClass("selected");
    } else {
    let current_price = parseFloat( $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-info-price").attr("data-price") );
    let selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price") ); 
    let current_rrp_price = parseFloat( $(this).closest(".otaku-box-body-offer-container").find(".retail-price-title span").attr("data-rrp-price") );
    let selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price") ); 
    let selected_currency = $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
    if ( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected").length != 0 ) {
	  let step_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-price"));
      let new_price = current_price - step_price + selected_price;
      new_price = new_price.toFixed(2);
      let step_rrp_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-rrp-price"));
      let new_rrp_price = current_rrp_price - step_rrp_price + selected_rrp_price;
      new_rrp_price = new_rrp_price.toFixed(2);
      if ( selected_currency == "€") {
       current_price = parseFloat( $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-info-price").attr("data-price").replace(/\,/g, '.') );
       selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
	   step_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') );
	   new_price = current_price - step_price + selected_price;
	   new_price = new_price.toFixed(2).toString().replace(/\./g, ',');
       if ( (".retail-price-title span").lenght > 0 ) { 
         current_rrp_price = parseFloat( $(this).closest(".otaku-box-body-offer-container").find(".retail-price-title span").attr("data-rrp-price").replace(/\,/g, '.') );
         selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') ); 
  	     step_rrp_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') );
  	     new_rrp_price = current_rrp_price - step_rrp_price + selected_rrp_price;
  	     new_rrp_price = new_rrp_price.toFixed(2).toString().replace(/\./g, ',');
       }  
	  } 
      if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false ) {
        $(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
        $(".otaku-box-selected-offer-info-price").text(selected_currency + new_price.toString());
        $(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
        $(".retail-price-title span").text( selected_currency + new_rrp_price.toString());
      }
    } else {     
      let new_price = current_price + selected_price;
      new_price = new_price.toFixed(2);
      let new_rrp_price = current_rrp_price + selected_rrp_price;
      new_rrp_price = new_rrp_price.toFixed(2);
      if ( selected_currency == "€") {
		current_price = parseFloat( $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-info-price").attr("data-price").replace(/\,/g, '.') );
        selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
	    new_price = current_price + selected_price;
        new_price = new_price.toFixed(2).toString().replace(/\./g, ',');
        if ( (".retail-price-title span").lenght > 0 ) {
          current_rrp_price = parseFloat( $(this).closest(".otaku-box-body-offer-container").find(".retail-price-title span").attr("data-rrp-price").replace(/\,/g, '.') );
          selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') ); 
  	      new_rrp_price = current_rrp_price + selected_rrp_price;
          new_rrp_price = new_rrp_price.toFixed(2).toString().replace(/\./g, ',');
        }  
	  }
      if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false ) {
        $(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
        $(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toString());
        $(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
        $(".retail-price-title span").text( selected_currency + new_rrp_price.toString());
      }
    }
    $(".otaku-box-offer-btn").removeAttr("disabled");
	$(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select" ).removeClass("selected");
    $(this).addClass("selected");
	if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("otaku-box-selected-offer-step-final") ) {
	  $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    }
	if ( $(this).hasClass("start-pre-purchase") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-pre-purchase");
    }
    if ( $(this).hasClass("show-retail-price") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-show-retail-price");
    }
    $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).find(".otaku-box-answer-select-input-id").val() );
    $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).find(".otaku-box-answer-select-input-selling-plan").val() );
    if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("tob-variant-final") ) {
      let combined_options = '';
      $( ".otaku-box-selected-offer-step" ).each(function() {
	    if ( ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != '' ) &&
		     ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != null ) ) {
          combined_options = combined_options + $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val();
        }
      });
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-id.variant-title-" + combined_options ).val() );
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-selling-plan.variant-title-" + combined_options).val() );
    }
    }
 });
}); 
$( document ).ready(function() {
  $( ".otaku-box-selected-offer-step-change" ).click(function() {
    $(".otaku-box-selected-offer-step").removeClass("edit"); 
    $(this).closest(".otaku-box-selected-offer-step").addClass("edit");  
    $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-edit");
    $(".otaku-box-offer-btn").attr("disabled","disabled");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-monthly-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-monthly-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-monthly-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-three-months-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-three-months-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-three-months-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-six-months-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-six-months-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-six-months-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-annual-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-annual-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-annual-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( "#digital-no" ).click(function() {
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-edit");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn-final").click();
    $('#pre-purchase').css('pointer-events','none');
    $("#pre-purchase .modal-dialog").hide();
  });
  $( "#digital-yes" ).click(function() {
    $(".otaku-box-offer-footer-cancel-digital").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
    $("#pre-purchase .close").click();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-price").removeClass("otaku-box-selected-offer-info-price");
    $(".the-otaku-box-body.selected").find(".otaku-box-pre-purchase-offer-price").addClass("otaku-box-selected-offer-info-price");
    $(".main-product-image").addClass("remove-main-image");
    $(".main-digital-image").removeClass("remove-digital-image");
    $(".otaku-box-body-image-container").addClass("digital-image-container");
    $(".otaku-box-selected-offer-info-header").addClass("otaku-box-selected-offer-info-digital-header");
    let info_title = $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").attr("data-title");	
    $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").html("You have the TOB <span>" + info_title + "</span>" );
    $(".the-otaku-box-body.selected .otaku-box-plan-title").hide();
    $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-digital-title").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }); 
  $( ".digital-back" ).click(function() {
    $(".otaku-box-offer-footer-cancel-digital").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-price").addClass("otaku-box-selected-offer-info-price");
    $(".the-otaku-box-body.selected").find(".otaku-box-pre-purchase-offer-price").removeClass("otaku-box-selected-offer-info-price");
    $(".main-product-image").removeClass("remove-main-image");
    $(".main-digital-image").addClass("remove-digital-image");
    $(".main-digital-image").removeClass("show-image");
    $(".main-digital-image").removeAttr("style")
    $(".otaku-box-body-image-container").removeClass("digital-image-container");
    $(".otaku-box-selected-offer-info-header").removeClass("otaku-box-selected-offer-info-digital-header");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step").removeClass("active");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step .otaku-box-step-select-main-input").val("");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step .otaku-box-questions-select").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.pre-purchase-step").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.pre-purchase-step").addClass("active");
    $(".otaku-box-offer-btn").removeAttr("disabled");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
    let selected_currency = $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-info-price").text().slice(0,1);
    if ( selected_currency == "€") {
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").attr("data-price","0,00");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").html("€0,00");
    } else {
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").attr("data-price","0.00");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").html("$0.00");
    }
    let info_title = $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").attr("data-title");		
    $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").html(info_title);
    $(".the-otaku-box-body.selected .otaku-box-plan-title").show();
    $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-digital-title").hide(); 
    $(".otaku-box-offer-btn").html("Checkout");
    $(".retail-price-step").addClass("selected");
    $(".retail-price-section").addClass("show");
    $(".otaku-box-selected-offer-info-footer-price").addClass("show"); 
    $(".otaku-box-selected-offer-step.retail-price-step .otaku-box-questions-select").removeClass("show-retail-price"); 
    $(".otaku-box-offer-footer").addClass("hide-border"); 
  });
  $( "#cancel-digital" ).click(function() {
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
  }); 
  $( ".otaku-box-offer-pre-btn" ).click(function() {
    $("#the-otaku-box-monthly-offer").addClass("selected");
    $(".otaku-box-selected-offer-pre-step").remove();
  });
}); 
function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
if ( getUrlVars() !== undefined ) {
if ( $("#tripwire-url-1").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-1").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-1").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-2").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-2").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-2").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-3").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-3").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-3").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-4").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-4").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-4").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-5").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-5").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-5").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-6").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-6").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-6").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-7").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-7").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-7").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-8").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-8").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-8").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-9").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-9").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-9").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-10").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-10").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-10").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-tob_offer_03"] && !Shopify.designMode) return;
  try {
     
$( document ).ready(function() { 
  $( ".the-otaku-box-build-a-box .otaku-box-offer-btn" ).click(function() {
    if ( $(this).hasClass("otaku-box-offer-btn-initial") ) {
   	  $(".otaku-box-offer-boxes").remove();   
      $(".otaku-box-offer-info").remove();
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info").addClass("selected");
      $(this).removeClass("otaku-box-offer-btn-initial");
      $(this).addClass("otaku-box-offer-btn-next");
      $(this).attr("disabled","disabled");	
    } else if ( $(this).hasClass("otaku-box-offer-btn-edit") ) {
      $(".otaku-box-selected-offer-step.edit").removeClass("edit");
      $(this).removeClass("otaku-box-offer-btn-edit");
      if ( $(".otaku-box-selected-offer-step.active").find(".otaku-box-questions-select.selected").length == 0 ) {
	    $(this).attr("disabled","disabled");
      }
    } else if ( $(this).hasClass("otaku-box-offer-btn-final-disable") ) {
      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $( ".otaku-box-selected-offer-step" ).each(function() {
        if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();
        }
        if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
        }
        if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
        }
        if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
        }
        if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }	
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
        }
        if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }	
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
        }
        if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }	
		if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
        }
        if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }		
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
        }
        if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }	
      });
      let checkout_local_url = $("#local_url").val();
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout?step=contact_information";
	  jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });	
      window.location.href = checkout_url;
    } else if ( $(this).hasClass("otaku-box-offer-btn-next") ) {
      $(this).attr("disabled","disabled");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").addClass("selected");
 	  $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").next().addClass("active");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active.selected").removeClass("active");
    }
 });
}); 
$( document ).ready(function() {
  $( ".the-otaku-box-build-a-box .otaku-box-questions-select" ).click(function() {
	let current_step = 	$(this).closest(".otaku-box-selected-offer-step").attr("data-step");
    if ( $(this).hasClass("no-option") ) {
	  $(this).closest(".otaku-box-selected-offer-step").addClass("deny-offer");
      setTimeout(function(){  $('.step-image[data-step=' + current_step + ']').removeClass("show-image");  }, 500);
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
	  if ( $('.step-image-remove[data-step=' + current_step + ']').length > 0 ) {
        setTimeout(function(){  $('.step-image-remove[data-step=' + current_step + ']').removeClass("remove-image");  }, 500);
        $('.step-image-remove[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
	  }
    } else if ( $(this).hasClass("otaku-box-combination-product") ) {
	  let current_combination = 	$(this).attr("data-combination");
	  if ( $(this).hasClass("otaku-box-combination-product-limit") ) {
	    if ( $(this).hasClass("selected") ) {
		  $('.step-image[data-step_' + current_combination + '=' + current_step + ']').removeClass("show-image");
          $('.step-image[data-step_' + current_combination + '=' + current_step + ']').removeAttr( 'style' );
		} else {
		  $('.step-image[data-step_' + current_combination + '=' + current_step + ']').addClass("show-image");
          $('.step-image[data-step_' + current_combination + '=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
		}
	  } else {          
        $('.step-image-combination-' + current_step).removeClass("show-image");
        $('.step-image-combination-' + current_step ).removeAttr( 'style' );
        $('.step-image[data-step_' + current_combination + '=' + current_step + ']').addClass("show-image");
        $('.step-image[data-step_' + current_combination + '=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
      }
    } else {
	  $(this).closest(".otaku-box-selected-offer-step").removeClass("deny-offer");
	  $('.step-image[data-step=' + current_step + ']').addClass("show-image");
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
	  if ( $('.step-image-remove[data-step=' + current_step + ']').length > 0 ) {
        $('.step-image-remove[data-step=' + current_step + ']').addClass("remove-image");
        $('.step-image-remove[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
	  }
    }
    if ( $(this).hasClass("otaku-box-combination-product-limit") ) {	
	  var data_combination = $(this).attr("data-combination");
	  if ( $(this).hasClass("selected") ) {
	    $(this).removeClass("selected");
        $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(data_combination-1).val( "" );
        $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(data_combination-1).val( "" );
	  } else {
	    $(this).addClass("selected");
        $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(data_combination-1).val( $(this).find(".otaku-box-answer-select-input-id").val() );
        $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(data_combination-1).val( $(this).find(".otaku-box-answer-select-input-selling-plan").val() );
      }
	  var total_selected = $('.otaku-box-combination-product-limit.selected').length;
      var limit_selected = $(this).attr("data-combination-limit");
	  if ( total_selected == limit_selected ) {
	    $(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select:not(.selected)" ).addClass("disabled");
        $(".otaku-box-offer-btn").removeAttr("disabled");
        if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("otaku-box-selected-offer-step-final") ) {
          $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
        }
	  } else {
		$(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select:not(.selected)" ).removeClass("disabled");
        $(".otaku-box-offer-btn").attr("disabled", "disabled");
	  }     
	} else {
      $(".otaku-box-offer-btn").removeAttr("disabled");
      $(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select" ).removeClass("selected");
      $(this).addClass("selected");
      if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("otaku-box-selected-offer-step-final") ) {
        $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
      }
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).find(".otaku-box-answer-select-input-id").val() );
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).find(".otaku-box-answer-select-input-selling-plan").val() );
	}
    if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("tob-variant-final") ) {
      let combined_options = '';
      $( ".otaku-box-selected-offer-step" ).each(function() {
	    if ( ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != '' ) &&
		   ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != null ) ) {
          combined_options = combined_options + $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val();
        }
      });
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-id.variant-title-" + combined_options ).val() );
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-selling-plan.variant-title-" + combined_options).val() );
    }
 });
}); 
$( document ).ready(function() {
  $( ".the-otaku-box-build-a-box .otaku-box-selected-offer-step-change" ).click(function() {
    $(".otaku-box-selected-offer-step").removeClass("edit"); 
    $(this).closest(".otaku-box-selected-offer-step").addClass("edit");  
    $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-edit");
    $(".otaku-box-offer-btn").attr("disabled","disabled");
 });
});
$( document ).ready(function() {
  $( ".the-otaku-box-build-a-box .otaku-box-first-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-first-offer").addClass("selected");
 });
});
$( document ).ready(function() {
  $( ".the-otaku-box-build-a-box .otaku-box-second-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-second-offer").addClass("selected");
 });
});
$( document ).ready(function() {
  $( ".the-otaku-box-build-a-box .otaku-box-third-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-third-offer").addClass("selected");
 });
});
$( document ).ready(function() {
  $( ".the-otaku-box-build-a-box .otaku-box-fourth-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-fourth-offer").addClass("selected");
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-tob_offer_04"] && !Shopify.designMode) return;
  try {
    

// Create an object with the initial values
const cookieObj = {
  BW_Collection: false,
  Waifu_Collection: false,
  Ecchi_Digital: false,
  Ecchi_Physical: false,
  Jinko: false,
  Yukina: false
};

const cookieValue = document.cookie
  .split('; ')
  .find(row => row.startsWith('myCookie='))
  ?.split('=')[1];

$( document ).ready(function() { 
  $( ".the-otaku-box-pre-purchase .otaku-box-offer-btn" ).click(function() {
    if ( $(this).hasClass("otaku-box-offer-btn-initial") ) {
   	 
    } else if ( $(this).hasClass("otaku-box-offer-btn-edit") ) {
      $(".otaku-box-selected-offer-step.edit").removeClass("edit");
      $(this).removeClass("otaku-box-offer-btn-edit");
      if ( $(".otaku-box-selected-offer-step.active").find(".otaku-box-questions-select.selected").length == 0 ) {
	    $(this).attr("disabled","disabled");
      }
      let current_step_image = 	$(".otaku-box-selected-offer-step.active").attr("data-step");      
    

     
      window.scrollTo({ top: 0, behavior: 'smooth' });

    } else if ( $(this).hasClass("otaku-box-offer-btn-summary") ) {

      $("body").addClass("fixed");
      $(".otaku-box-offer-boxes").show();   
      $(".otaku-box-offer-info").show();
      
      $(this).removeClass("otaku-box-offer-btn-summary");
      $(this).addClass("otaku-box-offer-btn-final");
      $(".otaku-box-plan-description").show();
      $(".otaku-box-plan-title").removeClass("d-none");
      $(".otaku-box-selected-offer-info").hide();
      $(".otaku-box-body-image-container").addClass("summary-image");
    

      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected");    
      $("#the-otaku-box-monthly-offer").removeClass("the-otaku-box-body-upsell");        
      $(this).html('Checkout <i class="icon-e-15"></i>');
   

      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);

    } else if ( $(this).hasClass("otaku-box-offer-btn-final") ) {
      setTimeout(function(){  $(".the-otaku-box-spinner").show();  }, 500);
      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $( ".otaku-box-selected-offer-step" ).each(function() {
        if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();

          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() == "42521417318571" ) || ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() == "42521422364843" ) ) {
            cookieObj.Jinko = true;
          }

          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() == "42521422528683" ) || ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() == "42521423184043" ) ) {
            cookieObj.Yukina = true;
          }

          if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() == "42526707024043" ) {
            cookieObj.BW_Collection = true;
          }

          if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() == "42526693621931" ) {
            cookieObj.Waifu_Collection = true;
          }

          if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() == "41972642578603" ) {
            cookieObj.Ecchi_Digital = true;
          }

          if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() == "41225096396971" ) {
            cookieObj.Ecchi_Physical = true;
          }


  
          if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
          }
    	  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
            && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
            && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
    	  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
            && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
            && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
            && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
            && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }		
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
            && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
        }			
      });
      
      // Set the cookie with the object as a JSON string
      cookieExpiry = new Date(Date.now() + 86400e3).toUTCString(); // Set expiry to one day
      document.cookie = `myCookie=${JSON.stringify(cookieObj)}; expires=${cookieExpiry}`;

      let checkout_local_url = $("#local_url").val();
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout?step=contact_information";
	  jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });	
      window.location.href = checkout_url;
    } else if ( $(this).hasClass("otaku-box-offer-btn-next") ) {
      $(this).attr("disabled","disabled");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").addClass("selected");
 	  $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").next().addClass("active");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active.selected").removeClass("active");
      
      //let current_step_image = 	$(".otaku-box-selected-offer-step.active").attr("data-step");      
      //$('.step-image').removeClass("show-image");
      //$('.step-image[data-step=' + current_step_image + ']').addClass("show-image");
      //$('.step-image[data-step=' + current_step_image + ']').css({"animation":"image-animation-on 0.5s"});
      //$('.otaku-box-body-image-container .otaku-box-badge').removeClass('selected');
      //$('.otaku-box-body-image-container .otaku-box-badge').text('Add-on');
      
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
      
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
 });
});  
$( document ).ready(function() {
  $( ".the-otaku-box-pre-purchase .otaku-box-questions-select" ).click(function() {
	let current_step = 	$(this).closest(".otaku-box-selected-offer-step").attr("data-step");
    if ( $(this).hasClass("otaku-box-questions-select-pre-step") ) {
      let combination_step = $(this).attr("data-combination");
      $( ".free-pre-step .otaku-box-questions-combination .otaku-box-questions-select[data-combination=" + combination_step + "]" ).click();
      $(".otaku-box-offer-pre-btn").removeAttr("disabled");
    } else if ( $(this).hasClass("no-option") ) {
	  $(this).closest(".otaku-box-selected-offer-step").addClass("deny-offer");
      setTimeout(function(){  $('.step-image[data-step=' + current_step + ']').removeClass("show-image");  }, 500);
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".otaku-box-offer-btn").offset().top - $(window).height() + 80
    }, 500);

    if ( current_step == "4" ) {
      $(".otaku-box-offer-info-shipping.waify-collescion").hide();
    } 
    if ( current_step == "5" ) {
      $(".otaku-box-offer-info-shipping.bw-collection").hide();
    }  

    } else {
	  $(this).closest(".otaku-box-selected-offer-step").removeClass("deny-offer");
      $('.step-image[data-step=' + current_step + ']').addClass("show-image");
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".otaku-box-offer-btn").offset().top - $(window).height() + 80
      }, 500);

      if ( current_step == "4" ) {
        $(".otaku-box-offer-info-shipping.waify-collescion").show();
      } 
      if ( current_step == "5" ) {
        $(".otaku-box-offer-info-shipping.bw-collection").show();
      }  
      
    }
    
    if ( $(this).hasClass("otaku-box-questions-select-digital-step") ) {
      $(".otaku-box-offer-pre-btn").removeAttr("disabled");
      $(".otaku-box-selected-offer-step-pre-final").addClass("active");
    
      $(".digital_step .required_product.otaku-box-step-select-input-id").val( $(".digital_step .otaku-box-questions-select.yes-option .otaku-box-answer-select-input-id").val() );
      $(".physical_step .required_product.otaku-box-step-select-input-id").val( "" );
      $(".main-product-image-desktop.physical-image").removeClass("selected-image");
      $(".main-product-image-mobile.physical-image-mobile").removeClass("selected-image");
      $(".main-product-image-desktop.digital-image").addClass("selected-image");
      $(".main-product-image-mobile.digital-image-mobile").addClass("selected-image");
      $(".otaku-box-offer-info-right-digital").removeClass("d-none");
      $(".otaku-box-offer-info-right-physical").addClass("d-none");

      $(".main-product-image-summary-digital").addClass("selected-image");
      $(".main-product-image-summary-physical").removeClass("selected-image");

      if ( $(".otaku-box-questions-select-physical-step").attr("data-calculated-price") == "true" ) {
       let current_price = parseFloat( $(".otaku-box-selected-offer-info-price").attr("data-price") );
       let selected_price = parseFloat( $(".physical_step .otaku-box-questions-select-inner").attr("data-price") ); 
       let selected_currency = $(".otaku-box-selected-offer-info-price").text().slice(0,1);  
       let new_price = current_price - selected_price;
       $(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
       $(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toFixed(2).toString());
       $(".otaku-box-questions-select-physical-step").attr("data-calculated-price", false); 
      }

    
    } else if ( $(this).hasClass("otaku-box-questions-select-physical-step") ) {
      $(".otaku-box-offer-pre-btn").removeAttr("disabled");
      $(".otaku-box-selected-offer-step-pre-final").addClass("active");
      $(".digital_step .required_product.otaku-box-step-select-input-id").val( $(".digital_step .otaku-box-questions-select.yes-option .otaku-box-answer-select-input-id").val() );
      $(".physical_step .required_product.otaku-box-step-select-input-id").val( $(".physical_step .otaku-box-questions-select.yes-option .otaku-box-answer-select-input-id").val() );


      let current_price = parseFloat( $(".otaku-box-selected-offer-info-price").attr("data-price") );
       let selected_price = parseFloat( $(".physical_step .otaku-box-questions-select-inner").attr("data-price") ); 
       let selected_currency = $(".otaku-box-selected-offer-info-price").text().slice(0,1);  
       let new_price = current_price + selected_price;
       $(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
       $(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toFixed(2).toString());
        $(this).attr("data-calculated-price", "true");
      

      
      $(".main-product-image-desktop.digital-image").removeClass("selected-image");
      $(".main-product-image-mobile.digital-image-mobile").removeClass("selected-image");
      $(".main-product-image-desktop.physical-image").addClass("selected-image");
      $(".main-product-image-mobile.physical-image-mobile").addClass("selected-image");

      $(".main-product-image-summary-digital").removeClass("selected-image");
      $(".main-product-image-summary-physical").addClass("selected-image");
    

      $(".otaku-box-offer-info-right-digital").addClass("d-none");
      $(".otaku-box-offer-info-right-physical").removeClass("d-none");
    
    } else if ( $(this).hasClass("otaku-box-questions-select-pre-step") == false ) {
      let current_price = parseFloat( $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-info-price").attr("data-price") );
      let save_price = parseFloat( $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-save-price").attr("data-save-price") );
console.log(save_price);
      let selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price") ); 
console.log("1 " + selected_price);      
      let selected_save_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-save-price") ); 
console.log("2 " + selected_save_price);

      let selected_currency = $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( $(this).hasClass("otaku-box-combination-product-multiple") ) {
  	    if ( $(this).hasClass("selected") ) {
  		  let new_price = current_price - selected_price;
          $(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
          $(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toFixed(2).toString());	
          
          let new_save_price = save_price - selected_save_price;
          $(".otaku-box-selected-offer-save-price").attr("data-save-price",new_save_price);
          $(".otaku-box-selected-offer-save-price").text("-" + selected_currency + new_save_price.toFixed(2).toString());
console.log(new_save_price);          
  	    } else {
  		  let new_price = current_price + selected_price;
          $(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
          $(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toFixed(2).toString());	

          let new_save_price = save_price + selected_save_price;
          $(".otaku-box-selected-offer-save-price").attr("data-save-price",new_save_price);
          $(".otaku-box-selected-offer-save-price").text("-" + selected_currency + new_save_price.toFixed(2).toString());
console.log(new_save_price);           
  	    }
  	  } else if ( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected").length != 0 ) {
        let step_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-price"));
  	    let new_price = current_price - step_price + selected_price;
        $(".otaku-box-selected-offer-info-price").attr("data-price",new_price.toFixed(2));
        $(".otaku-box-selected-offer-info-price").text(selected_currency + new_price.toFixed(2).toString());

        let step_save_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-save-price"));
  	    let new_save_price = save_price - step_save_price + selected_save_price;
        $(".otaku-box-selected-offer-save-price").attr("data-save-price",new_save_price);
        $(".otaku-box-selected-offer-save-price").text("-" + selected_currency + new_save_price.toFixed(2).toString());
   console.log(new_save_price);       


      } else {     
        let new_price = current_price + selected_price;
        let new_save_price = save_price + selected_save_price;
console.log(new_save_price);
        $(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
        $(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toFixed(2).toString());

        $(".otaku-box-selected-offer-save-price").attr("data-save-price",new_save_price);
        $(".otaku-box-selected-offer-save-price").text("-" + selected_currency + new_save_price.toFixed(2).toString());

      }
    }

	if ( $(this).hasClass("otaku-box-combination-product-multiple") ) {
	  var data_combination = $(this).attr("data-combination");
	  if ( $(this).hasClass("selected") ) {
	    $(this).removeClass("selected");
        $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(data_combination-1).val( "" );
        $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(data_combination-1).val( "" );
	  } else {
		$(this).addClass("selected");
        $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(data_combination-1).val( $(this).find(".otaku-box-answer-select-input-id").val() );
        $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(data_combination-1).val( $(this).find(".otaku-box-answer-select-input-selling-plan").val() );
   	  }
 	  $(".otaku-box-offer-btn").removeAttr("disabled");
      if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("otaku-box-selected-offer-step-final") ) {
        $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
      }
      $(this).closest(".otaku-box-selected-offer-step").removeClass("deny-offer");
	} else {
	  $(".otaku-box-offer-btn").removeAttr("disabled");
      $(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select" ).removeClass("selected");
      $(this).addClass("selected");
      if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("otaku-box-selected-offer-step-final") ) {
        $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
      }
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).find(".otaku-box-answer-select-input-id").val() );
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).find(".otaku-box-answer-select-input-selling-plan").val() );
	}	
    
    if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("tob-variant-final") ) {
      let combined_options = '';
      $( ".otaku-box-selected-offer-step" ).each(function() {
	    if ( ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != '' ) &&
		   ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != null ) ) {
          combined_options = combined_options + $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val();
        }
      });
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-id.variant-title-" + combined_options ).val() );
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-selling-plan.variant-title-" + combined_options).val() );
    }
    
  

    if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("otaku-box-selected-offer-step-summary") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-summary");
    }

    
 });
}); 
$( document ).ready(function() {
  $( ".the-otaku-box-pre-purchase .otaku-box-selected-offer-step-change" ).click(function() {
    $(".otaku-box-selected-offer-step").removeClass("edit"); 
    $(this).closest(".otaku-box-selected-offer-step").addClass("edit");  
    $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-edit");
    $(".otaku-box-offer-btn").attr("disabled","disabled");

    //let current_step_image = 	$(".otaku-box-selected-offer-step.edit").attr("data-step");      
    //$('.step-image').removeClass("show-image");
    //$('.step-image[data-step=' + current_step_image + ']').addClass("show-image");
    //$('.step-image[data-step=' + current_step_image + ']').css({"animation":"image-animation-on 0.5s"});

    //if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("deny-offer") ) {
      //$('.otaku-box-body-image-container .otaku-box-badge').removeClass('selected');
      //$('.otaku-box-body-image-container .otaku-box-badge').text('Add-on');
    //} else {
      //$('.otaku-box-body-image-container .otaku-box-badge').addClass('selected');
      //$('.otaku-box-body-image-container .otaku-box-badge').text('Added');
    //}

  

 });
});
$( document ).ready(function() {
  $( ".the-otaku-box-pre-purchase .otaku-box-monthly-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-monthly-offer").addClass("selected");
 });
});
$( document ).ready(function() {
  $( ".the-otaku-box-pre-purchase .otaku-box-three-months-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-three-months-offer").addClass("selected");
 });
});
$( document ).ready(function() {
  $( ".the-otaku-box-pre-purchase .otaku-box-six-months-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-six-months-offer").addClass("selected");
 });
});
$( document ).ready(function() {
  $( ".the-otaku-box-pre-purchase .otaku-box-annual-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-annual-offer").addClass("selected");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-offer-pre-btn" ).click(function() {
    if ( $(this).hasClass("otaku-box-offer-pre-btn-lv2") ) {
      $("body").addClass("fixed");
      
      $(this).addClass("otaku-box-offer-pre-btn-physical-digital");
      $(this).removeClass("otaku-box-offer-pre-btn-lv2");
      $(".otaku-box-selected-offer-free-figure-step").hide();
      $(".otaku-box-offer-footer-lv-2").hide();
      $(".otaku-box-selected-offer-digital-physical-step").show();

      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);

      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(".otaku-box-ssl-step").show();
    } else if ( $(this).hasClass("otaku-box-offer-pre-btn-physical-digital") ) {
      $("body").addClass("fixed");
            
      
      $(".otaku-box-offer-boxes").hide();   
      $(".otaku-box-offer-info").hide();
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info").addClass("selected");
     
     
      $(".otaku-box-plan-description").hide();
    
      $(".otaku-box-plan-title").addClass("d-none");


      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected");    
      $("#the-otaku-box-monthly-offer").addClass("the-otaku-box-body-upsell");        
      
      $(".otaku-box-selected-offer-info").show();
      $(".otaku-box-offer-btn").attr("disabled","disabled");

      
      $("#the-otaku-box-monthly-offer").addClass("selected");

      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);

      $(".otaku-box-selected-offer-pre-step").hide();
      $(this).removeClass("otaku-box-offer-pre-btn-physical-digital");
    } else {
      $("body").addClass("fixed");
      
      $("body").addClass("ecchitoons-flow");
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-free-figure-step .otaku-box-selected-offer-step-title").text("Don’t let her get away!");
      $(".otaku-box-questions-select-pre-step.selected").hide();
      $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").hide();
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(this).addClass("otaku-box-offer-pre-btn-lv2");
      $(".otaku-box-offer-footer-lv-2").show();
      $(".otaku-box-body-image-container-back.step-back").addClass("show");
      $(".otaku-box-selected-offer-free-figure-step").addClass("otaku-box-selected-offer-free-figure-step-lv2");

      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);


      
    }
  });
  $(".otaku-box-offer-footer-lv-2-btn").click(function() {
    $(".otaku-box-offer-pre-btn-lv2").removeAttr("disabled");
    $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
    $(this).addClass("selected");
  });
  $(".otaku-box-offer-footer-lv-2-btn-yes").click(function() {
    let combination_step = $(this).closest(".otaku-box-selected-offer-pre-step").find(".otaku-box-selected-offer-free-figure-step .otaku-box-questions-select-pre-step:not(.selected)").attr("data-combination");
    $( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select[data-combination=" + combination_step + "]" ).click();

    if ( $(this).closest(".otaku-box-selected-offer-pre-step").find(".otaku-box-questions-select-pre-step").attr("data-combination") == "1" ) {
      $(".jinko-acrylic .otaku-box-offer-info-right").text("$14");
    } else {
      $(".yukina-acrylic .otaku-box-offer-info-right").text("$14");
    }

    $(this).attr("data-calculated-price", true); 

  });
  $(".otaku-box-offer-footer-lv-2-btn-no").click(function() {
    $(".otaku-box-selected-offer-info-price").text("$" + $(".otaku-box-selected-offer-info-price").attr("data-origianl-price") );
     $(".otaku-box-selected-offer-info-price").attr("data-price", $(".otaku-box-selected-offer-info-price").attr("data-origianl-price") );
    $( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select").removeClass("selected");
    $( ".additional-pre-step .otaku-box-step-select-input-id").val("");

    if ( $(this).closest(".otaku-box-selected-offer-pre-step").find(".otaku-box-questions-select-pre-step").attr("data-combination") == "1" ) {
      $(".jinko-acrylic").hide();
    } else {
      $(".yukina-acrylic").hide();
    }
    $(".otaku-box-offer-info-total-price").hide();
    $(".otaku-box-offer-footer-lv-2-btn-yes").attr("data-calculated-price", false); 
    
  });

});

$( document ).ready(function() {
  $( ".step-back" ).click(function() {
    if ( $(this).closest(".otaku-box-selected-offer-step-info").hasClass("otaku-box-selected-offer-free-figure-step") ) {
      $("body").addClass("fixed");
      $("body").removeClass("ecchitoons-flow");
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-free-figure-step .otaku-box-selected-offer-step-title").text("Choose your FREE bonus figure!");
      $(".otaku-box-questions-select-pre-step.selected").show();
      $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").show();
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(".otaku-box-offer-pre-btn").removeClass("otaku-box-offer-pre-btn-lv2");
      $(".otaku-box-offer-footer-lv-2").hide();
      $(".otaku-box-body-image-container-back.step-back").removeClass("show");
      $(".otaku-box-questions-select-pre-step").removeClass("selected");
      $(".otaku-box-selected-offer-step.free-pre-step .required_product.otaku-box-step-select-input-id").val("");
      $(".otaku-box-selected-offer-free-figure-step").removeClass("otaku-box-selected-offer-free-figure-step-lv2");
      $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);
    }
    if ( $(this).closest(".otaku-box-selected-offer-step-info").hasClass("otaku-box-selected-offer-digital-physical-step") ) {
       $("body").addClass("fixed");
      $(".otaku-box-offer-pre-btn").removeClass("otaku-box-offer-pre-btn-physical-digital");
      $(".otaku-box-offer-pre-btn").addClass("otaku-box-offer-pre-btn-lv2");
      $(".otaku-box-selected-offer-free-figure-step").show();
      $(".otaku-box-offer-footer-lv-2").show();
      $(".otaku-box-selected-offer-digital-physical-step").hide();
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
      $(".otaku-box-questions-select-digital-step").removeClass("selected");
      $(".otaku-box-questions-select-physical-step").removeClass("selected");
      $(".jinko-acrylic").show();
      $(".yukina-acrylic").show();
      $(".otaku-box-offer-info-total-price").show();
      $(".jinko-acrylic .otaku-box-offer-info-right").text("Free");
      $(".yukina-acrylic .otaku-box-offer-info-right").text("Free");
      $( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select").removeClass("selected");
      $( ".additional-pre-step .otaku-box-step-select-input-id").val("");
      $(".otaku-box-ssl-step").hide();


      if ( $(".otaku-box-offer-footer-lv-2-btn-yes").attr("data-calculated-price") == "true" ) {
       let current_price = parseFloat( $(".otaku-box-selected-offer-info-price").attr("data-price") );
       let selected_price = parseFloat( $(".additional-pre-step .otaku-box-questions-select-inner").attr("data-price") ); 
       let selected_currency = $(".otaku-box-selected-offer-info-price").text().slice(0,1);  
       let new_price = current_price - selected_price;
       $(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
       $(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toFixed(2).toString());
       $(".otaku-box-offer-footer-lv-2-btn-yes").attr("data-calculated-price", false); 
      }

      
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);
    }
    if ( $(this).closest(".the-otaku-box-body").hasClass("the-otaku-box-body-upsell") ) {
      $("body").addClass("fixed");
      $("#the-otaku-box-monthly-offer").removeClass("selected");
      $(".otaku-box-selected-offer-pre-step").show();
      $(".otaku-box-offer-pre-btn").addClass("otaku-box-offer-pre-btn-physical-digital");
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(".otaku-box-selected-offer-step-pre-final").removeClass("active");
      $(".digital_step .required_product.otaku-box-step-select-input-id").val( "" );
      $(".physical_step .required_product.otaku-box-step-select-input-id").val( "" );
      $(".otaku-box-questions-select-digital-step").removeClass("selected");
      $(".otaku-box-questions-select-physical-step").removeClass("selected");
      if ( $(".otaku-box-questions-select-physical-step").attr("data-calculated-price") == "true" ) {
       let current_price = parseFloat( $(".otaku-box-selected-offer-info-price").attr("data-price") );
       let selected_price = parseFloat( $(".physical_step .otaku-box-questions-select-inner").attr("data-price") ); 
       let selected_currency = $(".otaku-box-selected-offer-info-price").text().slice(0,1);  
       let new_price = current_price - selected_price;
       $(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
       $(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toFixed(2).toString());
       $(".otaku-box-questions-select-physical-step").attr("data-calculated-price", false); 
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);
    } else if ( $(this).closest(".the-otaku-box-body").hasClass("selected") ) {
      $("body").addClass("fixed");
      $(".otaku-box-offer-boxes").hide();   
      $(".otaku-box-offer-info").hide();
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-summary");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(".otaku-box-plan-description").hide();
      $(".otaku-box-plan-title").addClass("d-none");
      $(".otaku-box-selected-offer-info").show();
      $(".otaku-box-offer-btn").html('Next <i class="icon-e-15"></i>');
      $(".the-otaku-box-body").addClass("the-otaku-box-body-upsell");
      $(".otaku-box-body-image-container").removeClass("summary-image");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);
    }
 });
 let number = document.querySelector(".otaku-box-badge-countdown .badge").textContent;
 let stringNr = [...number].reduce((result, digit) =>  result+=`<span>${digit}</span>`, ""); 
 $(".otaku-box-badge-countdown .badge").html(stringNr);
});


(function(factory) {
        	if (typeof define === 'function' && define.amd) {
            	// AMD (Register as an anonymous module)
            	define(['jquery'], factory);
        	} else if (typeof exports === 'object') {
            	// Node/CommonJS
            	module.exports = factory(require('jquery'));
        	} else {
            	// Browser globals
            	factory(jQuery);
        	}
    	}(function($) {

        	var pluses = /\+/g;

        	function encode(s) {
            	return config.raw ? s : encodeURIComponent(s);
        	}

        	function decode(s) {
            	return config.raw ? s : decodeURIComponent(s);
        	}

        	function stringifyCookieValue(value) {
            	return encode(config.json ? JSON.stringify(value) : String(value));
        	}

        	function parseCookieValue(s) {
            	if (s.indexOf('"') === 0) {
                	// This is a quoted cookie as according to RFC2068, unescape...
                	s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
            	}

            	try {
                	// Replace server-side written pluses with spaces.
                	// If we can't decode the cookie, ignore it, it's unusable.
                	// If we can't parse the cookie, ignore it, it's unusable.
                	s = decodeURIComponent(s.replace(pluses, ' '));
                	return config.json ? JSON.parse(s) : s;
            	} catch (e) {}
        	}

        	function read(s, converter) {
            	var value = config.raw ? s : parseCookieValue(s);
            	return $.isFunction(converter) ? converter(value) : value;
        	}

        	var config = $.cookie = function(key, value, options) {

            	// Write

            	if (arguments.length > 1 && !$.isFunction(value)) {
                	options = $.extend({}, config.defaults, options);

                	if (typeof options.expires === 'number') {
                    	var days = options.expires,
                        	t = options.expires = new Date();
                    	t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
                	}

                	return (document.cookie = [
                    	encode(key), '=', stringifyCookieValue(value),
                    	options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                    	options.path ? '; path=' + options.path : '',
                    	options.domain ? '; domain=' + options.domain : '',
                    	options.secure ? '; secure' : ''
                	].join(''));
            	}

            	// Read

            	var result = key ? undefined : {},
                	// To prevent the for loop in the first place assign an empty array
                	// in case there are no cookies at all. Also prevents odd result when
                	// calling $.cookie().
                	cookies = document.cookie ? document.cookie.split('; ') : [],
                	i = 0,
                	l = cookies.length;

            	for (; i < l; i++) {
                	var parts = cookies[i].split('='),
                    	name = decode(parts.shift()),
                    	cookie = parts.join('=');

                	if (key === name) {
                    	// If second argument (value) is a function it's a converter...
                    	result = read(cookie, value);
                    	break;
                	}

                	// Prevent storing a cookie that we couldn't decode.
                	if (!key && (cookie = read(cookie)) !== undefined) {
                    	result[name] = cookie;
                	}
            	}

            	return result;
        	};

        	config.defaults = {};

        	$.removeCookie = function(key, options) {
            	// Must not alter options, thus extending a fresh object...
            	$.cookie(key, '', $.extend({}, options, {
                	expires: -1
            	}));
            	return !$.cookie(key);
        	};

    	}));



(function() {
        	var deadline = new Date();
        	deadline.setMinutes(deadline.getMinutes() + 5);
        	var date = $.cookie('date');
        	if (date == undefined) {

            	$.cookie('year', deadline.getFullYear());
            	$.cookie('month', deadline.getMonth());
            	$.cookie('date', deadline.getDate());
            	$.cookie('hours', deadline.getHours());
            	$.cookie('minutes', deadline.getMinutes());
            	$.cookie('seconds', deadline.getSeconds());
        	}

        	if (date == undefined) {} else {
            	deadline.setFullYear($.cookie('year'));
            	deadline.setMonth($.cookie('month'));
            	deadline.setDate($.cookie('date'));
            	deadline.setHours($.cookie('hours'));
            	deadline.setMinutes($.cookie('minutes'));
            	deadline.setSeconds($.cookie('seconds'));

        	}

        	var currentTime = new Date();
        	var timeDifference = deadline.getTime() - currentTime.getTime();
        	if (timeDifference <= 0) {

            	deadline = new Date();
            	deadline.setMinutes(deadline.getMinutes() + 5);
            	$.cookie('year', deadline.getFullYear());
            	$.cookie('date', deadline.getDate());
            	$.cookie('hours', deadline.getHours());
            	$.cookie('minutes', deadline.getMinutes());
            	$.cookie('seconds', deadline.getSeconds());
            	$.cookie('month', deadline.getMonth());
        	}

        	function pad(num, size) {
            	var s = "0" + num;
            	return s.substr(s.length - size);
        	}

        	function getTimeRemaining(endtime) {
            	var t = Date.parse(endtime) - Date.parse(new Date()),
                	seconds = Math.floor((t / 1000) % 60),
                	minutes = Math.floor((t / 1000 / 60) % 60),
                	hours = Math.floor((t / (1000 * 60 * 60)) % 24),
                	days = Math.floor(t / (1000 * 60 * 60 * 24));

            	return {
                	'total': t,
                	'days': days,
                	'hours': hours,
                	'minutes': minutes,
                	'seconds': seconds
            	};
        	}
        	var $js_clock = $('.js-clock-x');
        	function clock(id, endtime) {
           	 
            	var days = document.getElementById(id + '-days'),
            	hours = document.getElementById(id + '-hours'),
                	minutes = document.getElementById(id + '-minutes'),
                	seconds = document.getElementById(id + '-seconds');

            	var days_2 = document.getElementById(id + '-days'),
            	hours_2 = document.getElementById(id + '-hours'),
                	minutes_2 = document.getElementById(id + '-minutes'),
                	seconds_2 = document.getElementById(id + '-seconds');

            	var timeinterval = setInterval(function() {
                	var t = getTimeRemaining(endtime);

                	if (t.total <= 0) {
                    	clearInterval(timeinterval);
                    	/*===========================================================*/
                    	deadline = new Date();
                    	deadline.setMinutes(deadline.getMinutes() + 5);
                    	$.cookie('year', deadline.getFullYear());
                    	$.cookie('date', deadline.getDate());
                    	$.cookie('hours', deadline.getHours());
                    	$.cookie('minutes', deadline.getMinutes());
                    	$.cookie('seconds', deadline.getSeconds());
                    	$.cookie('month', deadline.getMonth());
                    	clock('js-clock-x', deadline);
                    	/*===========================================================*/
                    	/*clearInterval(timeinterval);
                    	deadline = new Date();
                    	deadline.setMinutes(deadline.getMinutes() + 5);
                    	clock('js-clock', deadline);*/

                	} else {
                 	 
                  	$.each($js_clock, function(index){
                   	 
                  	});
                  	$.each($js_clock, function(index){
                    	$(this).find('#' + id + '-days').html(pad(t.days, 2));
                    	$(this).find('#' + id + '-hours').html(pad(t.hours, 2));
                    	$(this).find('#' + id + '-minutes').html(pad(t.minutes, 2));
                    	$(this).find('#' + id + '-seconds').html(pad(t.seconds, 2));                   	 
                  	});
                   	 
                	}
            	}, 1000);
        	}
        	clock('js-clock-x', deadline);
  
  			var $js_clock_top = $('.js-clock-top');
        	function clock_top(id, endtime) {
           	 
            	var days = document.getElementById(id + '-days'),
            	hours = document.getElementById(id + '-hours'),
                	minutes = document.getElementById(id + '-minutes'),
                	seconds = document.getElementById(id + '-seconds');

            	var days_2 = document.getElementById(id + '-days'),
            	hours_2 = document.getElementById(id + '-hours'),
                	minutes_2 = document.getElementById(id + '-minutes'),
                	seconds_2 = document.getElementById(id + '-seconds');

            	var timeinterval = setInterval(function() {
                	var t = getTimeRemaining(endtime);

                	if (t.total <= 0) {
                    	clearInterval(timeinterval);
                    	/*===========================================================*/
                    	deadline = new Date();
                    	deadline.setMinutes(deadline.getMinutes() + 5);
                    	$.cookie('year', deadline.getFullYear());
                    	$.cookie('date', deadline.getDate());
                    	$.cookie('hours', deadline.getHours());
                    	$.cookie('minutes', deadline.getMinutes());
                    	$.cookie('seconds', deadline.getSeconds());
                    	$.cookie('month', deadline.getMonth());
                    	clock('js-clock-x', deadline);
                    	/*===========================================================*/
                    	/*clearInterval(timeinterval);
                    	deadline = new Date();
                    	deadline.setMinutes(deadline.getMinutes() + 5);
                    	clock('js-clock', deadline);*/

                	} else {
                 	 
                  	$.each($js_clock_top, function(index){
                   	 
                  	});
                  	$.each($js_clock_top, function(index){
                    	$(this).find('#' + id + '-days').html(pad(t.days, 2));
                    	$(this).find('#' + id + '-hours').html(pad(t.hours, 2));
                    	$(this).find('#' + id + '-minutes').html(pad(t.minutes, 2));
                    	$(this).find('#' + id + '-seconds').html(pad(t.seconds, 2));                   	 
                  	});
                   	 
                	}
            	}, 1000);
        	}
        	clock_top('js-clock-top', deadline);
  
            var $js_clock_hero_01 = $('.js-clock-hero_01');
        	function clock_hero_01(id, endtime) {
           	 
            	var days = document.getElementById(id + '-days'),
            	hours = document.getElementById(id + '-hours'),
                	minutes = document.getElementById(id + '-minutes'),
                	seconds = document.getElementById(id + '-seconds');

            	var days_2 = document.getElementById(id + '-days'),
            	hours_2 = document.getElementById(id + '-hours'),
                	minutes_2 = document.getElementById(id + '-minutes'),
                	seconds_2 = document.getElementById(id + '-seconds');

            	var timeinterval = setInterval(function() {
                	var t = getTimeRemaining(endtime);

                	if (t.total <= 0) {
                    	clearInterval(timeinterval);
                    	/*===========================================================*/
                    	deadline = new Date();
                    	deadline.setMinutes(deadline.getMinutes() + 5);
                    	$.cookie('year', deadline.getFullYear());
                    	$.cookie('date', deadline.getDate());
                    	$.cookie('hours', deadline.getHours());
                    	$.cookie('minutes', deadline.getMinutes());
                    	$.cookie('seconds', deadline.getSeconds());
                    	$.cookie('month', deadline.getMonth());
                    	clock('js_clock_hero_01', deadline);
                    	/*===========================================================*/
                    	/*clearInterval(timeinterval);
                    	deadline = new Date();
                    	deadline.setMinutes(deadline.getMinutes() + 5);
                    	clock('js-clock', deadline);*/

                	} else {
                 	 
                  	$.each($js_clock_hero_01, function(index){
                   	 
                  	});
                  	$.each($js_clock_hero_01, function(index){
                    	$(this).find('#' + id + '-days').html(pad(t.days, 2));
                    	$(this).find('#' + id + '-hours').html(pad(t.hours, 2));
                    	$(this).find('#' + id + '-minutes').html(pad(t.minutes, 2));
                    	$(this).find('#' + id + '-seconds').html(pad(t.seconds, 2));                   	 
                  	});
                   	 
                	}
            	}, 1000);
        	}
        	clock_hero_01('js-clock-hero_01', deadline);
  
  			var $js_clock_hero_02 = $('.js-clock-hero_02');
        	function clock_hero_02(id, endtime) {
           	 
            	var days = document.getElementById(id + '-days'),
            	hours = document.getElementById(id + '-hours'),
                	minutes = document.getElementById(id + '-minutes'),
                	seconds = document.getElementById(id + '-seconds');

            	var days_2 = document.getElementById(id + '-days'),
            	hours_2 = document.getElementById(id + '-hours'),
                	minutes_2 = document.getElementById(id + '-minutes'),
                	seconds_2 = document.getElementById(id + '-seconds');

            	var timeinterval = setInterval(function() {
                	var t = getTimeRemaining(endtime);

                	if (t.total <= 0) {
                    	clearInterval(timeinterval);
                    	/*===========================================================*/
                    	deadline = new Date();
                    	deadline.setMinutes(deadline.getMinutes() + 5);
                    	$.cookie('year', deadline.getFullYear());
                    	$.cookie('date', deadline.getDate());
                    	$.cookie('hours', deadline.getHours());
                    	$.cookie('minutes', deadline.getMinutes());
                    	$.cookie('seconds', deadline.getSeconds());
                    	$.cookie('month', deadline.getMonth());
                    	clock('js_clock_hero_02', deadline);
                    	/*===========================================================*/
                    	/*clearInterval(timeinterval);
                    	deadline = new Date();
                    	deadline.setMinutes(deadline.getMinutes() + 5);
                    	clock('js-clock', deadline);*/

                	} else {
                 	 
                  	$.each($js_clock_hero_02, function(index){
                   	 
                  	});
                  	$.each($js_clock_hero_02, function(index){
                    	$(this).find('#' + id + '-days').html(pad(t.days, 2));
                    	$(this).find('#' + id + '-hours').html(pad(t.hours, 2));
                    	$(this).find('#' + id + '-minutes').html(pad(t.minutes, 2));
                    	$(this).find('#' + id + '-seconds').html(pad(t.seconds, 2));                   	 
                  	});
                   	 
                	}
            	}, 1000);
        	}
        
			
    	})();
 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-tob_offer_05"] && !Shopify.designMode) return;
  try {
    

let cookiePostUpsell = false;

if ( getUrlVars() !== undefined ) {
  if ( getUrlVars()["figure"] ==  "rias" || getUrlVars()["figure"] ==  "rem" || getUrlVars()["figure"] ==  "rias-rem"  ) {

  } else {
    $(".otaku-box-selected-offer-pre-step").show();
  }
} else {
  $(".otaku-box-selected-offer-pre-step").show();
}
  
$( document ).ready(function() { 
  $( ".otaku-box-offer-btn" ).click(function() {
    if ( $(this).hasClass("otaku-box-offer-btn-initial") ) {
   	  $(".otaku-box-offer-boxes").hide();   
      $(".otaku-box-offer-info").hide();
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info").addClass("selected");
      $(this).removeClass("otaku-box-offer-btn-initial");
      $(this).addClass("otaku-box-offer-btn-next");
      if ( $(this).closest(".the-otaku-box-body-v2").find(".post-purchase-step").hasClass("selected") ) {
        $(this).addClass("otaku-box-offer-btn-post-purchase");
      } else {
        $(this).attr("disabled","disabled");	
        $(this).closest(".the-otaku-box-body-v2").find(".start-post-purchase").removeClass("selected");
      }      
      $(".otaku-box-body-image-container-back").removeClass("box-selection");
      $(".otaku-box-body-image-container-back").addClass("box-selected");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
      window.scrollTo({ top: 0, behavior: 'smooth' });
     
      $(".otaku-box-plan-title-1").hide();
      $(".otaku-box-plan-title-2").show();


      if ( ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) && ( $(this).closest(".the-otaku-box-container").find(".scale-figure-step").hasClass("active") ) ) {
        $(this).closest(".the-otaku-box-container").find(".scale-figure-step .otaku-box-questions-select:not(.no-option)").click();
      }
      
    } else if ( $(this).hasClass("otaku-box-offer-btn-show-retail-price") ) {
      $(this).removeClass("otaku-box-offer-btn-show-retail-price");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select.show-retail-price").removeClass("show-retail-price");
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
        if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Kasse");
         } else {
           $(".otaku-box-offer-btn").html("Vérifier");
         }
      } else {
        $(this).html("Checkout");
      }
      $(".retail-price-step").addClass("selected");
      $(".retail-price-section").addClass("show");
      $(".otaku-box-selected-offer-info-footer-price").addClass("show");
      $(".otaku-box-offer-footer").addClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").hide();
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 

 
      
    } else if ( $(this).hasClass("otaku-box-offer-btn-edit") ) {
      $(".otaku-box-selected-offer-step.edit").removeClass("edit");
      $(this).removeClass("otaku-box-offer-btn-edit");
      
    } else if ( $(this).hasClass("otaku-box-offer-btn-post-purchase") ) {
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase"); 
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").hide();
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").hide();
      $(".the-otaku-box-body.selected .otaku-box-plan-title").hide();
      $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-header-text").hide();
      $(".main-product-image").addClass("remove-main-image");
      $(".main-digital-image").removeClass("remove-digital-image");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-body-image-container").addClass("post_purchase_step_image");
      $(".otaku-box-body-image-container-back").removeClass("box-selected");
      $(".otaku-box-body-image-container-back").addClass("box-checkout");
      // $(".otaku-box-body-offer-container").addClass("post_purchase_step_offer");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
	  $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
      $(".post_purchase_step").addClass("active");
      $(".end-post-purchase").removeClass("selected");

      if ( $(this).closest(".the-otaku-box-container").find(".post_purchase_step.post_purchase_step_next").length > 0 ) {
        $(this).addClass("otaku-box-offer-btn-post-purchase-start");
      } 
 	 
      window.scrollTo({ top: 0, behavior: 'smooth' });

      if ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") )  {    
       $(this).closest(".the-otaku-box-container").find(".otaku-box-selected-offer-step-final .end-post-purchase:not(.no-option)").click();
      }

      
    } else if ( $(this).hasClass("otaku-box-offer-btn-pre-purchase") ) {
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
        if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Weiter");
         } else {
           $(".otaku-box-offer-btn").html("Suivant");
         }
      } else {
        $(this).html("Next");
      }
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-edit"); 
	  $(this).closest(".the-otaku-box-body").find(".btn-start-pre-purchase").click();
      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $( ".otaku-box-selected-offer-step" ).each(function() {
        if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();
        }
        if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }		
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		}
      });
      let checkout_local_url = $("#local_url").val();
      let checkout_digtial_all_url = ''; 
      $( ".the-otaku-box-body.selected .digital-step" ).each(function() {
        checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-answer-select-main-input-id" ).val() + "%26items[][quantity]=1%26";
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
          checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
          checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() + "%26items[][quantity]=1%26";
        }
      });
      checkout_digtial_all_url = checkout_url + checkout_digtial_all_url + "return_to=" + checkout_local_url + "checkout";
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout";
      jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });
      $("#digital-all").attr("href", checkout_digtial_all_url); 
      $(".otaku-box-offer-footer-cancel-digital").attr("href", checkout_url);   
    } else if ( $(this).hasClass("otaku-box-offer-btn-final") ) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $(".the-otaku-box-spinner").show(); $("body").addClass("fixed"); }, 100);
      $(this).attr("style","pointer-events:none;");
      $(".otaku-box-selected-offer-info-header-digital").addClass("finished-test");
      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $(this).closest(".the-otaku-box-body.selected").find( ".otaku-box-selected-offer-step" ).each(function() {
       if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();         
        }
        if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }		
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	

          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(8).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(8).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(8).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(8).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(8).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(8).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(8).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(8).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(8).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(8).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	

          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(9).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(9).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(9).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(9).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(9).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(9).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(9).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(9).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(9).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(9).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	


          
		}
      });

      cookieExpiry = new Date(Date.now() + 86400e3).toUTCString(); // Set expiry to one day
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=.theotakubox.com;path=/;expires=${cookieExpiry};SameSite=None; Secure`;
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=theotakubox.com;expires=${cookieExpiry};SameSite=None; Secure`;

      console.log("test123 " + cookiePostUpsell);
      
      let checkout_local_url = $("#local_url").val();
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout";
	  jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });	

   
      
       window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);
      setTimeout(function(){  window.location.href = checkout_url; }, 500);
    } else if ( $(this).hasClass("otaku-box-offer-btn-next") ) {         
      $(this).attr("disabled","disabled");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").addClass("selected");
 	  $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").next().addClass("active");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active.selected").removeClass("active");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
      if ( $(this).hasClass("otaku-box-offer-btn-post-purchase-start") ) {
        if ( $(this).closest(".the-otaku-box-container").find(".main-digital-image-2").hasClass("hide-digital") ) {
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-1").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-3").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-2").removeClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").addClass("post_purchase_step_image_2");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").removeClass("post_purchase_step_image_3");
          $(this).closest(".the-otaku-box-container").find(".box-checkout").addClass("box-checkout-2");
        } else {
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-1").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-2").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-3").removeClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").removeClass("post_purchase_step_image_2");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").addClass("post_purchase_step_image_3");
          $(this).closest(".the-otaku-box-container").find(".box-checkout").removeClass("box-checkout-2");
          $(this).closest(".the-otaku-box-container").find(".box-checkout").addClass("box-checkout-3");
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }   


       if ( ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step").hasClass("selected") ) && ( $(this).closest(".the-otaku-box-container").find(".ecchi-step").hasClass("selected") == false ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step .otaku-box-questions-select-variations.selected").length > 0 ) ) {    
        $(this).closest(".the-otaku-box-container").find(".ecchi-step .otaku-box-questions-select.yes-option").click();
       }

      if ( ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step").hasClass("selected") ) && ( $(this).closest(".the-otaku-box-container").find(".ecchi-step").hasClass("selected") == false ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step .otaku-box-questions-select.selected").length > 0 ) ) {    
        $(this).closest(".the-otaku-box-container").find(".ecchi-step .otaku-box-questions-select.yes-option").click();
       }
      
    }
 });
});  
$( document ).ready(function() {
  $( ".otaku-box-questions-select" ).click(function() {
    let current_step = 	$(this).closest(".otaku-box-selected-offer-step").attr("data-step");
    if ( $(this).hasClass("show-neither") ) {
      $(".otaku-box-selected-offer-step[data-step='3']").addClass("active");
      $(".otaku-box-offer-pre-btn").removeAttr("disabled");
      $(".otaku-box-offer-pre-btn").addClass("otaku-box-offer-pre-btn-lv2");
      $(".otaku-box-offer-pre-btn.otaku-box-offer-pre-btn-lv2").click();
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(".otaku-box-offer-pre-btn").removeClass("otaku-box-offer-pre-btn-lv2");
    } else if ( $(this).hasClass("otaku-box-questions-select-pre-step") ) {
      let combination_step = $(this).attr("data-combination");
      $( ".the-otaku-box-container" ).each(function() {
        $( this ).find( ".free-pre-step .otaku-box-questions-combination .otaku-box-questions-select[data-combination=" + combination_step + "]" ).click();
      });
      $(".otaku-box-selected-offer-step[data-step='3']").addClass("active");
      $(".otaku-box-offer-pre-btn").removeAttr("disabled");
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".otaku-box-offer-pre-btn").offset().top - $(window).height() + 180
       }, 500); 
    } else if ( $(this).hasClass("no-option") ) {
	  $(this).closest(".otaku-box-selected-offer-step").addClass("deny-offer");
      setTimeout(function(){  $('.step-image[data-step=' + current_step + ']').removeClass("show-image");  }, 500);
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
	  if ( $('.step-image-remove[data-step=' + current_step + ']').length > 0 ) {
        setTimeout(function(){  $('.step-image-remove[data-step=' + current_step + ']').removeClass("remove-image");  }, 500);
        $('.step-image-remove[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
	  }
      if ( $(this).hasClass("end-post-purchase") ) {
        $('.otaku-box-step-select-input-id.ecchitoons-teaser').val("41606325829803");
      }  
      if ( $(this).hasClass("end-post-purchase-ecchitoons") ) {
        cookiePostUpsell = false;
      }  
    } else if ( $(this).hasClass("otaku-box-combination-product") ) {
	  let current_combination = 	$(this).attr("data-combination");
      $('.step-image-combination.step-image-combination-' + current_step).removeClass("show-image");
      $('.step-image-combination.step-image-combination-' + current_step).removeAttr( 'style' );
      $('.step-image[data-step_' + current_combination + '=' + current_step + ']').addClass("show-image");
	  $('.step-image[data-step_' + current_combination + '=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
    } else {
	  $(this).closest(".otaku-box-selected-offer-step").removeClass("deny-offer");
	  $('.step-image[data-step=' + current_step + ']').addClass("show-image");
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
	  if ( $('.step-image-remove[data-step=' + current_step + ']').length > 0 ) {
        $('.step-image-remove[data-step=' + current_step + ']').addClass("remove-image");
        $('.step-image-remove[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
	   }
      if ( $(this).hasClass("end-post-purchase") ) {
        $('.otaku-box-step-select-input-id.ecchitoons-teaser').val("");
      }  
      if ( $(this).hasClass("end-post-purchase-ecchitoons") ) {
        cookiePostUpsell = true;
      }  
      if ( $(this).hasClass("end-post-purchase-waifu") ) {
        cookiePostUpsell = "waifu";
      }  
    }
    
    if ( $(this).hasClass("otaku-box-questions-select-variations") ) {
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      let selected_var_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price") ); 
       if ( selected_currency == "€") {
        selected_var_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
       }
      if ( $(this).hasClass("otaku-box-questions-select-variations-quarterly") ) {
        selected_var_price = selected_var_price / 3;
        selected_var_price = selected_var_price.toFixed(2);
      }
      if ( selected_var_price == 0 ) {
        selected_var_price = "0.00";
         if ( selected_currency == "€") {
          selected_var_price = "0,00";
         }
      }
      if ( selected_currency == "€") {
        $(this).closest(".otaku-box-selected-offer-step-info").find(".otaku-box-selected-offer-step-price span").text("€" + selected_var_price.toString().replace(/\./g, ',') );
      } else {
        $(this).closest(".otaku-box-selected-offer-step-info").find(".otaku-box-selected-offer-step-price span").text("$" + selected_var_price.toString());
      }
    }

    if ( ( $(window).scrollTop() + $(window).height() != $(document).height() ) && ( $(".the-otaku-box-body.selected .otaku-box-offer-btn").length > 0 ) ) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".the-otaku-box-body.selected .otaku-box-offer-btn").offset().top - $(window).height() + 180
       }, 500); 
    }

    
    if ( $(this).hasClass("otaku-box-questions-select-pre-step") ) {
      $(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select" ).removeClass("selected");
      $(this).addClass("selected");
   } else {
    let current_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price") );
    let selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price") ); 
    let current_rrp_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price") );
    let selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price") ); 
    let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
    if ( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected").length != 0 ) {
	  let step_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-price"));
      let new_price = current_price - step_price + selected_price;
      new_price = new_price.toFixed(2);
      let step_rrp_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-rrp-price"));
      let new_rrp_price = current_rrp_price - step_rrp_price + selected_rrp_price;
      new_rrp_price = new_rrp_price.toFixed(2);
      if ( selected_currency == "€") {
       current_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price").replace(/\,/g, '.') );
       selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
	   step_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') );
	   new_price = current_price - step_price + selected_price;
	   new_price = new_price.toFixed(2).toString().replace(/\./g, ',');
       if ( (".retail-price-title span").lenght > 0 ) { 
         current_rrp_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price").replace(/\,/g, '.') );
         selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') ); 
  	     step_rrp_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') );
  	     new_rrp_price = current_rrp_price - step_rrp_price + selected_rrp_price;
  	     new_rrp_price = new_rrp_price.toFixed(2).toString().replace(/\./g, ',');
       }  
	  } 
      if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false && $(this).hasClass("end-post-purchase-ecchitoons") == false && $(this).closest(".otaku-box-selected-offer-step").hasClass("additional-pre-step") == false ) {
        $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
        $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text(selected_currency + new_price.toString());
        $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
        $(this).closest(".the-otaku-box-body").find(".retail-price-title span").text( selected_currency + new_rrp_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      }
    } else {     
      let new_price = current_price + selected_price;
      new_price = new_price.toFixed(2);
      let new_rrp_price = current_rrp_price + selected_rrp_price;
      new_rrp_price = new_rrp_price.toFixed(2);
      if ( selected_currency == "€") {
		current_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price").replace(/\,/g, '.') );
        selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
	    new_price = current_price + selected_price;
        new_price = new_price.toFixed(2).toString().replace(/\./g, ',');
        if ( (".retail-price-title span").lenght > 0 ) {
          current_rrp_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price").replace(/\,/g, '.') );
          selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') ); 
  	      new_rrp_price = current_rrp_price + selected_rrp_price;
          new_rrp_price = new_rrp_price.toFixed(2).toString().replace(/\./g, ',');
        }  


         if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false && $(this).hasClass("end-post-purchase-ecchitoons") == false && $(this).closest(".otaku-box-selected-offer-step").hasClass("additional-pre-step") == false ) {
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toString());
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").text( selected_currency + new_rrp_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        }
        
	  } else {
        if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false && $(this).hasClass("end-post-purchase-ecchitoons") == false && $(this).closest(".otaku-box-selected-offer-step").hasClass("additional-pre-step") == false ) {
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toString());
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").text( selected_currency + new_rrp_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        }
      }
    }
    $(".otaku-box-offer-btn").removeAttr("disabled");
	$(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select" ).removeClass("selected");
    $(this).addClass("selected");
	if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("otaku-box-selected-offer-step-final") ) {
	  $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    }
	if ( $(this).hasClass("start-pre-purchase") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-pre-purchase");
    }
    if ( $(this).hasClass("start-post-purchase") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-post-purchase");
      if ( $(this).hasClass("yes-option") ) {
        $(this).closest(".otaku-box-selected-offer-step").find( ".otaku-box-selected-offer-step-title-selected" ).text("Uncensored");
      } else {
        $(this).closest(".otaku-box-selected-offer-step").find( ".otaku-box-selected-offer-step-title-selected" ).text("Censored");
      }
    }
    if ( $(this).hasClass("show-retail-price") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-show-retail-price");
    }
    $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).find(".otaku-box-answer-select-input-id").val() );
    $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).find(".otaku-box-answer-select-input-selling-plan").val() );
    if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("tob-variant-final") ) {
      let combined_options = '';
      $( ".the-otaku-box-body.selected .otaku-box-selected-offer-step" ).each(function() {
	    if ( ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != '' ) &&
		     ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != null ) ) {
          combined_options = combined_options + $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val();
        }
      });
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-id.variant-title-" + combined_options ).val() );
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-selling-plan.variant-title-" + combined_options).val() );
    }
    
    }
 });
}); 
$( document ).ready(function() {
  $( ".otaku-box-selected-offer-step-change" ).click(function() {
    $(".otaku-box-selected-offer-step").removeClass("edit"); 
    $(this).closest(".otaku-box-selected-offer-step").addClass("edit");  
    $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-edit");
    $(".otaku-box-offer-btn").attr("disabled","disabled");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-monthly-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-monthly-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-monthly-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-three-months-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-three-months-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-three-months-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-six-months-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-six-months-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-six-months-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-annual-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-annual-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-annual-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-monthly-offer-box" ).click(function() {
   $(".the-otaku-box-body").removeClass("pre-select-no");
 });
});  
$( document ).ready(function() {
  $( "#digital-no" ).click(function() {
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-edit");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn-final").click();
    $('#pre-purchase').css('pointer-events','none');
    $("#pre-purchase .modal-dialog").hide();
  });
  $( "#digital-yes" ).click(function() {
    $(".otaku-box-offer-footer-cancel-digital").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
    $("#pre-purchase .close").click();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-price").removeClass("otaku-box-selected-offer-info-price");
    $(".the-otaku-box-body.selected").find(".otaku-box-pre-purchase-offer-price").addClass("otaku-box-selected-offer-info-price");
    $(".main-product-image").addClass("remove-main-image");
    $(".main-digital-image").removeClass("remove-digital-image");
    $(".otaku-box-body-image-container").addClass("digital-image-container");
    $(".otaku-box-selected-offer-info-header").addClass("otaku-box-selected-offer-info-digital-header");
    let info_title = $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").attr("data-title");	
    $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").html("You have the TOB <span>" + info_title + "</span>" );
    $(".the-otaku-box-body.selected .otaku-box-plan-title").hide();
    $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-digital-title").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }); 
  $( ".digital-back" ).click(function() {
    $(".otaku-box-offer-footer-cancel-digital").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-price").addClass("otaku-box-selected-offer-info-price");
    $(".the-otaku-box-body.selected").find(".otaku-box-pre-purchase-offer-price").removeClass("otaku-box-selected-offer-info-price");
    $(".main-product-image").removeClass("remove-main-image");
    $(".main-digital-image").addClass("remove-digital-image");
    $(".main-digital-image").removeClass("show-image");
    $(".main-digital-image").removeAttr("style")
    $(".otaku-box-body-image-container").removeClass("digital-image-container");
    $(".otaku-box-selected-offer-info-header").removeClass("otaku-box-selected-offer-info-digital-header");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step").removeClass("active");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step .otaku-box-step-select-main-input").val("");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step .otaku-box-questions-select").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.pre-purchase-step").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.pre-purchase-step").addClass("active");
    $(".otaku-box-offer-btn").removeAttr("disabled");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
    let selected_currency = $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-info-price").text().slice(0,1);
    if ( selected_currency == "€") {
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").attr("data-price","0,00");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").html("€0,00");
    } else {
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").attr("data-price","0.00");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").html("$0.00");
    }
    let info_title = $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").attr("data-title");		
    $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").html(info_title);
    $(".the-otaku-box-body.selected .otaku-box-plan-title").show();
    $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-digital-title").hide(); 
    if ( selected_currency == "€") {
      if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Kasse");
         } else {
           $(".otaku-box-offer-btn").html("Vérifier");
         }
    } else {
      $(".otaku-box-offer-btn").html("Checkout");
    }
    
    $(".otaku-box-offer-btn").html("Checkout");
    $(".retail-price-step").addClass("selected");
    $(".retail-price-section").addClass("show");
    $(".otaku-box-selected-offer-info-footer-price").addClass("show"); 
    $(".otaku-box-selected-offer-step.retail-price-step .otaku-box-questions-select").removeClass("show-retail-price"); 
    $(".otaku-box-offer-footer").addClass("hide-border"); 
  });
  $( "#cancel-digital" ).click(function() {
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
  }); 
}); 


// EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE  

$( document ).ready(function() {
  $( ".otaku-box-offer-pre-btn" ).click(function() {
    if ( $(".single-offer-body").length > 0 ) {

      if ( $(this).hasClass("otaku-box-offer-pre-btn-lv3") ) {
        $(".single-offer-body").addClass("selected");
        $(".otaku-box-selected-offer-pre-step").hide();
        $("body").removeClass("black-friday-offer");
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else if ( $(this).hasClass("otaku-box-offer-pre-btn-lv2") ) {
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).removeClass("otaku-box-offer-pre-btn-lv2");
          $(this).addClass("otaku-box-offer-pre-btn-lv3");
          $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v2");
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v3");
          $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
          $(".otaku-box-offer-footer-lv-2-btn").addClass("otaku-box-offer-footer-lv-3-btn");
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step == 1 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          }
          if ( selected_step == 2 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='1']").hide();
          }
          if ( selected_step ==  3) {
            $(".otaku-box-questions-select-pre-step[data-combination='2']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='1']").hide();
          }
          $(".step-back-initial").addClass("step-back-initial-2");

          window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-title").text( $(".additional-pre-step .otaku-box-selected-offer-step-title").first().text().trim() );
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-subtitle").text( $(".additional-pre-step .otaku-box-selected-offer-step-subtitle").first().text().replace(/\s+/g, ' ').trim() );
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).addClass("otaku-box-offer-pre-btn-lv2");
          $(".otaku-box-questions-select-pre-step.selected").hide();
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step == 1 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          }
          if ( selected_step == 2 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          }
          if ( selected_step ==  3) {
            $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          }
          $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").hide();
          $(".otaku-box-offer-footer-lv-2").show();
          $(".step-back-initial").show();
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v2");
          $(".show-neither").hide();

          window.scrollTo({ top: 0, behavior: 'smooth' });

      }  
      
    } else {
      if ( $(this).hasClass("otaku-box-offer-pre-btn-lv3") ) {
        $("#the-otaku-box-six-months-offer").addClass("selected");
        $(".otaku-box-selected-offer-pre-step").hide();
        $("body").removeClass("black-friday-offer");
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else if ( $(this).hasClass("otaku-box-offer-pre-btn-lv2") ) {
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).removeClass("otaku-box-offer-pre-btn-lv2");
          $(this).addClass("otaku-box-offer-pre-btn-lv3");
          $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v2");
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v3");
          $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
          $(".otaku-box-offer-footer-lv-2-btn").addClass("otaku-box-offer-footer-lv-3-btn");
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step == 1 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          }
          if ( selected_step == 2 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='1']").hide();
          }
          if ( selected_step ==  3) {
            $(".otaku-box-questions-select-pre-step[data-combination='2']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='1']").hide();
          }
          $(".step-back-initial").addClass("step-back-initial-2");
          window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-title").text( $(".additional-pre-step .otaku-box-selected-offer-step-title").first().text().trim() );
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-subtitle").text( $(".additional-pre-step .otaku-box-selected-offer-step-subtitle").first().text().replace(/\s+/g, ' ').trim() );
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).addClass("otaku-box-offer-pre-btn-lv2");
          $(".otaku-box-questions-select-pre-step.selected").hide();
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step == 1 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          }
          if ( selected_step == 2 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          }
          if ( selected_step ==  3) {
            $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          }
          $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").hide();
          $(".otaku-box-offer-footer-lv-2").show();
          $(".step-back-initial").show();
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v2");
          $(".show-neither").hide();

          // Only difference
          if ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) {
            $(".otaku-box-selected-offer-pre-step-v2 .otaku-box-offer-footer-lv-2-btn-yes").click();
          }

        window.scrollTo({ top: 0, behavior: 'smooth' });

      }  
      
    }

    $(".free-offer-note").hide();

  });
  $(".otaku-box-offer-footer-lv-2-btn").click(function() {
    if ( $(this).hasClass("otaku-box-offer-footer-lv-3-btn") ) {
      $(".otaku-box-offer-pre-btn-lv3").removeAttr("disabled");
    } else {
      $(".otaku-box-offer-pre-btn-lv2").removeAttr("disabled");
    }
    $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
    $(this).addClass("selected");
  });
  $(".otaku-box-offer-footer-lv-2-btn-yes").click(function() {
    let combination_step = $(this).closest(".otaku-box-selected-offer-pre-step").find(".otaku-box-questions-select-pre-step:not(.selected)").attr("data-combination");
    if ( $(this).hasClass("otaku-box-offer-footer-lv-3-btn") ) {
      let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
      let combination_step = 3;
      if ( selected_step == 3 ) {
        combination_step = 2;
      }
      let combination_product_id = $(".additional-pre-step .otaku-box-combination-product[data-combination=" + combination_step + "] .otaku-box-answer-select-input-id").val();
      $('.step-image[data-step_' + combination_step + '=2]').addClass("show-image");
	  $('.step-image[data-step_' + combination_step + '=2]').css({"animation":"image-animation-on 0.5s"});
      $( ".the-otaku-box-container" ).each(function() {
        if ( ( $(this).find(".additional-pre-step .all-two").val() != '' ) && ( $(this).find(".additional-pre-step .all-two").val() != combination_product_id ) ) {
          $( this ).find( ".additional-pre-step .all-three").val(combination_product_id);
        } else {
          $( this ).find( ".additional-pre-step .all-two").val(combination_product_id);
        }
      });
    } else {
      $( ".the-otaku-box-container" ).each(function() {
        $( this ).find( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select[data-combination=" + combination_step + "]" ).click();
      });
    }
  });
  $(".otaku-box-offer-footer-lv-2-btn-no").click(function() {
    if ( $(this).hasClass("otaku-box-offer-footer-lv-3-btn") ) {
      if ( $(".additional-pre-step .all-three").val() != '' ) {
        $( ".additional-pre-step .all-three").val("");
      } else {
        let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
        let combination_step = 3;
        if ( selected_step == 3 ) {
          combination_step = 2;
        } 
        let combination_product_id = $(".additional-pre-step .otaku-box-combination-product[data-combination=" + combination_step + "] .otaku-box-answer-select-input-id").val();
        if ( ( $(".additional-pre-step .all-two").val() != '' ) && ( $(".additional-pre-step .all-two").val() == combination_product_id ) ) {  
          $( ".additional-pre-step .all-two").val("");
        }
      }
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step ==  3) {
            $(".step-image-combination.step-image[data-step_2='2']").removeClass("show-image");
            $(".step-image-combination.step-image[data-step_2='2']").removeAttr( 'style' );
          } else {
            $(".step-image-combination.step-image[data-step_3='2']").removeClass("show-image");
          $(".step-image-combination.step-image[data-step_3='2']").removeAttr( 'style' );
          }
    } else {
      $( ".additional-pre-step .otaku-box-step-select-input-id").val("");
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step ==  1) {
            $(".step-image-combination.step-image[data-step_2='2']").removeClass("show-image");
            $(".step-image-combination.step-image[data-step_2='2']").removeAttr( 'style' );
          } else {
            $(".step-image-combination.step-image[data-step_1='2']").removeClass("show-image");
            $(".step-image-combination.step-image[data-step_1='2']").removeAttr( 'style' );
          }
    }
    $( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select").removeClass("selected");
  });
  $(".step-back-initial").click(function() {
    if ( $(this).hasClass("step-back-initial-2") ) {
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
        $(".otaku-box-offer-pre-btn").addClass("otaku-box-offer-pre-btn-lv2");
        $(".otaku-box-offer-pre-btn").removeClass("otaku-box-offer-pre-btn-lv3");
        $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v2");
        $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v3");
        $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
        $(".otaku-box-offer-footer-lv-2-btn").removeClass("otaku-box-offer-footer-lv-3-btn");
        let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
        if ( selected_step == 1 ) {
          $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          $(".otaku-box-questions-select-pre-step[data-combination='2']").show();
        }
        if ( selected_step == 2 ) {
          $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          $(".otaku-box-questions-select-pre-step[data-combination='1']").show();
        }
        if ( selected_step ==  3) {
          $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          $(".otaku-box-questions-select-pre-step[data-combination='1']").show();
        }
        $(".step-back-initial").removeClass("step-back-initial-2");
    } else {
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-title").text( $(".free-pre-step .otaku-box-selected-offer-step-title").first().text().trim() );
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-subtitle").text( $(".free-pre-step .otaku-box-selected-offer-step-subtitle").first().text().trim() );
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $( ".otaku-box-offer-pre-btn" ).removeClass("otaku-box-offer-pre-btn-lv2");
      $(".otaku-box-questions-select-pre-step").show();
      $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").show();
      $(".otaku-box-offer-footer-lv-2").hide();
      $(".step-back-initial").hide();
      $( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select").removeClass("selected");
      $( ".additional-pre-step .otaku-box-step-select-input-id").val("");
      $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v2");
      $(".otaku-box-offer-footer-lv-2 .otaku-box-offer-footer-lv-2-btn").removeClass("selected");
      $(".otaku-box-selected-offer-pre-step .otaku-box-questions-select-pre-step").removeClass("selected"); 
      $(".show-neither").show(); 
      $("body").addClass("black-friday-offer");
      $(".free-offer-note").show();
    }
  });
}); 


// EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE
  
$( document ).ready(function() {
  $( ".step-back" ).click(function() {
    if ( $(this).hasClass("box-selection") ) {
      $(".the-otaku-box-body").removeClass("selected");
      $("body").addClass("black-friday-offer");
      $(".otaku-box-selected-offer-pre-step").show();
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( $(this).hasClass("box-selected") ) {
      $(".otaku-box-offer-boxes").show();   
      $(".otaku-box-offer-info").show();
      $(".otaku-box-selected-offer-info").removeClass("selected");
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-initial");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-show-retail-price");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase");
      $(".otaku-box-offer-btn").removeAttr("disabled");	
      $(".otaku-box-body-image-container-back").addClass("box-selection");
      $(".otaku-box-body-image-container-back").removeClass("box-selected");
      $(".otaku-box-plan-title-1").show();
      $(".otaku-box-plan-title-2").hide();
      
      //$(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select").addClass("show-retail-price");
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
         if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Weiter");
         } else {
           $(".otaku-box-offer-btn").html("Suivant");
         }
      } else {
         $(".otaku-box-offer-btn").html("Next");
      }
      $(".retail-price-step").removeClass("selected");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").show();
   
      
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( $(this).hasClass("box-checkout-2") ) {
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next_2").removeClass("active");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step-final").removeClass("active");
      
      
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next").removeClass("selected");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next").addClass("active");
      
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-1").removeClass("hide-digital");
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-2").addClass("hide-digital");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").removeClass("post_purchase_step_image_2");

      
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").attr("disabled","true");

      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step .otaku-box-questions-select.selected").removeClass("selected");
      
      $(this).removeClass("box-checkout-2");
    } else if ( $(this).hasClass("box-checkout-3") ) {
      
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step-final").removeClass("active");
      
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next_2").removeClass("selected");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next_2").addClass("active");
      
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-2").removeClass("hide-digital");
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-3").addClass("hide-digital");

      $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").addClass("post_purchase_step_image_2");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").removeClass("post_purchase_step_image_3");

      
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").attr("disabled","true");

      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step .otaku-box-questions-select.selected").removeClass("selected");
      
      $(this).removeClass("box-checkout-3");
      $(this).addClass("box-checkout-2"); 
    } else if ( $(this).hasClass("box-checkout") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-post-purchase"); 
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
      $(".otaku-box-selected-offer-step.selected").show();
      $(".otaku-box-selected-offer-step.active").show();
      $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-plan-title-2").show();
      $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-plan-title-1").hide();
      $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-header-text").show();
      $(".main-product-image").removeClass("remove-main-image");
      $(".main-digital-image").addClass("remove-digital-image");
  
    
      $(".otaku-box-body-image-container").removeClass("post_purchase_step_image");
      $(".otaku-box-body-image-container-back").addClass("box-selected");
      $(".otaku-box-body-image-container-back").removeClass("box-checkout");
      $(".post_purchase_step").removeClass("active");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
      //$(".otaku-box-offer-btn").attr("disabled","disabled");
      $(".otaku-box-offer-btn").removeAttr("disabled");	
      $(".otaku-box-plan-title.otaku-box-digital-title").hide();

      
      if ( $(this).closest(".the-otaku-box-body").hasClass("retail-price-body") ) {
        $(this).closest(".the-otaku-box-body").find(".retail-price-step").addClass("active");
        $(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select").addClass("show-retail-price");
        $(".retail-price-step").removeClass("selected");
        $(".retail-price-section").removeClass("show");
      }

      
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
         if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Weiter");
         } else {
           $(".otaku-box-offer-btn").html("Suivant");
         }
      } else {
         $(".otaku-box-offer-btn").html("Next");
      }
     
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").show(); 


      if ( $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").hasClass("otaku-box-offer-btn-post-purchase-start") ) {
        $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase-start");
        $(this).closest(".the-otaku-box-body").find(".main-digital-image-1").removeClass("hide-digital");
        $(this).closest(".the-otaku-box-body").find(".main-digital-image-2").addClass("hide-digital");
        $(this).closest(".the-otaku-box-body").find(".main-digital-image-3").addClass("hide-digital");
        $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").removeClass("post_purchase_step_image_2");
      }

      //$(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step .otaku-box-questions-select.selected").removeClass("selected");
      
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
});   
function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
if ( getUrlVars() !== undefined ) {
if ( $("#tripwire-url-1").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-1").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-1").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-2").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-2").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-2").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-3").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-3").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-3").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-4").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-4").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-4").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-5").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-5").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-5").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-6").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-6").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-6").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-7").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-7").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-7").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-8").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-8").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-8").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-9").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-9").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-9").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-10").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-10").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-10").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
}

$( document ).ready(function() {
  if ( getUrlVars() !== undefined ) {
    if ( ( getUrlVars()["figure"] ==  "rias" ) || ( getUrlVars()["figure"] ==  "first" ) ) {
      $(".otaku-box-selected-offer-pre-step:not(.otaku-box-selected-offer-pre-step-v2) .otaku-box-questions-select[data-combination='1']").click();
      $(".otaku-box-offer-pre-btn").click();
      $(".otaku-box-selected-offer-pre-step").show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( ( getUrlVars()["figure"] ==  "leafa" ) || ( getUrlVars()["figure"] ==  "rem" ) || ( getUrlVars()["figure"] ==  "albedo" ) || ( getUrlVars()["figure"] ==  "second" ) ) {
      $(".otaku-box-selected-offer-pre-step:not(.otaku-box-selected-offer-pre-step-v2) .otaku-box-questions-select[data-combination='2']").click();
      $(".otaku-box-offer-pre-btn").click();
      $(".otaku-box-selected-offer-pre-step").show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( ( getUrlVars()["figure"] ==  "rias-maid" ) || ( getUrlVars()["figure"] ==  "third" ) ) {
      $(".otaku-box-selected-offer-pre-step:not(.otaku-box-selected-offer-pre-step-v2) .otaku-box-questions-select[data-combination='3']").click();
      $(".otaku-box-offer-pre-btn").click();
      $(".otaku-box-selected-offer-pre-step").show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}); 

$(document).ready(function() {
  function generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const urgencyNote = $('.urgency-note');
  if (urgencyNote.length > 0) {
    const randomNumber = generateRandomNumber(25, 50);
    urgencyNote.find('span').text(randomNumber);
  }
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-tob_offer_06"] && !Shopify.designMode) return;
  try {
    

let cookiePostUpsell = false;

if ( getUrlVars() !== undefined ) {
  if ( getUrlVars()["figure"] ==  "rias" || getUrlVars()["figure"] ==  "rem" ) {

  } else {
    $(".otaku-box-selected-offer-pre-step").show();
  }
} else {
  $(".otaku-box-selected-offer-pre-step").show();
}
  
$( document ).ready(function() { 
  $( ".otaku-box-offer-btn" ).click(function() {
    if ( $(this).hasClass("otaku-box-offer-btn-initial") ) {
   	  $(".otaku-box-offer-boxes").hide();   
      $(".otaku-box-offer-info").hide();
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info").addClass("selected");
      $(this).removeClass("otaku-box-offer-btn-initial");
      $(this).addClass("otaku-box-offer-btn-next");
      $(this).attr("disabled","disabled");	
      $(".otaku-box-body-image-container-back").removeClass("box-selection");
      $(".otaku-box-body-image-container-back").addClass("box-selected");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
      window.scrollTo({ top: 0, behavior: 'smooth' });
     
      $(".otaku-box-plan-title-1").hide();
      $(".otaku-box-plan-title-2").show();


      if ( ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) && ( $(this).closest(".the-otaku-box-container").find(".scale-figure-step").hasClass("active") ) ) {
        $(this).closest(".the-otaku-box-container").find(".scale-figure-step .otaku-box-questions-select:not(.no-option)").click();
      }
      
    } else if ( $(this).hasClass("otaku-box-offer-btn-show-retail-price") ) {
      $(this).removeClass("otaku-box-offer-btn-show-retail-price");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select.show-retail-price").removeClass("show-retail-price");
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
        if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Kasse");
         } else {
           $(".otaku-box-offer-btn").html("Vérifier");
         }
      } else {
        $(this).html("Checkout");
      }
      $(".retail-price-step").addClass("selected");
      $(".retail-price-section").addClass("show");
      $(".otaku-box-selected-offer-info-footer-price").addClass("show");
      $(".otaku-box-offer-footer").addClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").hide();
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 

 
      
    } else if ( $(this).hasClass("otaku-box-offer-btn-edit") ) {
      $(".otaku-box-selected-offer-step.edit").removeClass("edit");
      $(this).removeClass("otaku-box-offer-btn-edit");
      
    } else if ( $(this).hasClass("otaku-box-offer-btn-post-purchase") ) {
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase"); 
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").hide();
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").hide();
      $(".the-otaku-box-body.selected .otaku-box-plan-title").hide();
      $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-header-text").hide();
      $(".main-product-image").addClass("remove-main-image");
      $(".main-digital-image").removeClass("remove-digital-image");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-body-image-container").addClass("post_purchase_step_image");
      $(".otaku-box-body-image-container-back").removeClass("box-selected");
      $(".otaku-box-body-image-container-back").addClass("box-checkout");
      // $(".otaku-box-body-offer-container").addClass("post_purchase_step_offer");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
	  $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
      $(".post_purchase_step").addClass("active");

      if ( $(this).closest(".the-otaku-box-container").find(".post_purchase_step.post_purchase_step_next").length > 0 ) {
        $(this).addClass("otaku-box-offer-btn-post-purchase-start");
      } 
 	 
      window.scrollTo({ top: 0, behavior: 'smooth' });

      if ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") )  {    
       $(this).closest(".the-otaku-box-container").find(".otaku-box-selected-offer-step-final .end-post-purchase:not(.no-option)").click();
      }

      
    } else if ( $(this).hasClass("otaku-box-offer-btn-pre-purchase") ) {
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
        if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Weiter");
         } else {
           $(".otaku-box-offer-btn").html("Suivant");
         }
      } else {
        $(this).html("Next");
      }
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-edit"); 
	  $(this).closest(".the-otaku-box-body").find(".btn-start-pre-purchase").click();
      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $( ".otaku-box-selected-offer-step" ).each(function() {
        if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();
        }
        if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }		
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		}
      });
      let checkout_local_url = $("#local_url").val();
      let checkout_digtial_all_url = ''; 
      $( ".the-otaku-box-body.selected .digital-step" ).each(function() {
        checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-answer-select-main-input-id" ).val() + "%26items[][quantity]=1%26";
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
          checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
          checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() + "%26items[][quantity]=1%26";
        }
      });
      checkout_digtial_all_url = checkout_url + checkout_digtial_all_url + "return_to=" + checkout_local_url + "checkout";
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout";
      jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });
      $("#digital-all").attr("href", checkout_digtial_all_url); 
      $(".otaku-box-offer-footer-cancel-digital").attr("href", checkout_url);   
    } else if ( $(this).hasClass("otaku-box-offer-btn-final") ) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $(".the-otaku-box-spinner").show(); $("body").addClass("fixed"); }, 100);
      $(this).attr("style","pointer-events:none;");
      $(".otaku-box-selected-offer-info-header-digital").addClass("finished-test");
      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $(this).closest(".the-otaku-box-body.selected").find( ".otaku-box-selected-offer-step" ).each(function() {
       if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();         
        }
        if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }		
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		}
      });

      cookieExpiry = new Date(Date.now() + 86400e3).toUTCString(); // Set expiry to one day
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=.theotakubox.com;path=/;expires=${cookieExpiry};SameSite=None; Secure`;
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=theotakubox.com;expires=${cookieExpiry};SameSite=None; Secure`;

      let checkout_local_url = $("#local_url").val();
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout";
	  jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });	

   
      
       window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);
      setTimeout(function(){  window.location.href = checkout_url; }, 500);
    } else if ( $(this).hasClass("otaku-box-offer-btn-next") ) {         
      $(this).attr("disabled","disabled");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").addClass("selected");
 	  $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").next().addClass("active");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active.selected").removeClass("active");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
      if ( $(this).hasClass("otaku-box-offer-btn-post-purchase-start") ) {
        if ( $(this).closest(".the-otaku-box-container").find(".main-digital-image-2").hasClass("hide-digital") ) {
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-1").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-3").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-2").removeClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").addClass("post_purchase_step_image_2");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").removeClass("post_purchase_step_image_3");
          $(this).closest(".the-otaku-box-container").find(".box-checkout").addClass("box-checkout-2");
        } else {
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-1").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-2").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-3").removeClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").removeClass("post_purchase_step_image_2");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").addClass("post_purchase_step_image_3");
          $(this).closest(".the-otaku-box-container").find(".box-checkout").removeClass("box-checkout-2");
          $(this).closest(".the-otaku-box-container").find(".box-checkout").addClass("box-checkout-3");
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }   


       if ( ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step").hasClass("selected") ) && ( $(this).closest(".the-otaku-box-container").find(".ecchi-step").hasClass("selected") == false ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step .otaku-box-questions-select-variations.selected").length > 0 ) ) {    
        $(this).closest(".the-otaku-box-container").find(".ecchi-step .otaku-box-questions-select.yes-option").click();
       }

      if ( ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step").hasClass("selected") ) && ( $(this).closest(".the-otaku-box-container").find(".ecchi-step").hasClass("selected") == false ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step .otaku-box-questions-select.selected").length > 0 ) ) {    
        $(this).closest(".the-otaku-box-container").find(".ecchi-step .otaku-box-questions-select.yes-option").click();
       }
      
    }
 });
});  
$( document ).ready(function() {
  $( ".otaku-box-questions-select" ).click(function() {
    let current_step = 	$(this).closest(".otaku-box-selected-offer-step").attr("data-step");
    if ( $(this).hasClass("show-neither") ) {
      $(".otaku-box-selected-offer-step[data-step='3']").addClass("active");
      $(".otaku-box-offer-pre-btn").removeAttr("disabled");
      $(".otaku-box-offer-pre-btn").addClass("otaku-box-offer-pre-btn-lv2");
      $(".otaku-box-offer-pre-btn.otaku-box-offer-pre-btn-lv2").click();
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(".otaku-box-offer-pre-btn").removeClass("otaku-box-offer-pre-btn-lv2");
    } else if ( $(this).hasClass("otaku-box-questions-select-pre-step") ) {
      let combination_step = $(this).attr("data-combination");
      $( ".the-otaku-box-container" ).each(function() {
        $( this ).find( ".free-pre-step .otaku-box-questions-combination .otaku-box-questions-select[data-combination=" + combination_step + "]" ).click();
      });
      $(".otaku-box-selected-offer-step[data-step='3']").addClass("active");
      $(".otaku-box-offer-pre-btn").removeAttr("disabled");
    } else if ( $(this).hasClass("no-option") ) {
	  $(this).closest(".otaku-box-selected-offer-step").addClass("deny-offer");
      setTimeout(function(){  $('.step-image[data-step=' + current_step + ']').removeClass("show-image");  }, 500);
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
	  if ( $('.step-image-remove[data-step=' + current_step + ']').length > 0 ) {
        setTimeout(function(){  $('.step-image-remove[data-step=' + current_step + ']').removeClass("remove-image");  }, 500);
        $('.step-image-remove[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
	  }
      if ( $(this).hasClass("end-post-purchase") ) {
        $('.otaku-box-step-select-input-id.ecchitoons-teaser').val("41606325829803");
      }  
      if ( $(this).hasClass("end-post-purchase-ecchitoons") ) {
        cookiePostUpsell = false;
      }  
    } else if ( $(this).hasClass("otaku-box-combination-product") ) {
	  let current_combination = 	$(this).attr("data-combination");
      $('.step-image-combination.step-image-combination-' + current_step).removeClass("show-image");
      $('.step-image-combination.step-image-combination-' + current_step).removeAttr( 'style' );
      $('.step-image[data-step_' + current_combination + '=' + current_step + ']').addClass("show-image");
	  $('.step-image[data-step_' + current_combination + '=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
    } else {
	  $(this).closest(".otaku-box-selected-offer-step").removeClass("deny-offer");
	  $('.step-image[data-step=' + current_step + ']').addClass("show-image");
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
	  if ( $('.step-image-remove[data-step=' + current_step + ']').length > 0 ) {
        $('.step-image-remove[data-step=' + current_step + ']').addClass("remove-image");
        $('.step-image-remove[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
	   }
      if ( $(this).hasClass("end-post-purchase") ) {
        $('.otaku-box-step-select-input-id.ecchitoons-teaser').val("");
      }  
      if ( $(this).hasClass("end-post-purchase-ecchitoons") ) {
        cookiePostUpsell = true;
      }  
      if ( $(this).hasClass("end-post-purchase-waifu") ) {
        cookiePostUpsell = "waifu";
      }  
    }
    
    if ( $(this).hasClass("otaku-box-questions-select-variations") ) {
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      let selected_var_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price") ); 
       if ( selected_currency == "€") {
        selected_var_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
       }
      if ( $(this).hasClass("otaku-box-questions-select-variations-quarterly") ) {
        selected_var_price = selected_var_price / 3;
        selected_var_price = selected_var_price.toFixed(2);
      }
      if ( selected_var_price == 0 ) {
        selected_var_price = "0.00";
         if ( selected_currency == "€") {
          selected_var_price = "0,00";
         }
      }
      if ( selected_currency == "€") {
        $(this).closest(".otaku-box-selected-offer-step-info").find(".otaku-box-selected-offer-step-price span").text("€" + selected_var_price.toString().replace(/\./g, ',') );
      } else {
        $(this).closest(".otaku-box-selected-offer-step-info").find(".otaku-box-selected-offer-step-price span").text("$" + selected_var_price.toString());
      }
    }

    if ( ( $(window).scrollTop() + $(window).height() != $(document).height() ) && ( $(".the-otaku-box-body.selected .otaku-box-offer-btn").length > 0 ) ) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".the-otaku-box-body.selected .otaku-box-offer-btn").offset().top - $(window).height() + 80
       }, 500); 
    }

    
    if ( $(this).hasClass("otaku-box-questions-select-pre-step") ) {
      $(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select" ).removeClass("selected");
      $(this).addClass("selected");
   } else {
    let current_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price") );
    let selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price") ); 
    let current_rrp_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price") );
    let selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price") ); 
    let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
    if ( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected").length != 0 ) {
	  let step_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-price"));
      let new_price = current_price - step_price + selected_price;
      new_price = new_price.toFixed(2);
      let step_rrp_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-rrp-price"));
      let new_rrp_price = current_rrp_price - step_rrp_price + selected_rrp_price;
      new_rrp_price = new_rrp_price.toFixed(2);
      if ( selected_currency == "€") {
       current_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price").replace(/\,/g, '.') );
       selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
	   step_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') );
	   new_price = current_price - step_price + selected_price;
	   new_price = new_price.toFixed(2).toString().replace(/\./g, ',');
       if ( (".retail-price-title span").lenght > 0 ) { 
         current_rrp_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price").replace(/\,/g, '.') );
         selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') ); 
  	     step_rrp_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') );
  	     new_rrp_price = current_rrp_price - step_rrp_price + selected_rrp_price;
  	     new_rrp_price = new_rrp_price.toFixed(2).toString().replace(/\./g, ',');
       }  
	  } 
      if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false && $(this).hasClass("end-post-purchase-ecchitoons") == false && $(this).closest(".otaku-box-selected-offer-step").hasClass("additional-pre-step") == false ) {
        $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
        $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text(selected_currency + new_price.toString());
        $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
        $(this).closest(".the-otaku-box-body").find(".retail-price-title span").text( selected_currency + new_rrp_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      }
    } else {     
      let new_price = current_price + selected_price;
      new_price = new_price.toFixed(2);
      let new_rrp_price = current_rrp_price + selected_rrp_price;
      new_rrp_price = new_rrp_price.toFixed(2);
      if ( selected_currency == "€") {
		current_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price").replace(/\,/g, '.') );
        selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
	    new_price = current_price + selected_price;
        new_price = new_price.toFixed(2).toString().replace(/\./g, ',');
        if ( (".retail-price-title span").lenght > 0 ) {
          current_rrp_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price").replace(/\,/g, '.') );
          selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') ); 
  	      new_rrp_price = current_rrp_price + selected_rrp_price;
          new_rrp_price = new_rrp_price.toFixed(2).toString().replace(/\./g, ',');
        }  


         if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false && $(this).hasClass("end-post-purchase-ecchitoons") == false && $(this).closest(".otaku-box-selected-offer-step").hasClass("additional-pre-step") == false ) {
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toString());
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").text( selected_currency + new_rrp_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        }
        
	  } else {
        if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false && $(this).hasClass("end-post-purchase-ecchitoons") == false && $(this).closest(".otaku-box-selected-offer-step").hasClass("additional-pre-step") == false ) {
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toString());
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").text( selected_currency + new_rrp_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        }
      }
    }
    $(".otaku-box-offer-btn").removeAttr("disabled");
	$(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select" ).removeClass("selected");
    $(this).addClass("selected");
	if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("otaku-box-selected-offer-step-final") ) {
	  $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    }
	if ( $(this).hasClass("start-pre-purchase") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-pre-purchase");
    }
    if ( $(this).hasClass("start-post-purchase") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-post-purchase");
    }
    if ( $(this).hasClass("show-retail-price") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-show-retail-price");
    }
    $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).find(".otaku-box-answer-select-input-id").val() );
    $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).find(".otaku-box-answer-select-input-selling-plan").val() );
    if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("tob-variant-final") ) {
      let combined_options = '';
      $( ".the-otaku-box-body.selected .otaku-box-selected-offer-step" ).each(function() {
	    if ( ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != '' ) &&
		     ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != null ) ) {
          combined_options = combined_options + $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val();
        }
      });
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-id.variant-title-" + combined_options ).val() );
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-selling-plan.variant-title-" + combined_options).val() );
    }
    
    }
 });
}); 
$( document ).ready(function() {
  $( ".otaku-box-selected-offer-step-change" ).click(function() {
    $(".otaku-box-selected-offer-step").removeClass("edit"); 
    $(this).closest(".otaku-box-selected-offer-step").addClass("edit");  
    $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-edit");
    $(".otaku-box-offer-btn").attr("disabled","disabled");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-monthly-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-monthly-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-monthly-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-three-months-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-three-months-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-three-months-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-six-months-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-six-months-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-six-months-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-annual-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-annual-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-annual-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-monthly-offer-box" ).click(function() {
   $(".the-otaku-box-body").removeClass("pre-select-no");
 });
});  
$( document ).ready(function() {
  $( "#digital-no" ).click(function() {
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-edit");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn-final").click();
    $('#pre-purchase').css('pointer-events','none');
    $("#pre-purchase .modal-dialog").hide();
  });
  $( "#digital-yes" ).click(function() {
    $(".otaku-box-offer-footer-cancel-digital").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
    $("#pre-purchase .close").click();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-price").removeClass("otaku-box-selected-offer-info-price");
    $(".the-otaku-box-body.selected").find(".otaku-box-pre-purchase-offer-price").addClass("otaku-box-selected-offer-info-price");
    $(".main-product-image").addClass("remove-main-image");
    $(".main-digital-image").removeClass("remove-digital-image");
    $(".otaku-box-body-image-container").addClass("digital-image-container");
    $(".otaku-box-selected-offer-info-header").addClass("otaku-box-selected-offer-info-digital-header");
    let info_title = $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").attr("data-title");	
    $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").html("You have the TOB <span>" + info_title + "</span>" );
    $(".the-otaku-box-body.selected .otaku-box-plan-title").hide();
    $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-digital-title").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }); 
  $( ".digital-back" ).click(function() {
    $(".otaku-box-offer-footer-cancel-digital").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-price").addClass("otaku-box-selected-offer-info-price");
    $(".the-otaku-box-body.selected").find(".otaku-box-pre-purchase-offer-price").removeClass("otaku-box-selected-offer-info-price");
    $(".main-product-image").removeClass("remove-main-image");
    $(".main-digital-image").addClass("remove-digital-image");
    $(".main-digital-image").removeClass("show-image");
    $(".main-digital-image").removeAttr("style")
    $(".otaku-box-body-image-container").removeClass("digital-image-container");
    $(".otaku-box-selected-offer-info-header").removeClass("otaku-box-selected-offer-info-digital-header");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step").removeClass("active");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step .otaku-box-step-select-main-input").val("");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step .otaku-box-questions-select").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.pre-purchase-step").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.pre-purchase-step").addClass("active");
    $(".otaku-box-offer-btn").removeAttr("disabled");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
    let selected_currency = $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-info-price").text().slice(0,1);
    if ( selected_currency == "€") {
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").attr("data-price","0,00");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").html("€0,00");
    } else {
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").attr("data-price","0.00");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").html("$0.00");
    }
    let info_title = $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").attr("data-title");		
    $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").html(info_title);
    $(".the-otaku-box-body.selected .otaku-box-plan-title").show();
    $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-digital-title").hide(); 
    if ( selected_currency == "€") {
      if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Kasse");
         } else {
           $(".otaku-box-offer-btn").html("Vérifier");
         }
    } else {
      $(".otaku-box-offer-btn").html("Checkout");
    }
    
    $(".otaku-box-offer-btn").html("Checkout");
    $(".retail-price-step").addClass("selected");
    $(".retail-price-section").addClass("show");
    $(".otaku-box-selected-offer-info-footer-price").addClass("show"); 
    $(".otaku-box-selected-offer-step.retail-price-step .otaku-box-questions-select").removeClass("show-retail-price"); 
    $(".otaku-box-offer-footer").addClass("hide-border"); 
  });
  $( "#cancel-digital" ).click(function() {
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
  }); 
}); 

$( document ).ready(function() {
  $( ".otaku-box-offer-pre-btn" ).click(function() {
    if ( $(".single-offer-body").length > 0 ) {

      if ( $(this).hasClass("otaku-box-offer-pre-btn-lv2") ) {
        $(".single-offer-body").addClass("selected");
        $(".otaku-box-selected-offer-pre-step").hide();
        $("body").removeClass("black-friday-offer");
        window.scrollTo({ top: 0, behavior: 'smooth' });
       
      } else {
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-title").text( $(".additional-pre-step .otaku-box-selected-offer-step-title").first().text().trim() );
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-subtitle").text( $(".additional-pre-step .otaku-box-selected-offer-step-subtitle").first().text().replace(/\s+/g, ' ').trim() );
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).addClass("otaku-box-offer-pre-btn-lv2");
          $(".otaku-box-questions-select-pre-step.selected").hide();
          $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").hide();
          $(".otaku-box-offer-footer-lv-2").show();
          $(".step-back-initial").show();
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v2");   

          $(".show-neither").hide();
          
      }  
    } else {
      if ( $(this).hasClass("otaku-box-offer-pre-btn-lv2") ) {
        $("#the-otaku-box-six-months-offer").addClass("selected");
        $(".otaku-box-selected-offer-pre-step").hide();
        $("body").removeClass("black-friday-offer");
        window.scrollTo({ top: 0, behavior: 'smooth' });
      
      } else {
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-title").text( $(".additional-pre-step .otaku-box-selected-offer-step-title").first().text().trim() );
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-subtitle").text( $(".additional-pre-step .otaku-box-selected-offer-step-subtitle").first().text().replace(/\s+/g, ' ').trim() );
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).addClass("otaku-box-offer-pre-btn-lv2");
          $(".otaku-box-questions-select-pre-step.selected").hide();
          $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").hide();
          $(".otaku-box-offer-footer-lv-2").show();
          $(".step-back-initial").show();
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v2");

          if ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) {
            $(".otaku-box-selected-offer-pre-step-v2 .otaku-box-offer-footer-lv-2-btn-yes").click();
          }

          $(".show-neither").hide();
  
         
      }  
    }
  });

  $(".otaku-box-offer-footer-lv-2-btn").click(function() {
    $(".otaku-box-offer-pre-btn-lv2").removeAttr("disabled");
    $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
    $(this).addClass("selected");
  });
  
  $(".otaku-box-offer-footer-lv-2-btn-yes").click(function() {
    let combination_step = $(this).closest(".otaku-box-selected-offer-pre-step").find(".otaku-box-questions-select-pre-step:not(.selected)").attr("data-combination");
    $( ".the-otaku-box-container" ).each(function() {
      $( this ).find( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select[data-combination=" + combination_step + "]" ).click();
    });
  });
  
  $(".otaku-box-offer-footer-lv-2-btn-no").click(function() {
    $( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select").removeClass("selected");
    $( ".additional-pre-step .otaku-box-step-select-input-id").val("");
    $(".step-image-combination-2").removeClass("show-image");
    $(".step-image-combination-2").removeAttr( 'style' );
  });

  $(".step-back-initial").click(function() {
    $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-title").text( $(".free-pre-step .otaku-box-selected-offer-step-title").first().text().trim() );
    $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-subtitle").text( $(".free-pre-step .otaku-box-selected-offer-step-subtitle").first().text().trim() );
    $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
    $( ".otaku-box-offer-pre-btn" ).removeClass("otaku-box-offer-pre-btn-lv2");
    $(".otaku-box-questions-select-pre-step.selected").show();
    $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").show();
    $(".otaku-box-offer-footer-lv-2").hide();
    $(".step-back-initial").hide();
    $( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select").removeClass("selected");
    $( ".additional-pre-step .otaku-box-step-select-input-id").val("");
    $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v2");
    $(".otaku-box-offer-footer-lv-2 .otaku-box-offer-footer-lv-2-btn").removeClass("selected");
    $(".otaku-box-selected-offer-pre-step .otaku-box-questions-select-pre-step").removeClass("selected");

    $(".show-neither").show(); 
$("body").addClass("black-friday-offer");
    
  });
  
}); 

$( document ).ready(function() {
  $( ".step-back" ).click(function() {
    if ( $(this).hasClass("box-selection") ) {
      $(".the-otaku-box-body").removeClass("selected");
      $("body").addClass("black-friday-offer");
      $(".otaku-box-selected-offer-pre-step").show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( $(this).hasClass("box-selected") ) {
      $(".otaku-box-offer-boxes").show();   
      $(".otaku-box-offer-info").show();
      $(".otaku-box-selected-offer-info").removeClass("selected");
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-initial");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-show-retail-price");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase");
      $(".otaku-box-offer-btn").removeAttr("disabled");	
      $(".otaku-box-body-image-container-back").addClass("box-selection");
      $(".otaku-box-body-image-container-back").removeClass("box-selected");
      $(".otaku-box-plan-title-1").show();
      $(".otaku-box-plan-title-2").hide();
      
      //$(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select").addClass("show-retail-price");
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
         if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Weiter");
         } else {
           $(".otaku-box-offer-btn").html("Suivant");
         }
      } else {
         $(".otaku-box-offer-btn").html("Next");
      }
      $(".retail-price-step").removeClass("selected");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").show();
   
      
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( $(this).hasClass("box-checkout-2") ) {
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next_2").removeClass("active");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step-final").removeClass("active");
      
      
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next").removeClass("selected");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next").addClass("active");
      
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-1").removeClass("hide-digital");
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-2").addClass("hide-digital");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").removeClass("post_purchase_step_image_2");

      
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").attr("disabled","true");

      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step .otaku-box-questions-select.selected").removeClass("selected");
      
      $(this).removeClass("box-checkout-2");
    } else if ( $(this).hasClass("box-checkout-3") ) {
      
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step-final").removeClass("active");
      
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next_2").removeClass("selected");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next_2").addClass("active");
      
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-2").removeClass("hide-digital");
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-3").addClass("hide-digital");

      $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").addClass("post_purchase_step_image_2");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").removeClass("post_purchase_step_image_3");

      
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").attr("disabled","true");

      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step .otaku-box-questions-select.selected").removeClass("selected");
      
      $(this).removeClass("box-checkout-3");
      $(this).addClass("box-checkout-2"); 
    } else if ( $(this).hasClass("box-checkout") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-post-purchase"); 
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
      $(".otaku-box-selected-offer-step.selected").show();
      $(".otaku-box-selected-offer-step.active").show();
      $(".the-otaku-box-body.selected .otaku-box-plan-title").show();
      $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-header-text").show();
      $(".main-product-image").removeClass("remove-main-image");
      $(".main-digital-image").addClass("remove-digital-image");
  
    
      $(".otaku-box-body-image-container").removeClass("post_purchase_step_image");
      $(".otaku-box-body-image-container-back").addClass("box-selected");
      $(".otaku-box-body-image-container-back").removeClass("box-checkout");
      $(".post_purchase_step").removeClass("active");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
      $(".otaku-box-offer-btn").attr("disabled","disabled");	
      $(".otaku-box-plan-title.otaku-box-digital-title").hide();

      
      if ( $(this).closest(".the-otaku-box-body").hasClass("retail-price-body") ) {
        $(this).closest(".the-otaku-box-body").find(".retail-price-step").addClass("active");
        $(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select").addClass("show-retail-price");
        $(".retail-price-step").removeClass("selected");
        $(".retail-price-section").removeClass("show");
      }

      
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
         if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Weiter");
         } else {
           $(".otaku-box-offer-btn").html("Suivant");
         }
      } else {
         $(".otaku-box-offer-btn").html("Next");
      }
     
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").show(); 


      if ( $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").hasClass("otaku-box-offer-btn-post-purchase-start") ) {
        $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase-start");
        $(this).closest(".the-otaku-box-body").find(".main-digital-image-1").removeClass("hide-digital");
        $(this).closest(".the-otaku-box-body").find(".main-digital-image-2").addClass("hide-digital");
        $(this).closest(".the-otaku-box-body").find(".main-digital-image-3").addClass("hide-digital");
        $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").removeClass("post_purchase_step_image_2");
      }

      //$(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step .otaku-box-questions-select.selected").removeClass("selected");
      
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
});   
function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
if ( getUrlVars() !== undefined ) {
if ( $("#tripwire-url-1").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-1").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-1").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-2").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-2").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-2").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-3").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-3").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-3").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-4").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-4").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-4").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-5").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-5").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-5").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-6").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-6").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-6").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-7").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-7").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-7").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-8").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-8").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-8").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-9").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-9").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-9").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-10").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-10").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-10").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
}

$( document ).ready(function() {
  if ( getUrlVars() !== undefined ) {
    if ( getUrlVars()["figure"] ==  "rias" ) {
      $(".otaku-box-selected-offer-pre-step:not(.otaku-box-selected-offer-pre-step-v2) .otaku-box-questions-select[data-combination='1']").click();
      $(".otaku-box-offer-pre-btn").click();
      $(".otaku-box-selected-offer-pre-step").show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( ( getUrlVars()["figure"] ==  "leafa" ) || ( getUrlVars()["figure"] ==  "rem" ) ) {
      $(".otaku-box-selected-offer-pre-step:not(.otaku-box-selected-offer-pre-step-v2) .otaku-box-questions-select[data-combination='2']").click();
      $(".otaku-box-offer-pre-btn").click();
      $(".otaku-box-selected-offer-pre-step").show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-tob_offer_07"] && !Shopify.designMode) return;
  try {
    

let cookiePostUpsell = false;

if ( getUrlVars() !== undefined ) {
  if ( getUrlVars()["figure"] ==  "rias" || getUrlVars()["figure"] ==  "rem" || getUrlVars()["figure"] ==  "rias-rem"  ) {

  } else {
    $(".otaku-box-selected-offer-pre-step").show();
  }
} else {
  $(".otaku-box-selected-offer-pre-step").show();
}
  
$( document ).ready(function() { 
  $( ".otaku-box-offer-btn" ).click(function() {
    if ( $(this).hasClass("otaku-box-offer-btn-initial") ) {
   	  $(".otaku-box-offer-boxes").hide();   
      $(".otaku-box-offer-info").hide();
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info").addClass("selected");
      $(this).removeClass("otaku-box-offer-btn-initial");
      $(this).addClass("otaku-box-offer-btn-next");
      $(this).attr("disabled","disabled");	
      $(".otaku-box-body-image-container-back").removeClass("box-selection");
      $(".otaku-box-body-image-container-back").addClass("box-selected");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
      window.scrollTo({ top: 0, behavior: 'smooth' });
     
      $(".otaku-box-plan-title-1").hide();
      $(".otaku-box-plan-title-2").show();


      if ( ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) && ( $(this).closest(".the-otaku-box-container").find(".scale-figure-step").hasClass("active") ) ) {
        $(this).closest(".the-otaku-box-container").find(".scale-figure-step .otaku-box-questions-select:not(.no-option)").click();
      }
      
    } else if ( $(this).hasClass("otaku-box-offer-btn-show-retail-price") ) {
      $(this).removeClass("otaku-box-offer-btn-show-retail-price");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select.show-retail-price").removeClass("show-retail-price");
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
        if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Kasse");
         } else {
           $(".otaku-box-offer-btn").html("Vérifier");
         }
      } else {
        $(this).html("Checkout");
      }
      $(".retail-price-step").addClass("selected");
      $(".retail-price-section").addClass("show");
      $(".otaku-box-selected-offer-info-footer-price").addClass("show");
      $(".otaku-box-offer-footer").addClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").hide();
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 

 
      
    } else if ( $(this).hasClass("otaku-box-offer-btn-edit") ) {
      $(".otaku-box-selected-offer-step.edit").removeClass("edit");
      $(this).removeClass("otaku-box-offer-btn-edit");
      
    } else if ( $(this).hasClass("otaku-box-offer-btn-post-purchase") ) {
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase"); 
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").hide();
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").hide();
      $(".the-otaku-box-body.selected .otaku-box-plan-title").hide();
      $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-header-text").hide();
      $(".main-product-image").addClass("remove-main-image");
      $(".main-digital-image").removeClass("remove-digital-image");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-body-image-container").addClass("post_purchase_step_image");
      $(".otaku-box-body-image-container-back").removeClass("box-selected");
      $(".otaku-box-body-image-container-back").addClass("box-checkout");
      // $(".otaku-box-body-offer-container").addClass("post_purchase_step_offer");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
	  $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
      $(".post_purchase_step").addClass("active");

      if ( $(this).closest(".the-otaku-box-container").find(".post_purchase_step.post_purchase_step_next").length > 0 ) {
        $(this).addClass("otaku-box-offer-btn-post-purchase-start");
      } 
 	 
      window.scrollTo({ top: 0, behavior: 'smooth' });

      if ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") )  {    
       $(this).closest(".the-otaku-box-container").find(".otaku-box-selected-offer-step-final .end-post-purchase:not(.no-option)").click();
      }

      
    } else if ( $(this).hasClass("otaku-box-offer-btn-pre-purchase") ) {
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
        if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Weiter");
         } else {
           $(".otaku-box-offer-btn").html("Suivant");
         }
      } else {
        $(this).html("Next");
      }
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-edit"); 
	  $(this).closest(".the-otaku-box-body").find(".btn-start-pre-purchase").click();
      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $( ".otaku-box-selected-offer-step" ).each(function() {
        if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();
        }
        if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }		
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		}
      });
      let checkout_local_url = $("#local_url").val();
      let checkout_digtial_all_url = ''; 
      $( ".the-otaku-box-body.selected .digital-step" ).each(function() {
        checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-answer-select-main-input-id" ).val() + "%26items[][quantity]=1%26";
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
          checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
          checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() + "%26items[][quantity]=1%26";
        }
      });
      checkout_digtial_all_url = checkout_url + checkout_digtial_all_url + "return_to=" + checkout_local_url + "checkout";
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout";
      jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });
      $("#digital-all").attr("href", checkout_digtial_all_url); 
      $(".otaku-box-offer-footer-cancel-digital").attr("href", checkout_url);   
    } else if ( $(this).hasClass("otaku-box-offer-btn-final") ) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $(".the-otaku-box-spinner").show(); $("body").addClass("fixed"); }, 100);
      $(this).attr("style","pointer-events:none;");
      $(".otaku-box-selected-offer-info-header-digital").addClass("finished-test");
      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $(this).closest(".the-otaku-box-body.selected").find( ".otaku-box-selected-offer-step" ).each(function() {
       if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();         
        }
        if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }		
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		}
      });

      cookieExpiry = new Date(Date.now() + 86400e3).toUTCString(); // Set expiry to one day
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=.theotakubox.com;path=/;expires=${cookieExpiry};SameSite=None; Secure`;
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=theotakubox.com;expires=${cookieExpiry};SameSite=None; Secure`;

      let checkout_local_url = $("#local_url").val();
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout";
	  jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });	

   
      
       window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);
      setTimeout(function(){  window.location.href = checkout_url; }, 500);
    } else if ( $(this).hasClass("otaku-box-offer-btn-next") ) {         
      $(this).attr("disabled","disabled");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").addClass("selected");
 	  $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").next().addClass("active");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active.selected").removeClass("active");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
      if ( $(this).hasClass("otaku-box-offer-btn-post-purchase-start") ) {
        if ( $(this).closest(".the-otaku-box-container").find(".main-digital-image-2").hasClass("hide-digital") ) {
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-1").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-3").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-2").removeClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").addClass("post_purchase_step_image_2");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").removeClass("post_purchase_step_image_3");
          $(this).closest(".the-otaku-box-container").find(".box-checkout").addClass("box-checkout-2");
        } else {
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-1").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-2").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-3").removeClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").removeClass("post_purchase_step_image_2");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").addClass("post_purchase_step_image_3");
          $(this).closest(".the-otaku-box-container").find(".box-checkout").removeClass("box-checkout-2");
          $(this).closest(".the-otaku-box-container").find(".box-checkout").addClass("box-checkout-3");
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }   


       if ( ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step").hasClass("selected") ) && ( $(this).closest(".the-otaku-box-container").find(".ecchi-step").hasClass("selected") == false ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step .otaku-box-questions-select-variations.selected").length > 0 ) ) {    
        $(this).closest(".the-otaku-box-container").find(".ecchi-step .otaku-box-questions-select.yes-option").click();
       }

      if ( ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step").hasClass("selected") ) && ( $(this).closest(".the-otaku-box-container").find(".ecchi-step").hasClass("selected") == false ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step .otaku-box-questions-select.selected").length > 0 ) ) {    
        $(this).closest(".the-otaku-box-container").find(".ecchi-step .otaku-box-questions-select.yes-option").click();
       }
      
    }
 });
});  
$( document ).ready(function() {
  $( ".otaku-box-questions-select" ).click(function() {
    let current_step = 	$(this).closest(".otaku-box-selected-offer-step").attr("data-step");
    if ( $(this).hasClass("show-neither") ) {
      $(".otaku-box-selected-offer-step[data-step='3']").addClass("active");
      $(".otaku-box-offer-pre-btn").removeAttr("disabled");
      $(".otaku-box-offer-pre-btn").addClass("otaku-box-offer-pre-btn-lv2");
      $(".otaku-box-offer-pre-btn.otaku-box-offer-pre-btn-lv2").click();
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(".otaku-box-offer-pre-btn").removeClass("otaku-box-offer-pre-btn-lv2");
    } else if ( $(this).hasClass("otaku-box-questions-select-pre-step") ) {
      let combination_step = $(this).attr("data-combination");
      $( ".the-otaku-box-container" ).each(function() {
        $( this ).find( ".free-pre-step .otaku-box-questions-combination .otaku-box-questions-select[data-combination=" + combination_step + "]" ).click();
      });
      $(".otaku-box-selected-offer-step[data-step='3']").addClass("active");
      $(".otaku-box-offer-pre-btn").removeAttr("disabled");
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".otaku-box-offer-pre-btn").offset().top - $(window).height() + 180
       }, 500); 
    } else if ( $(this).hasClass("no-option") ) {
	  $(this).closest(".otaku-box-selected-offer-step").addClass("deny-offer");
      setTimeout(function(){  $('.step-image[data-step=' + current_step + ']').removeClass("show-image");  }, 500);
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
	  if ( $('.step-image-remove[data-step=' + current_step + ']').length > 0 ) {
        setTimeout(function(){  $('.step-image-remove[data-step=' + current_step + ']').removeClass("remove-image");  }, 500);
        $('.step-image-remove[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
	  }
      if ( $(this).hasClass("end-post-purchase") ) {
        $('.otaku-box-step-select-input-id.ecchitoons-teaser').val("41606325829803");
      }  
      if ( $(this).hasClass("end-post-purchase-ecchitoons") ) {
        cookiePostUpsell = false;
      }  
    } else if ( $(this).hasClass("otaku-box-combination-product") ) {
	  let current_combination = 	$(this).attr("data-combination");
      $('.step-image-combination.step-image-combination-' + current_step).removeClass("show-image");
      $('.step-image-combination.step-image-combination-' + current_step).removeAttr( 'style' );
      $('.step-image[data-step_' + current_combination + '=' + current_step + ']').addClass("show-image");
	  $('.step-image[data-step_' + current_combination + '=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
    } else {
	  $(this).closest(".otaku-box-selected-offer-step").removeClass("deny-offer");
	  $('.step-image[data-step=' + current_step + ']').addClass("show-image");
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
	  if ( $('.step-image-remove[data-step=' + current_step + ']').length > 0 ) {
        $('.step-image-remove[data-step=' + current_step + ']').addClass("remove-image");
        $('.step-image-remove[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
	   }
      if ( $(this).hasClass("end-post-purchase") ) {
        $('.otaku-box-step-select-input-id.ecchitoons-teaser').val("");
      }  
      if ( $(this).hasClass("end-post-purchase-ecchitoons") ) {
        cookiePostUpsell = true;
      }  
      if ( $(this).hasClass("end-post-purchase-waifu") ) {
        cookiePostUpsell = "waifu";
      }  
    }
    
    if ( $(this).hasClass("otaku-box-questions-select-variations") ) {
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      let selected_var_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price") ); 
       if ( selected_currency == "€") {
        selected_var_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
       }
      if ( $(this).hasClass("otaku-box-questions-select-variations-quarterly") ) {
        selected_var_price = selected_var_price / 3;
        selected_var_price = selected_var_price.toFixed(2);
      }
      if ( selected_var_price == 0 ) {
        selected_var_price = "0.00";
         if ( selected_currency == "€") {
          selected_var_price = "0,00";
         }
      }
      if ( selected_currency == "€") {
        $(this).closest(".otaku-box-selected-offer-step-info").find(".otaku-box-selected-offer-step-price span").text("€" + selected_var_price.toString().replace(/\./g, ',') );
      } else {
        $(this).closest(".otaku-box-selected-offer-step-info").find(".otaku-box-selected-offer-step-price span").text("$" + selected_var_price.toString());
      }
    }

    if ( ( $(window).scrollTop() + $(window).height() != $(document).height() ) && ( $(".the-otaku-box-body.selected .otaku-box-offer-btn").length > 0 ) ) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".the-otaku-box-body.selected .otaku-box-offer-btn").offset().top - $(window).height() + 180
       }, 500); 
    }

    
    if ( $(this).hasClass("otaku-box-questions-select-pre-step") ) {
      $(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select" ).removeClass("selected");
      $(this).addClass("selected");
   } else {
    let current_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price") );
    let selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price") ); 
    let current_rrp_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price") );
    let selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price") ); 
    let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
    if ( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected").length != 0 ) {
	  let step_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-price"));
      let new_price = current_price - step_price + selected_price;
      new_price = new_price.toFixed(2);
      let step_rrp_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-rrp-price"));
      let new_rrp_price = current_rrp_price - step_rrp_price + selected_rrp_price;
      new_rrp_price = new_rrp_price.toFixed(2);
      if ( selected_currency == "€") {
       current_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price").replace(/\,/g, '.') );
       selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
	   step_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') );
	   new_price = current_price - step_price + selected_price;
	   new_price = new_price.toFixed(2).toString().replace(/\./g, ',');
       if ( (".retail-price-title span").lenght > 0 ) { 
         current_rrp_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price").replace(/\,/g, '.') );
         selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') ); 
  	     step_rrp_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') );
  	     new_rrp_price = current_rrp_price - step_rrp_price + selected_rrp_price;
  	     new_rrp_price = new_rrp_price.toFixed(2).toString().replace(/\./g, ',');
       }  
	  } 
      if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false && $(this).hasClass("end-post-purchase-ecchitoons") == false && $(this).closest(".otaku-box-selected-offer-step").hasClass("additional-pre-step") == false ) {
        $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
        $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text(selected_currency + new_price.toString());
        $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
        $(this).closest(".the-otaku-box-body").find(".retail-price-title span").text( selected_currency + new_rrp_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      }
    } else {     
      let new_price = current_price + selected_price;
      new_price = new_price.toFixed(2);
      let new_rrp_price = current_rrp_price + selected_rrp_price;
      new_rrp_price = new_rrp_price.toFixed(2);
      if ( selected_currency == "€") {
		current_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price").replace(/\,/g, '.') );
        selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
	    new_price = current_price + selected_price;
        new_price = new_price.toFixed(2).toString().replace(/\./g, ',');
        if ( (".retail-price-title span").lenght > 0 ) {
          current_rrp_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price").replace(/\,/g, '.') );
          selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') ); 
  	      new_rrp_price = current_rrp_price + selected_rrp_price;
          new_rrp_price = new_rrp_price.toFixed(2).toString().replace(/\./g, ',');
        }  


         if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false && $(this).hasClass("end-post-purchase-ecchitoons") == false && $(this).closest(".otaku-box-selected-offer-step").hasClass("additional-pre-step") == false ) {
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toString());
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").text( selected_currency + new_rrp_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        }
        
	  } else {
        if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false && $(this).hasClass("end-post-purchase-ecchitoons") == false && $(this).closest(".otaku-box-selected-offer-step").hasClass("additional-pre-step") == false ) {
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toString());
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").text( selected_currency + new_rrp_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        }
      }
    }
    $(".otaku-box-offer-btn").removeAttr("disabled");
	$(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select" ).removeClass("selected");
    $(this).addClass("selected");
	if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("otaku-box-selected-offer-step-final") ) {
	  $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    }
	if ( $(this).hasClass("start-pre-purchase") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-pre-purchase");
    }
    if ( $(this).hasClass("start-post-purchase") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-post-purchase");
    }
    if ( $(this).hasClass("show-retail-price") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-show-retail-price");
    }
    $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).find(".otaku-box-answer-select-input-id").val() );
    $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).find(".otaku-box-answer-select-input-selling-plan").val() );
    if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("tob-variant-final") ) {
      let combined_options = '';
      $( ".the-otaku-box-body.selected .otaku-box-selected-offer-step" ).each(function() {
	    if ( ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != '' ) &&
		     ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != null ) ) {
          combined_options = combined_options + $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val();
        }
      });
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-id.variant-title-" + combined_options ).val() );
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-selling-plan.variant-title-" + combined_options).val() );
    }
    
    }
 });
}); 
$( document ).ready(function() {
  $( ".otaku-box-selected-offer-step-change" ).click(function() {
    $(".otaku-box-selected-offer-step").removeClass("edit"); 
    $(this).closest(".otaku-box-selected-offer-step").addClass("edit");  
    $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-edit");
    $(".otaku-box-offer-btn").attr("disabled","disabled");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-monthly-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-monthly-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-monthly-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-three-months-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-three-months-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-three-months-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-six-months-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-six-months-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-six-months-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-annual-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-annual-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-annual-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-monthly-offer-box" ).click(function() {
   $(".the-otaku-box-body").removeClass("pre-select-no");
 });
});  
$( document ).ready(function() {
  $( "#digital-no" ).click(function() {
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-edit");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn-final").click();
    $('#pre-purchase').css('pointer-events','none');
    $("#pre-purchase .modal-dialog").hide();
  });
  $( "#digital-yes" ).click(function() {
    $(".otaku-box-offer-footer-cancel-digital").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
    $("#pre-purchase .close").click();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-price").removeClass("otaku-box-selected-offer-info-price");
    $(".the-otaku-box-body.selected").find(".otaku-box-pre-purchase-offer-price").addClass("otaku-box-selected-offer-info-price");
    $(".main-product-image").addClass("remove-main-image");
    $(".main-digital-image").removeClass("remove-digital-image");
    $(".otaku-box-body-image-container").addClass("digital-image-container");
    $(".otaku-box-selected-offer-info-header").addClass("otaku-box-selected-offer-info-digital-header");
    let info_title = $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").attr("data-title");	
    $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").html("You have the TOB <span>" + info_title + "</span>" );
    $(".the-otaku-box-body.selected .otaku-box-plan-title").hide();
    $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-digital-title").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }); 
  $( ".digital-back" ).click(function() {
    $(".otaku-box-offer-footer-cancel-digital").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-price").addClass("otaku-box-selected-offer-info-price");
    $(".the-otaku-box-body.selected").find(".otaku-box-pre-purchase-offer-price").removeClass("otaku-box-selected-offer-info-price");
    $(".main-product-image").removeClass("remove-main-image");
    $(".main-digital-image").addClass("remove-digital-image");
    $(".main-digital-image").removeClass("show-image");
    $(".main-digital-image").removeAttr("style")
    $(".otaku-box-body-image-container").removeClass("digital-image-container");
    $(".otaku-box-selected-offer-info-header").removeClass("otaku-box-selected-offer-info-digital-header");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step").removeClass("active");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step .otaku-box-step-select-main-input").val("");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step .otaku-box-questions-select").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.pre-purchase-step").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.pre-purchase-step").addClass("active");
    $(".otaku-box-offer-btn").removeAttr("disabled");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
    let selected_currency = $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-info-price").text().slice(0,1);
    if ( selected_currency == "€") {
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").attr("data-price","0,00");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").html("€0,00");
    } else {
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").attr("data-price","0.00");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").html("$0.00");
    }
    let info_title = $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").attr("data-title");		
    $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").html(info_title);
    $(".the-otaku-box-body.selected .otaku-box-plan-title").show();
    $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-digital-title").hide(); 
    if ( selected_currency == "€") {
      if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Kasse");
         } else {
           $(".otaku-box-offer-btn").html("Vérifier");
         }
    } else {
      $(".otaku-box-offer-btn").html("Checkout");
    }
    
    $(".otaku-box-offer-btn").html("Checkout");
    $(".retail-price-step").addClass("selected");
    $(".retail-price-section").addClass("show");
    $(".otaku-box-selected-offer-info-footer-price").addClass("show"); 
    $(".otaku-box-selected-offer-step.retail-price-step .otaku-box-questions-select").removeClass("show-retail-price"); 
    $(".otaku-box-offer-footer").addClass("hide-border"); 
  });
  $( "#cancel-digital" ).click(function() {
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
  }); 
}); 


// EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE  

$( document ).ready(function() {
  $( ".otaku-box-offer-pre-btn" ).click(function() {
    if ( $(".single-offer-body").length > 0 ) {

      if ( $(this).hasClass("otaku-box-offer-pre-btn-lv3") ) {
        $(".single-offer-body").addClass("selected");
        $(".otaku-box-selected-offer-pre-step").hide();
        $("body").removeClass("black-friday-offer");
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else if ( $(this).hasClass("otaku-box-offer-pre-btn-lv2") ) {
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).removeClass("otaku-box-offer-pre-btn-lv2");
          $(this).addClass("otaku-box-offer-pre-btn-lv3");
          $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v2");
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v3");
          $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
          $(".otaku-box-offer-footer-lv-2-btn").addClass("otaku-box-offer-footer-lv-3-btn");
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step == 1 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          }
          if ( selected_step == 2 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='1']").hide();
          }
          if ( selected_step ==  3) {
            $(".otaku-box-questions-select-pre-step[data-combination='2']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='1']").hide();
          }
          $(".step-back-initial").addClass("step-back-initial-2");

          window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-title").text( $(".additional-pre-step .otaku-box-selected-offer-step-title").first().text().trim() );
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-subtitle").text( $(".additional-pre-step .otaku-box-selected-offer-step-subtitle").first().text().replace(/\s+/g, ' ').trim() );
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).addClass("otaku-box-offer-pre-btn-lv2");
          $(".otaku-box-questions-select-pre-step.selected").hide();
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step == 1 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          }
          if ( selected_step == 2 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          }
          if ( selected_step ==  3) {
            $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          }
          $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").hide();
          $(".otaku-box-offer-footer-lv-2").show();
          $(".step-back-initial").show();
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v2");
          $(".show-neither").hide();

          window.scrollTo({ top: 0, behavior: 'smooth' });

      }  
      
    } else {
      if ( $(this).hasClass("otaku-box-offer-pre-btn-lv3") ) {
        $("#the-otaku-box-six-months-offer").addClass("selected");
        $(".otaku-box-selected-offer-pre-step").hide();
        $("body").removeClass("black-friday-offer");
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else if ( $(this).hasClass("otaku-box-offer-pre-btn-lv2") ) {
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).removeClass("otaku-box-offer-pre-btn-lv2");
          $(this).addClass("otaku-box-offer-pre-btn-lv3");
          $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v2");
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v3");
          $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
          $(".otaku-box-offer-footer-lv-2-btn").addClass("otaku-box-offer-footer-lv-3-btn");
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step == 1 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          }
          if ( selected_step == 2 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='1']").hide();
          }
          if ( selected_step ==  3) {
            $(".otaku-box-questions-select-pre-step[data-combination='2']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='1']").hide();
          }
          $(".step-back-initial").addClass("step-back-initial-2");
          window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-title").text( $(".additional-pre-step .otaku-box-selected-offer-step-title").first().text().trim() );
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-subtitle").text( $(".additional-pre-step .otaku-box-selected-offer-step-subtitle").first().text().replace(/\s+/g, ' ').trim() );
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).addClass("otaku-box-offer-pre-btn-lv2");
          $(".otaku-box-questions-select-pre-step.selected").hide();
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step == 1 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          }
          if ( selected_step == 2 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          }
          if ( selected_step ==  3) {
            $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          }
          $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").hide();
          $(".otaku-box-offer-footer-lv-2").show();
          $(".step-back-initial").show();
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v2");
          $(".show-neither").hide();

          // Only difference
          if ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) {
            $(".otaku-box-selected-offer-pre-step-v2 .otaku-box-offer-footer-lv-2-btn-yes").click();
          }

        window.scrollTo({ top: 0, behavior: 'smooth' });

      }  
      
    }

    $(".free-offer-note").hide();

  });
  $(".otaku-box-offer-footer-lv-2-btn").click(function() {
    if ( $(this).hasClass("otaku-box-offer-footer-lv-3-btn") ) {
      $(".otaku-box-offer-pre-btn-lv3").removeAttr("disabled");
    } else {
      $(".otaku-box-offer-pre-btn-lv2").removeAttr("disabled");
    }
    $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
    $(this).addClass("selected");
  });
  $(".otaku-box-offer-footer-lv-2-btn-yes").click(function() {
    let combination_step = $(this).closest(".otaku-box-selected-offer-pre-step").find(".otaku-box-questions-select-pre-step:not(.selected)").attr("data-combination");
    if ( $(this).hasClass("otaku-box-offer-footer-lv-3-btn") ) {
      let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
      let combination_step = 3;
      if ( selected_step == 3 ) {
        combination_step = 2;
      }
      let combination_product_id = $(".additional-pre-step .otaku-box-combination-product[data-combination=" + combination_step + "] .otaku-box-answer-select-input-id").val();
      $('.step-image[data-step_' + combination_step + '=2]').addClass("show-image");
	  $('.step-image[data-step_' + combination_step + '=2]').css({"animation":"image-animation-on 0.5s"});
      $( ".the-otaku-box-container" ).each(function() {
        if ( ( $(this).find(".additional-pre-step .all-two").val() != '' ) && ( $(this).find(".additional-pre-step .all-two").val() != combination_product_id ) ) {
          $( this ).find( ".additional-pre-step .all-three").val(combination_product_id);
        } else {
          $( this ).find( ".additional-pre-step .all-two").val(combination_product_id);
        }
      });
    } else {
      $( ".the-otaku-box-container" ).each(function() {
        $( this ).find( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select[data-combination=" + combination_step + "]" ).click();
      });
    }
  });
  $(".otaku-box-offer-footer-lv-2-btn-no").click(function() {
    if ( $(this).hasClass("otaku-box-offer-footer-lv-3-btn") ) {
      if ( $(".additional-pre-step .all-three").val() != '' ) {
        $( ".additional-pre-step .all-three").val("");
      } else {
        let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
        let combination_step = 3;
        if ( selected_step == 3 ) {
          combination_step = 2;
        } 
        let combination_product_id = $(".additional-pre-step .otaku-box-combination-product[data-combination=" + combination_step + "] .otaku-box-answer-select-input-id").val();
        if ( ( $(".additional-pre-step .all-two").val() != '' ) && ( $(".additional-pre-step .all-two").val() == combination_product_id ) ) {  
          $( ".additional-pre-step .all-two").val("");
        }
      }
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step ==  3) {
            $(".step-image-combination.step-image[data-step_2='2']").removeClass("show-image");
            $(".step-image-combination.step-image[data-step_2='2']").removeAttr( 'style' );
          } else {
            $(".step-image-combination.step-image[data-step_3='2']").removeClass("show-image");
          $(".step-image-combination.step-image[data-step_3='2']").removeAttr( 'style' );
          }
    } else {
      $( ".additional-pre-step .otaku-box-step-select-input-id").val("");
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step ==  1) {
            $(".step-image-combination.step-image[data-step_2='2']").removeClass("show-image");
            $(".step-image-combination.step-image[data-step_2='2']").removeAttr( 'style' );
          } else {
            $(".step-image-combination.step-image[data-step_1='2']").removeClass("show-image");
            $(".step-image-combination.step-image[data-step_1='2']").removeAttr( 'style' );
          }
    }
    $( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select").removeClass("selected");
  });
  $(".step-back-initial").click(function() {
    if ( $(this).hasClass("step-back-initial-2") ) {
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
        $(".otaku-box-offer-pre-btn").addClass("otaku-box-offer-pre-btn-lv2");
        $(".otaku-box-offer-pre-btn").removeClass("otaku-box-offer-pre-btn-lv3");
        $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v2");
        $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v3");
        $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
        $(".otaku-box-offer-footer-lv-2-btn").removeClass("otaku-box-offer-footer-lv-3-btn");
        let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
        if ( selected_step == 1 ) {
          $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          $(".otaku-box-questions-select-pre-step[data-combination='2']").show();
        }
        if ( selected_step == 2 ) {
          $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          $(".otaku-box-questions-select-pre-step[data-combination='1']").show();
        }
        if ( selected_step ==  3) {
          $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          $(".otaku-box-questions-select-pre-step[data-combination='1']").show();
        }
        $(".step-back-initial").removeClass("step-back-initial-2");
    } else {
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-title").text( $(".free-pre-step .otaku-box-selected-offer-step-title").first().text().trim() );
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-subtitle").text( $(".free-pre-step .otaku-box-selected-offer-step-subtitle").first().text().trim() );
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $( ".otaku-box-offer-pre-btn" ).removeClass("otaku-box-offer-pre-btn-lv2");
      $(".otaku-box-questions-select-pre-step").show();
      $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").show();
      $(".otaku-box-offer-footer-lv-2").hide();
      $(".step-back-initial").hide();
      $( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select").removeClass("selected");
      $( ".additional-pre-step .otaku-box-step-select-input-id").val("");
      $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v2");
      $(".otaku-box-offer-footer-lv-2 .otaku-box-offer-footer-lv-2-btn").removeClass("selected");
      $(".otaku-box-selected-offer-pre-step .otaku-box-questions-select-pre-step").removeClass("selected"); 
      $(".show-neither").show(); 
      $("body").addClass("black-friday-offer");
      $(".free-offer-note").show();
    }
  });
}); 


// EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE
  
$( document ).ready(function() {
  $( ".step-back" ).click(function() {
    if ( $(this).hasClass("box-selection") ) {
      $(".the-otaku-box-body").removeClass("selected");
      $("body").addClass("black-friday-offer");
      $(".otaku-box-selected-offer-pre-step").show();
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( $(this).hasClass("box-selected") ) {
      $(".otaku-box-offer-boxes").show();   
      $(".otaku-box-offer-info").show();
      $(".otaku-box-selected-offer-info").removeClass("selected");
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-initial");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-show-retail-price");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase");
      $(".otaku-box-offer-btn").removeAttr("disabled");	
      $(".otaku-box-body-image-container-back").addClass("box-selection");
      $(".otaku-box-body-image-container-back").removeClass("box-selected");
      $(".otaku-box-plan-title-1").show();
      $(".otaku-box-plan-title-2").hide();
      
      //$(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select").addClass("show-retail-price");
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
         if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Weiter");
         } else {
           $(".otaku-box-offer-btn").html("Suivant");
         }
      } else {
         $(".otaku-box-offer-btn").html("Next");
      }
      $(".retail-price-step").removeClass("selected");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").show();
   
      
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( $(this).hasClass("box-checkout-2") ) {
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next_2").removeClass("active");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step-final").removeClass("active");
      
      
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next").removeClass("selected");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next").addClass("active");
      
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-1").removeClass("hide-digital");
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-2").addClass("hide-digital");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").removeClass("post_purchase_step_image_2");

      
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").attr("disabled","true");

      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step .otaku-box-questions-select.selected").removeClass("selected");
      
      $(this).removeClass("box-checkout-2");
    } else if ( $(this).hasClass("box-checkout-3") ) {
      
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step-final").removeClass("active");
      
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next_2").removeClass("selected");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next_2").addClass("active");
      
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-2").removeClass("hide-digital");
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-3").addClass("hide-digital");

      $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").addClass("post_purchase_step_image_2");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").removeClass("post_purchase_step_image_3");

      
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").attr("disabled","true");

      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step .otaku-box-questions-select.selected").removeClass("selected");
      
      $(this).removeClass("box-checkout-3");
      $(this).addClass("box-checkout-2"); 
    } else if ( $(this).hasClass("box-checkout") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-post-purchase"); 
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
      $(".otaku-box-selected-offer-step.selected").show();
      $(".otaku-box-selected-offer-step.active").show();
      $(".the-otaku-box-body.selected .otaku-box-plan-title").show();
      $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-header-text").show();
      $(".main-product-image").removeClass("remove-main-image");
      $(".main-digital-image").addClass("remove-digital-image");
  
    
      $(".otaku-box-body-image-container").removeClass("post_purchase_step_image");
      $(".otaku-box-body-image-container-back").addClass("box-selected");
      $(".otaku-box-body-image-container-back").removeClass("box-checkout");
      $(".post_purchase_step").removeClass("active");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
      $(".otaku-box-offer-btn").attr("disabled","disabled");	
      $(".otaku-box-plan-title.otaku-box-digital-title").hide();

      
      if ( $(this).closest(".the-otaku-box-body").hasClass("retail-price-body") ) {
        $(this).closest(".the-otaku-box-body").find(".retail-price-step").addClass("active");
        $(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select").addClass("show-retail-price");
        $(".retail-price-step").removeClass("selected");
        $(".retail-price-section").removeClass("show");
      }

      
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
         if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Weiter");
         } else {
           $(".otaku-box-offer-btn").html("Suivant");
         }
      } else {
         $(".otaku-box-offer-btn").html("Next");
      }
     
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").show(); 


      if ( $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").hasClass("otaku-box-offer-btn-post-purchase-start") ) {
        $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase-start");
        $(this).closest(".the-otaku-box-body").find(".main-digital-image-1").removeClass("hide-digital");
        $(this).closest(".the-otaku-box-body").find(".main-digital-image-2").addClass("hide-digital");
        $(this).closest(".the-otaku-box-body").find(".main-digital-image-3").addClass("hide-digital");
        $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").removeClass("post_purchase_step_image_2");
      }

      //$(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step .otaku-box-questions-select.selected").removeClass("selected");
      
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
});   
function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
if ( getUrlVars() !== undefined ) {
if ( $("#tripwire-url-1").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-1").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-1").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-2").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-2").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-2").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-3").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-3").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-3").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-4").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-4").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-4").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-5").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-5").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-5").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-6").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-6").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-6").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-7").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-7").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-7").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-8").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-8").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-8").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-9").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-9").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-9").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-10").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-10").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-10").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
}

$( document ).ready(function() {
  if ( getUrlVars() !== undefined ) {
    if ( getUrlVars()["figure"] ==  "rias" ) {
      $(".otaku-box-selected-offer-pre-step:not(.otaku-box-selected-offer-pre-step-v2) .otaku-box-questions-select[data-combination='1']").click();
      $(".otaku-box-offer-pre-btn").click();
      $(".otaku-box-selected-offer-pre-step").show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( ( getUrlVars()["figure"] ==  "leafa" ) || ( getUrlVars()["figure"] ==  "rem" ) || ( getUrlVars()["figure"] ==  "albedo" ) ) {
      $(".otaku-box-selected-offer-pre-step:not(.otaku-box-selected-offer-pre-step-v2) .otaku-box-questions-select[data-combination='2']").click();
      $(".otaku-box-offer-pre-btn").click();
      $(".otaku-box-selected-offer-pre-step").show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( getUrlVars()["figure"] ==  "rias-maid" ) {
      $(".otaku-box-selected-offer-pre-step:not(.otaku-box-selected-offer-pre-step-v2) .otaku-box-questions-select[data-combination='3']").click();
      $(".otaku-box-offer-pre-btn").click();
      $(".otaku-box-selected-offer-pre-step").show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
});  

$(document).ready(function() {
  function generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const urgencyNote = $('.urgency-note');
  if (urgencyNote.length > 0) {
    const randomNumber = generateRandomNumber(25, 50);
    urgencyNote.find('span').text(randomNumber);
  }
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-tob_offer_08"] && !Shopify.designMode) return;
  try {
    

let cookiePostUpsell = false;
  
document.querySelectorAll(".product-button").forEach(function(element) {
  element.addEventListener("click", function() {
    
    // Free Figures Button
    if (this.classList.contains("product-button-free-figures")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.add("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
      // SET ADDITIONAL STEPS
      document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-1").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-2").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-3").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-1").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-2").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-3").classList.remove("active");
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-1")) {
        document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-2").classList.add("active");
        document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-3").classList.add("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-2")) {
        document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-1").classList.add("active");
        document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-3").classList.add("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-3")) {
        document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-1").classList.add("active");
        document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-2").classList.add("active");
      }
      // SET IMAGES
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-1")) {
        document.querySelector("#figure-image-1").classList.add("active");
        document.querySelector("#figure-image-2").classList.remove("active");
        document.querySelector("#figure-image-3").classList.remove("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-2")) {
        document.querySelector("#figure-image-1").classList.remove("active");
        document.querySelector("#figure-image-2").classList.add("active");
        document.querySelector("#figure-image-3").classList.remove("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-3")) {
        document.querySelector("#figure-image-1").classList.remove("active");
        document.querySelector("#figure-image-2").classList.remove("active");
        document.querySelector("#figure-image-3").classList.add("active");
      }

      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }

    // Additional Figures Button
    if (this.classList.contains("product-button-additional-figures")) {
      // SET PRICE
      if ( !this.classList.contains("active") ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price + step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.add("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
      // SET IMAGES
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-1")) {
        document.querySelector("#figure-image-1").classList.add("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-2")) {
        document.querySelector("#figure-image-2").classList.add("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-3")) {
        document.querySelector("#figure-image-3").classList.add("active");
      }
    }

    // Additional Figures NO Button
    if (this.classList.contains("product-button-no-additional-figures")) {
      // SET PRICE
      let change_no = true;
      this.closest(".product-button-wrapper").querySelectorAll(".product-button-additional-figures").forEach(function(button) {
        if ( button != undefined ) {
          if ( !button.classList.contains("active") ) {
            change_no = false;
          }
        }
      });
      if ( !this.classList.contains("active") && change_no ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price - step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
      // SET IMAGES
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-1")) {
        document.querySelector("#figure-image-1").classList.remove("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-2")) {
        document.querySelector("#figure-image-2").classList.remove("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-3")) {
        document.querySelector("#figure-image-3").classList.remove("active");
      }
    }

    // Scale Figure Button
    if (this.classList.contains("product-button-scale-figure")) {
      // SET PRICE
      if ( !this.classList.contains("active") ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-2").classList.contains("active") ) {
          step_price = step_price * 3;
        }
        let current_price_rebill = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price + step_price;
        let new_price_rebill = current_price_rebill + step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        let new_price_curr_rebill = new_price_rebill.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
        document.getElementById('price-rebill').setAttribute('data-price', new_price_rebill );
        document.getElementById('price-rebill').innerHTML = new_price_curr_rebill;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      document.querySelector(".checkout-flow-step-scale-figure").classList.add("active");
      this.classList.add("active");
      // SET ID
      //document.querySelectorAll('.subscription-size').forEach(function(input) {
      //  input.value = '';
      //});
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
  
      }); 
      // SET IMAGE
      //document.querySelector("#tshirt-off").classList.remove("active");
      //document.querySelector("#tshirt-on").classList.add("active");
      
    }

    // Scale Figure NO Button
    if (this.classList.contains("product-button-no-scale-figure")) {
      // SET PRICE
      let change_no = true;
      this.closest(".product-button-wrapper").querySelectorAll(".product-button-scale-figure").forEach(function(button) {
        if ( button != undefined ) {
          if ( !button.classList.contains("active") ) {
            change_no = false;
          }
        }
      });
      if ( !this.classList.contains("active") && change_no ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-2").classList.contains("active") ) {
          step_price = step_price * 3;
        }
        let current_price_rebill = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price - step_price;
        let new_price_rebill = current_price_rebill - step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        let new_price_curr_rebill = new_price_rebill.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
        document.getElementById('price-rebill').setAttribute('data-price', new_price_rebill );
        document.getElementById('price-rebill').innerHTML = new_price_curr_rebill;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      document.querySelector(".checkout-flow-step-scale-figure").classList.remove("active");
      this.classList.add("active");
      // SET ID
      //document.querySelectorAll('.subscription-size').forEach(function(input) {
      //  input.value = 'No';
      //});
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 
      // SET IMAGE
      //document.querySelector("#tshirt-off").classList.add("active");
      //document.querySelector("#tshirt-on").classList.remove("active");      
    }

    // TShirt Button
    if (this.classList.contains("product-button-tshirt")) {
      // SET PRICE
      if ( !this.classList.contains("active") ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-2").classList.contains("active") ) {
          step_price = step_price * 3;
        }
        let current_price_rebill = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price + step_price;
        let new_price_rebill = current_price_rebill + step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        let new_price_curr_rebill = new_price_rebill.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
        document.getElementById('price-rebill').setAttribute('data-price', new_price_rebill );
        document.getElementById('price-rebill').innerHTML = new_price_curr_rebill;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      document.querySelectorAll('.subscription-size').forEach(function(input) {
        input.value = '';
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
        button.classList.add("flow-step-tshirt");
        button.classList.remove("flow-step-tshirt-size");
      }); 
      // SET IMAGE
      document.querySelector("#tshirt-off").classList.remove("active");
      document.querySelector("#tshirt-on").classList.add("active");
    }

    // TShirt NO Button
    if (this.classList.contains("product-button-no-tshirt")) {
      // SET PRICE
      let change_no = true;
      this.closest(".product-button-wrapper").querySelectorAll(".product-button-scale-figure").forEach(function(button) {
        if ( button != undefined ) {
          if ( !button.classList.contains("active") ) {
            change_no = false;
          }
        }
      });
      if ( !this.classList.contains("active") && change_no ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-2").classList.contains("active") ) {
          step_price = step_price * 3;
        }
        let current_price_rebill = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price - step_price;
        let new_price_rebill = current_price_rebill - step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        let new_price_curr_rebill = new_price_rebill.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
        document.getElementById('price-rebill').setAttribute('data-price', new_price_rebill );
        document.getElementById('price-rebill').innerHTML = new_price_curr_rebill;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      document.querySelectorAll('.subscription-size').forEach(function(input) {
        input.value = 'No';
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
        button.classList.remove("flow-step-tshirt");
        button.classList.add("flow-step-tshirt-size");
      }); 
      // SET IMAGE
      document.querySelector("#tshirt-off").classList.add("active");
      document.querySelector("#tshirt-on").classList.remove("active");
    }

    // TShirt SIZE Button
    if (this.classList.contains("product-button-tshirt-size")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      if (this.classList.contains("product-button-tshirt-size-s")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'Small';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-m")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'Medium';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-l")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'Large';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'XLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-2xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'XXLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-3xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = '3XLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-4xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = '4XLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-5xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = '5XLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-6xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = '6XLarge';
        });
      }
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 
    }

    // Ecchi Button
    if (this.classList.contains("product-button-ecchi")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      document.querySelectorAll('.subscription-ecchi').forEach(function(input) {
        input.value = 'Uncensored';
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 

      
      // SET ID
      let selected_size = document.querySelector('.subscription-size').value;
      let selected_ecchi = document.querySelector('.subscription-ecchi').value;
      let selected_option = selected_size + " / " + selected_ecchi;
      if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-1").classList.contains("active") || document.querySelector(".plan-box-wrapper .checkout-flow-step-product-2").classList.contains("active") ) {
        selected_option = selected_ecchi;
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-1").classList.contains("active") && selected_size != "No" ) {
          document.querySelectorAll(".checkout-flow-step-tshirt input").forEach(function(button) {
            button.classList.remove("active");
          });
          document.querySelector(".checkout-flow-step-tshirt .product-id.monthly[data-title='"+ selected_size + "']").classList.add("active");
          document.querySelector(".checkout-flow-step-tshirt .product-selling-plan.monthly[data-title='"+ selected_size + "']").classList.add("active");
        }
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-1").classList.contains("active") ) {
          document.querySelectorAll(".checkout-flow-step-scale-figure input").forEach(function(button) {
            button.classList.remove("active");
          });
          document.querySelector(".checkout-flow-step-scale-figure .product-id.monthly").classList.add("active");
          document.querySelector(".checkout-flow-step-scale-figure .product-selling-plan.monthly").classList.add("active");
        }
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-2").classList.contains("active") && selected_size != "No" ) {
          document.querySelectorAll(".checkout-flow-step-tshirt input").forEach(function(button) {
            button.classList.remove("active");
          });
          document.querySelector(".checkout-flow-step-tshirt .product-id.quarterly[data-title='"+ selected_size + "']").classList.add("active");
          document.querySelector(".checkout-flow-step-tshirt .product-selling-plan.quarterly[data-title='"+ selected_size + "']").classList.add("active");
        }
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-2").classList.contains("active") ) {
          document.querySelectorAll(".checkout-flow-step-scale-figure input").forEach(function(button) {
            button.classList.remove("active");
          });
          document.querySelector(".checkout-flow-step-scale-figure .product-id.quarterly").classList.add("active");
          document.querySelector(".checkout-flow-step-scale-figure .product-selling-plan.quarterly").classList.add("active");
        }
      }
      document.querySelectorAll(".plan-box-wrapper .checkout-flow-step-product.active input").forEach(function(button) {
        button.classList.remove("active");
      });
      document.querySelectorAll(".plan-box-wrapper .checkout-flow-step-product.active .freebie-product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      document.querySelectorAll(".plan-box-wrapper .checkout-flow-step-product.active input[data-title='"+ selected_option + "']").forEach(function(button) {
        button.classList.add("active");
      });
      document.querySelectorAll(".plan-box-wrapper .checkout-flow-step-product.active .freebie-product-id").forEach(function(button) {
        button.classList.add("active");
      });
    }

    // Ecchi NO Button
    if (this.classList.contains("product-button-no-ecchi")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      document.querySelectorAll('.subscription-ecchi').forEach(function(input) {
        input.value = 'Censored';
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 

      // SET ID
      let selected_size = document.querySelector('.subscription-size').value;
      let selected_ecchi = document.querySelector('.subscription-ecchi').value;
      let selected_option = selected_size + " / " + selected_ecchi;
      if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-1").classList.contains("active") || document.querySelector(".plan-box-wrapper .checkout-flow-step-product-2").classList.contains("active") ) {
        selected_option = selected_ecchi;
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-1").classList.contains("active") && selected_size != "No" ) {
          document.querySelectorAll(".checkout-flow-step-tshirt input").forEach(function(button) {
            button.classList.remove("active");
          });
          document.querySelector(".checkout-flow-step-tshirt .product-id.monthly[data-title='"+ selected_size + "']").classList.add("active");
          document.querySelector(".checkout-flow-step-tshirt .product-selling-plan.monthly[data-title='"+ selected_size + "']").classList.add("active");
        }
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-1").classList.contains("active") ) {
          document.querySelectorAll(".checkout-flow-step-scale-figure input").forEach(function(button) {
            button.classList.remove("active");
          });
          document.querySelector(".checkout-flow-step-scale-figure .product-id.monthly").classList.add("active");
          document.querySelector(".checkout-flow-step-scale-figure .product-selling-plan.monthly").classList.add("active");
        }
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-2").classList.contains("active") && selected_size != "No" ) {
          document.querySelectorAll(".checkout-flow-step-tshirt input").forEach(function(button) {
            button.classList.remove("active");
          });
          document.querySelector(".checkout-flow-step-tshirt .product-id.quarterly[data-title='"+ selected_size + "']").classList.add("active");
          document.querySelector(".checkout-flow-step-tshirt .product-selling-plan.quarterly[data-title='"+ selected_size + "']").classList.add("active");
        }
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-2").classList.contains("active") ) {
          document.querySelectorAll(".checkout-flow-step-scale-figure input").forEach(function(button) {
            button.classList.remove("active");
          });
          document.querySelector(".checkout-flow-step-scale-figure .product-id.quarterly").classList.add("active");
          document.querySelector(".checkout-flow-step-scale-figure .product-selling-plan.quarterly").classList.add("active");
        }
      }
      document.querySelectorAll(".plan-box-wrapper .checkout-flow-step-product.active input").forEach(function(button) {
        button.classList.remove("active");
      });
      document.querySelectorAll(".plan-box-wrapper .checkout-flow-step-product.active .freebie-product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      
      document.querySelectorAll(".plan-box-wrapper .checkout-flow-step-product.active input[data-title='"+ selected_option + "']").forEach(function(button) {
        button.classList.add("active");
      });
      document.querySelectorAll(".plan-box-wrapper .checkout-flow-step-product.active .freebie-product-id").forEach(function(button) {
        button.classList.add("active");
      });
    }

    // Plan Selection Button
    if (this.classList.contains("plan-box")) {
      // SET PRICE
      if ( !this.closest(".checkout-flow-step-product").classList.contains("active") ) {
        let current_price_rebill = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let current_price_today = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price_today - current_price_rebill;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
        if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-1") || this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-4") ) {
          let step_price = 0;
          step_price = parseFloat( this.closest(".checkout-flow-step-product").getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
          let new_price = step_price;
          let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
          document.getElementById('price-rebill').setAttribute('data-price', new_price );
          document.getElementById('price-rebill').innerHTML = new_price_curr;
          if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-1")  ) {
            document.getElementById('price-rebill-note').innerHTML = "Due Every Month";
          } else {
            document.getElementById('price-rebill-note').innerHTML = "Annual Pass Price";
          }
        }
        if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-2") ) {
          let step_price = 0;
          step_price = 3 * parseFloat( this.closest(".checkout-flow-step-product").getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
          let new_price = step_price;
          let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
          document.getElementById('price-rebill').setAttribute('data-price', new_price );
          document.getElementById('price-rebill').innerHTML = new_price_curr;
          document.getElementById('price-rebill-note').innerHTML = "Due Every 3 Months";
        }
        if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-3") ) {
          let step_price = 0;  
          step_price = 6 * parseFloat( this.closest(".checkout-flow-step-product").getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
          let new_price = step_price;
          let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
          document.getElementById('price-rebill').setAttribute('data-price', new_price );
          document.getElementById('price-rebill').innerHTML = new_price_curr;
          document.getElementById('price-rebill-note').innerHTML = "Due Every 6 Months";
        }
        current_price_rebill = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        current_price_today = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        new_price = current_price_today + current_price_rebill;
        new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".checkout-flow-step-product").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").classList.add("active");
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 
      // SET BAR
      document.querySelectorAll(".view-items-bar").forEach(function(button) {
        button.classList.remove("active");
      }); 
      if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-2") ) {
        document.getElementById('3months-bar').classList.add("active");
      }
      if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-3") ) {
        document.getElementById('6months-bar').classList.add("active");
      }
      if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-4") ) {
        document.getElementById('12months-bar').classList.add("active");
      }
      
      if ( this.classList.contains("plan-box-6months") ||  this.classList.contains("plan-box-annual") ) {
        document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("longer-plan");
        }); 
      } else {
        document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("longer-plan");
        }); 
      }

    }

    // Upsell Button
    if (this.classList.contains("product-button-upsell")) {
      // SET PRICE
      if ( !this.classList.contains("active") ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price + step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.add("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".freebie-product-id").forEach(function(button) {
        button.classList.add("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".teaser-product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
    }

    // Upsell NO Button
    if (this.classList.contains("product-button-no-upsell")) {
      // SET PRICE
      let change_no = true;
      this.closest(".product-button-wrapper").querySelectorAll(".product-button-upsell").forEach(function(button) {
        if ( button != undefined ) {
          if ( !button.classList.contains("active") ) {
            change_no = false;
          }
        }
      });
      if ( !this.classList.contains("active") && change_no ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price - step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".freebie-product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".teaser-product-id").forEach(function(button) {
        button.classList.add("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
    }
    
  });
});


document.querySelectorAll(".checkout-flow-button").forEach(function(element) {
  element.addEventListener("click", function() {
    
    // Free Figures NEXT Button
    if (this.classList.contains("flow-step-free")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-free");
      this.classList.add("flow-step-additional-figure");
      // STEP
      document.querySelectorAll(".checkout-flow-step-1").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-2").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-1").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-2").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-button-note").forEach(function(button) {
          button.style.display = "none";
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.add("active");
      }); 
    }

    // Additional Figures NEXT Button
    else if (this.classList.contains("flow-step-additional-figure")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-additional-figure");
      this.classList.add("flow-step-additional-figure-2");
      // STEP
      document.querySelectorAll(".checkout-flow-step-2").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-3").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-2").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-3").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-additional-figure");
          button.classList.add("back-additional-figure-2");
      }); 
    }

    // Additional Figures NEXT Button
    else if (this.classList.contains("flow-step-additional-figure-2")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-additional-figure-2");
      this.classList.add("flow-step-plan-selection");
      // STEP
      document.querySelectorAll(".checkout-flow-step-3").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-3").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-additional-figure-2");
          button.classList.add("back-plan-selection");
      }); 
    }

    // Plan Selection NEXT Button
    else if (this.classList.contains("flow-step-plan-selection")) {
      this.classList.remove("active");

      if ( this.classList.contains("longer-plan") ) {

        this.classList.remove("flow-step-plan-selection");
        this.classList.remove("longer-plan");
        this.classList.add("flow-step-tshirt-size");
        // STEP
        document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
            button.classList.remove("active");
        }); 
        document.querySelectorAll(".checkout-flow-step-6").forEach(function(button) {
            button.classList.add("active");
        }); 
        // NAV
        document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
            button.classList.remove("active");
            button.classList.add("past");
        }); 
        document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
            button.classList.remove("active");
            button.classList.add("past");
        }); 
        document.querySelectorAll(".checkout-flow-step-nav-6").forEach(function(button) {
            button.classList.add("active");
        }); 
        // TSHIRT CHANGE
        document.querySelectorAll(".checkout-flow-step-tshirt-1").forEach(function(button) {
            button.classList.remove("active");
        });
        document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
            button.classList.remove("active");
        });
        document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
            button.classList.remove("active");
        });
        document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
            button.classList.add("active");
        });
        document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
            button.classList.add("active");
        });
        document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
            button.classList.add("active");
        });
        //BACK
        document.querySelectorAll(".back-button").forEach(function(button) {
            button.classList.remove("back-plan-selection");
            button.classList.add("back-tshirt-size");
            button.classList.add("longer-plan");
        }); 
        
      } else {
      
      this.classList.remove("flow-step-plan-selection");
      this.classList.add("flow-step-scale-figure");
      // STEP
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-plan-selection");
          button.classList.remove("longer-plan");
          button.classList.add("back-scale-figure");
      }); 

      }
        
    }

    // Scale Figure NEXT Button
    else if (this.classList.contains("flow-step-scale-figure")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-scale-figure");
      this.classList.add("flow-step-tshirt");
      // STEP
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-6").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-6").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-scale-figure");
          button.classList.add("back-tshirt");
      }); 
    }  

    // TShirt NEXT Button
    else if (this.classList.contains("flow-step-tshirt")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-tshirt");
      this.classList.add("flow-step-tshirt-size");
      // TSHIRT CHANGE
      document.querySelectorAll(".checkout-flow-step-tshirt-1").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
          button.classList.add("active");
      });
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-tshirt");
          button.classList.add("back-tshirt-size");
      }); 
    }

    // TShirt Size NEXT Button
    else if (this.classList.contains("flow-step-tshirt-size")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-tshirt-size");
      this.classList.add("flow-step-ecchi");
      document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
          button.classList.remove("active");
      });
      // STEP
      document.querySelectorAll(".checkout-flow-step-6").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-7").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-6").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-7").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-tshirt-size");
          button.classList.remove("back-tshirt");
          button.classList.add("back-ecchi");
      }); 
    }

    // Ecchi NEXT Button
    else if (this.classList.contains("flow-step-ecchi")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-ecchi");
      this.classList.add("flow-step-finish");
      // STEP
      document.querySelectorAll(".checkout-flow-step-7").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-8").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-7").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-8").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-ecchi");
          button.classList.remove("back-tshirt");
          button.classList.remove("back-tshirt-size");
          button.classList.add("back-finish");
      }); 
    }

    // Flow Step Finish
    else if (this.classList.contains("flow-step-finish")) {

      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      let free_figure_id = ""
      document.querySelectorAll(".checkout-flow-step-1 .product-id.active").forEach(function(button) {
          free_figure_id = button.value;
      }); 
      if ( free_figure_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + free_figure_id + "%26items[][quantity]=1%26";
      }
      let additional_figure_id = ""
      document.querySelectorAll(".checkout-flow-step-2 .product-id.active").forEach(function(button) {
          additional_figure_id = button.value;
      }); 
      if ( additional_figure_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + additional_figure_id + "%26items[][quantity]=1%26";
      }
      let additional_figure_2_id = ""
      document.querySelectorAll(".checkout-flow-step-3 .product-id.active").forEach(function(button) {
          additional_figure_2_id = button.value;
      }); 
      if ( additional_figure_2_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + additional_figure_2_id + "%26items[][quantity]=1%26";
      }
      
      let box_product_id = "";
      document.querySelectorAll(".checkout-flow-step-4 .product-id.active").forEach(function(button) {
          box_product_id = button.value;
      }); 
      let box_product_plan = "";
      document.querySelectorAll(".checkout-flow-step-4 .product-selling-plan.active").forEach(function(button) {
          box_product_plan = button.value;
      }); 
      if ( ( box_product_id != "" ) && ( box_product_plan != "" ) ) {
        checkout_url = checkout_url + "items[][id]=" + box_product_id + "%26items[][selling_plan]=" + box_product_plan + "%26items[][quantity]=1%26";
      } else if ( box_product_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + box_product_id + "%26items[][quantity]=1%26";
      }

      let tshirt_product_id = "";
      document.querySelectorAll(".checkout-flow-step-6 .product-id.active").forEach(function(button) {
          tshirt_product_id = button.value;
      }); 
      let tshirt_product_plan = "";
      document.querySelectorAll(".checkout-flow-step-6 .product-selling-plan.active").forEach(function(button) {
          tshirt_product_plan = button.value;
      }); 
      if ( ( tshirt_product_id != "" ) && ( tshirt_product_plan != "" ) ) {
        checkout_url = checkout_url + "items[][id]=" + tshirt_product_id + "%26items[][selling_plan]=" + tshirt_product_plan + "%26items[][quantity]=1%26";
      } 


      let scale_figure_product_id = "";
      document.querySelectorAll(".checkout-flow-step-scale-figure.active .product-id.active").forEach(function(button) {
          scale_figure_product_id = button.value;
      }); 
      let scale_figure_product_plan = "";
      document.querySelectorAll(".checkout-flow-step-scale-figure.active .product-selling-plan.active").forEach(function(button) {
          scale_figure_product_plan = button.value;
      }); 
      if ( ( scale_figure_product_id != "" ) && ( scale_figure_product_plan != "" ) ) {
        checkout_url = checkout_url + "items[][id]=" + scale_figure_product_id + "%26items[][selling_plan]=" + scale_figure_product_plan + "%26items[][quantity]=1%26";
      } 

      
      let freebie_id = "";
      document.querySelectorAll(".checkout-flow-step-4 .freebie-product-id.active").forEach(function(button) {
          if ( button.value != undefined ) {
            freebie_id = freebie_id + "items[][id]=" + button.value + "%26items[][quantity]=1%26";
          }
      });
      if ( freebie_id != "" ) {
        checkout_url = checkout_url + freebie_id;
      }
      let digital_upsell_id = ""
      document.querySelectorAll(".checkout-flow-step-8 .product-id.active").forEach(function(button) {
          digital_upsell_id = button.value;
      }); 
      if ( digital_upsell_id != "" ) {
        cookiePostUpsell = "waifu";
        checkout_url = checkout_url + "items[][id]=" + digital_upsell_id + "%26items[][quantity]=1%26";
      }
      let digital_freebie_id = "";
      document.querySelectorAll(".checkout-flow-step-8 .freebie-product-id.active").forEach(function(button) {
          if ( button.value != undefined ) {
            digital_freebie_id = digital_freebie_id + "items[][id]=" + button.value + "%26items[][quantity]=1%26";
          }
      });
      if ( digital_freebie_id != "" ) {
        checkout_url = checkout_url + digital_freebie_id;
      }
      let teaser_id = "";
      document.querySelectorAll(".checkout-flow-step-8 .teaser-product-id.active").forEach(function(button) {
          if ( button.value != undefined ) {
            teaser_id = teaser_id + "items[][id]=" + button.value + "%26items[][quantity]=1%26";
          }
      });
      if ( teaser_id != "" ) {
        checkout_url = checkout_url + teaser_id;
      }
     
      cookieExpiry = new Date(Date.now() + 86400e3).toUTCString(); // Set expiry to one day
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=.theotakubox.com;path=/;expires=${cookieExpiry};SameSite=None; Secure`;
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=theotakubox.com;expires=${cookieExpiry};SameSite=None; Secure`;
      let checkout_local_url = $("#local_url").val();
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout";
	  jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });	
      setTimeout(function(){  document.querySelectorAll(".the-otaku-box-spinner").forEach(function(button) { button.style.display = "block"; }) }, 100);
      setTimeout(function(){  window.location.href = checkout_url; }, 500);
      
    }
    
  });
});  


document.querySelectorAll(".back-button").forEach(function(element) {
  element.addEventListener("click", function() {
    
    // Additional Figures BACK Button
    if (this.classList.contains("back-additional-figure")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("active");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-additional-figure");
          button.classList.remove("active");
          button.classList.add("flow-step-free");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-2").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-1").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-1").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-2").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-1 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-2 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
      // SET PRICE
      let new_price = 0;
      let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
      document.getElementById('price-today').setAttribute('data-price', new_price );
      document.getElementById('price-today').innerHTML = new_price_curr;
    }  

    // Additional Figures 2 BACK Button
    if (this.classList.contains("back-additional-figure-2")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-additional-figure-2");
          button.classList.add("back-additional-figure");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-additional-figure-2");
          button.classList.remove("active");
          button.classList.add("flow-step-additional-figure");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-3").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-2").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-2").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-3").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-2 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-3 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
      // SET PRICE
      let new_price = 0;
      let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
      document.getElementById('price-today').setAttribute('data-price', new_price );
      document.getElementById('price-today').innerHTML = new_price_curr;
    }  

    // PLAN SELECTION BACK Button
    if (this.classList.contains("back-plan-selection")) {
      // SET PRICE
      let today_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
      let rebill_price = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
      let new_price = today_price - rebill_price;
      let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
      document.getElementById('price-today').setAttribute('data-price', new_price );
      document.getElementById('price-today').innerHTML = new_price_curr;
      document.getElementById('price-rebill').setAttribute('data-price', '0' );
      document.getElementById('price-rebill').innerHTML = "$0.00";
      document.getElementById('price-rebill-note').innerHTML = "Due Every Month";

      if ( document.querySelector('.checkout-flow-step-3 .checkout-flow-step-product.active .product-button-additional-figures').classList.contains('active') ) {
        let step_price = parseFloat( document.querySelector('.checkout-flow-step-3 .checkout-flow-step-product.active .product-button-additional-figures').getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price - step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      } 
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-plan-selection");
          button.classList.add("back-additional-figure-2");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-plan-selection");
          button.classList.remove("active");
          button.classList.add("flow-step-additional-figure-2");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-3").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-3").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-3 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-4 .checkout-flow-step-product").forEach(function(button) {
          button.classList.remove("active");
      });
    }  

    // BACK Scale Figure Button
    if (this.classList.contains("back-scale-figure")) {
      
      // SET PRICE
      let today_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
      let rebill_price = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
      let new_price = today_price - rebill_price;
      let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
      document.getElementById('price-today').setAttribute('data-price', new_price );
      document.getElementById('price-today').innerHTML = new_price_curr;
      document.getElementById('price-rebill').setAttribute('data-price', '0' );
      document.getElementById('price-rebill').innerHTML = "$0.00";
      document.getElementById('price-rebill-note').innerHTML = "Due Every Month";
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-scale-figure");
          button.classList.add("back-plan-selection");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-scale-figure");
          button.classList.remove("active");
          button.classList.add("flow-step-plan-selection");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-4 .checkout-flow-step-product").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });  
      // SET BAR
      document.querySelectorAll(".view-items-bar").forEach(function(button) {
          button.classList.remove("active");
      });
      
    }  

    // TSIRT BACK Button
    if (this.classList.contains("back-tshirt")) {

      // SET PRICE
      if ( document.querySelector(".product-button-tshirt").classList.contains("active") ) {
        let step_price = parseFloat( document.querySelector(".product-button-tshirt").getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-2").classList.contains("active") ) {
          step_price = step_price * 3;
        }
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let current_price_rebill = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price - step_price;
        let new_price_rebill = current_price_rebill - step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        let new_price_curr_rebill = new_price_rebill.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
        document.getElementById('price-rebill').setAttribute('data-price', new_price_rebill );
        document.getElementById('price-rebill').innerHTML = new_price_curr_rebill;
      }
      
      if ( document.querySelector(".product-button-scale-figure").classList.contains("active") ) {
        let step_price = parseFloat( document.querySelector(".product-button-scale-figure").getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        if ( document.querySelector(".plan-box-wrapper .checkout-flow-step-product-2").classList.contains("active") ) {
          step_price = step_price * 3;
        }
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let current_price_rebill = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price - step_price;
        let new_price_rebill = current_price_rebill - step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        let new_price_curr_rebill = new_price_rebill.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
        document.getElementById('price-rebill').setAttribute('data-price', new_price_rebill );
        document.getElementById('price-rebill').innerHTML = new_price_curr_rebill;
      }
      
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-tshirt");
          button.classList.add("back-scale-figure");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-tshirt");
          button.classList.remove("active");
          button.classList.add("flow-step-scale-figure");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-6").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-6").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-6 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });

      // TSHIRT CHANGE
      document.querySelectorAll(".checkout-flow-step-tshirt-1").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
          button.classList.remove("active");
      });
      
    }  

    // TSIRT SIZE BACK Button
    if (this.classList.contains("back-tshirt-size")) {

      if (this.classList.contains("longer-plan")) {

        // SET PRICE
        let today_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let rebill_price = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = today_price - rebill_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
        document.getElementById('price-rebill').setAttribute('data-price', '0' );
        document.getElementById('price-rebill').innerHTML = "$0.00";
        document.getElementById('price-rebill-note').innerHTML = "Due Every Month";
        // BACK BUTTON
        document.querySelectorAll(".back-button").forEach(function(button) {
            button.classList.remove("back-tshirt-size");
            button.classList.remove("longer-plan");
            button.classList.add("back-plan-selection");
        });
        // FLOW BUTTON
        document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
            button.classList.remove("flow-step-tshirt-size");
            button.classList.remove("active");
            button.classList.add("flow-step-plan-selection");
        });
        // NAV
        document.querySelectorAll(".checkout-flow-step-nav-6").forEach(function(button) {
            button.classList.remove("active");
            button.classList.remove("past");
        }); 
        document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
            button.classList.remove("active");
            button.classList.remove("past");
        }); 
        document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
            button.classList.remove("past");  
            button.classList.add("active");
        }); 
        // GO BACK
        document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
            button.classList.add("active");
        }); 
        document.querySelectorAll(".checkout-flow-step-6").forEach(function(button) {
            button.classList.remove("active");
        });
        // PRODUCT BUTTON
        document.querySelectorAll(".checkout-flow-step-4 .checkout-flow-step-product").forEach(function(button) {
            button.classList.remove("active");
        }); 
        document.querySelectorAll(".checkout-flow-step-6 .product-button").forEach(function(button) {
            button.classList.remove("active");
        });
        // SET BAR
        document.querySelectorAll(".view-items-bar").forEach(function(button) {
          button.classList.remove("active");
        });

        // TSHIRT CHANGE
        document.querySelectorAll(".checkout-flow-step-tshirt-1").forEach(function(button) {
            button.classList.add("active");
        });
        document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
            button.classList.add("active");
        });
        document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
            button.classList.add("active");
        });
        document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
            button.classList.remove("active");
        });
        document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
            button.classList.remove("active");
        });
        document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
            button.classList.remove("active");
        });

      } else {

        // BACK BUTTON
        document.querySelectorAll(".back-button").forEach(function(button) {
            button.classList.remove("back-tshirt-size");
            button.classList.add("back-tshirt");
        });
        // FLOW BUTTON
        document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
            button.classList.remove("flow-step-tshirt-size");
            button.classList.remove("active");
            button.classList.add("flow-step-tshirt");
        });
        // TSHIRT CHANGE
        document.querySelectorAll(".checkout-flow-step-tshirt-1").forEach(function(button) {
            button.classList.add("active");
        });
        document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
            button.classList.add("active");
        });
        document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
            button.classList.add("active");
        });
        document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
            button.classList.remove("active");
        });
        document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
            button.classList.remove("active");
        });
        document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
            button.classList.remove("active");
        });
        // PRODUCT BUTTON
        document.querySelectorAll(".checkout-flow-step-4 .product-button").forEach(function(button) {
            button.classList.remove("active");
        }); 
        document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
            button.classList.remove("active");
        });
      }

    }  

    // ECCHI BACK Button
    if (this.classList.contains("back-ecchi")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-ecchi");
          button.classList.add("back-tshirt-size");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-ecchi");
          button.classList.remove("active");
          button.classList.add("flow-step-tshirt-size");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-7").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-6").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-6").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-7").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-6 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-7 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
    }

    // BACK FINISH Button
    if (this.classList.contains("back-finish")) {
      // SET PRICE
      if ( document.querySelector(".product-button-upsell").classList.contains("active") ) {
        let step_price = parseFloat( document.querySelector(".product-button-upsell").getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price - step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-finish");
          button.classList.add("back-ecchi");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-finish");
          button.classList.remove("active");
          button.classList.add("flow-step-ecchi");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-8").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-7").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-7").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-8").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-7 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-8 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
      
      
    }  




    
  }); 
}); 

document.getElementById('tshirt-select').addEventListener('change', function() {
    var selectedSize = this.value;
    var buttons = document.querySelectorAll('.product-button-tshirt-size-' + selectedSize);
    if (buttons.length > 0) {
        buttons[0].click();
    } else {
        console.error('Button not found for size: ' + selectedSize);
    }
});
document.addEventListener("DOMContentLoaded", function() {
  function generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const urgencyNote = document.getElementById('visitors');
  if (urgencyNote) {
    const randomNumber = generateRandomNumber(25, 50);
    urgencyNote.textContent = randomNumber;
  }
});

document.addEventListener("DOMContentLoaded", function() {
  var numberBoxes = document.querySelectorAll('.number-box');
  numberBoxes.forEach(function(box) {
    var randomNumber = Math.floor(Math.random() * 49) + 1; // Generate random number between 1 and 99
    var randomNumberStr = randomNumber < 10 ? String(randomNumber) : String(randomNumber);
    var firstDigit = randomNumberStr[0];
    var secondDigit = randomNumberStr[1];

    var firstNumber = document.createElement('div');
    firstNumber.className = 'number';
    firstNumber.textContent = firstDigit;
    box.appendChild(firstNumber);

    var secondNumber = document.createElement('div');
    secondNumber.className = 'number';
    secondNumber.textContent = secondDigit;
    box.appendChild(secondNumber);
  });
});

function getUrlVars() {
  var vars = {};
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    var hash = hashes[i].split('=');
    vars[hash[0]] = hash[1];
  }
  return vars;
}

document.addEventListener("DOMContentLoaded", function() {
  var urlVars = getUrlVars();  
  if (urlVars !== undefined) {
    if (urlVars["figure"] == "first" || urlVars["figure"] == "rias") {
      document.querySelector(".checkout-flow-step-free-figures .checkout-flow-step-product-1 .product-button").click();
      document.querySelector(".checkout-flow-button").click();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (urlVars["figure"] == "second" || urlVars["figure"] == "rem") {
      document.querySelector(".checkout-flow-step-free-figures .checkout-flow-step-product-2 .product-button").click();
      document.querySelector(".checkout-flow-button").click();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (urlVars["figure"] == "third" || urlVars["figure"] == "rias-maid") {
      document.querySelector(".checkout-flow-step-free-figures .checkout-flow-step-product-3 .product-button").click();
      document.querySelector(".checkout-flow-button").click();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-tob_offer_09"] && !Shopify.designMode) return;
  try {
    

let cookiePostUpsell = "yaoi";
  
document.querySelectorAll(".product-button").forEach(function(element) {
  element.addEventListener("click", function() {
    
    // Free Figures Button
    if (this.classList.contains("product-button-free-figures")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.add("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
      // SET ADDITIONAL STEPS
      document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-1").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-2").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-3").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-1").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-2").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-3").classList.remove("active");
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-1")) {
        document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-2").classList.add("active");
        document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-3").classList.add("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-2")) {
        document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-1").classList.add("active");
        document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-3").classList.add("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-3")) {
        document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-1").classList.add("active");
        document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-2").classList.add("active");
      }
      // SET IMAGES
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-1")) {
        document.querySelector("#figure-image-1").classList.add("active");
        document.querySelector("#figure-image-2").classList.remove("active");
        document.querySelector("#figure-image-3").classList.remove("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-2")) {
        document.querySelector("#figure-image-1").classList.remove("active");
        document.querySelector("#figure-image-2").classList.add("active");
        document.querySelector("#figure-image-3").classList.remove("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-3")) {
        document.querySelector("#figure-image-1").classList.remove("active");
        document.querySelector("#figure-image-2").classList.remove("active");
        document.querySelector("#figure-image-3").classList.add("active");
      }

      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }

    // Additional Figures Button
    if (this.classList.contains("product-button-additional-figures")) {
      // SET PRICE
      if ( !this.classList.contains("active") ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price + step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        //document.getElementById('price-today').setAttribute('data-price', new_price );
        //document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-selling-plan").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.add("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".product-selling-plan").forEach(function(button) {
        button.classList.add("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
      // SET IMAGES
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-1")) {
        document.querySelector("#figure-image-1").classList.add("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-2")) {
        document.querySelector("#figure-image-2").classList.add("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-3")) {
        document.querySelector("#figure-image-3").classList.add("active");
      }
    }

    // Additional Figures NO Button
    if (this.classList.contains("product-button-no-additional-figures")) {
      // SET PRICE
      let change_no = true;
      this.closest(".product-button-wrapper").querySelectorAll(".product-button-additional-figures").forEach(function(button) {
        if ( button != undefined ) {
          if ( !button.classList.contains("active") ) {
            change_no = false;
          }
        }
      });
      if ( !this.classList.contains("active") && change_no ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price - step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-selling-plan").forEach(function(button) {
        button.classList.remove("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
      // SET IMAGES
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-1")) {
        document.querySelector("#figure-image-1").classList.remove("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-2")) {
        document.querySelector("#figure-image-2").classList.remove("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-3")) {
        document.querySelector("#figure-image-3").classList.remove("active");
      }
    }

    // TShirt Button
    if (this.classList.contains("product-button-tshirt")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      document.querySelectorAll('.subscription-size').forEach(function(input) {
        input.value = '';
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
        button.classList.add("flow-step-tshirt");
        button.classList.remove("flow-step-tshirt-size");
      }); 
      // SET IMAGE
      //document.querySelector("#tshirt-off").classList.remove("active");
      //document.querySelector("#tshirt-on").classList.add("active");
    }

    // TShirt NO Button
    if (this.classList.contains("product-button-no-tshirt")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      document.querySelectorAll('.subscription-size').forEach(function(input) {
        input.value = 'No';
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
        button.classList.remove("flow-step-tshirt");
        //button.classList.add("flow-step-tshirt-size");
      }); 
      // SET IMAGE
      //document.querySelector("#tshirt-off").classList.add("active");
      //document.querySelector("#tshirt-on").classList.remove("active");

      let selected_size = document.querySelector('.subscription-size').value;
      let selected_option = selected_size;
      document.querySelector(".checkout-flow-step-plan-selection").querySelectorAll("input").forEach(function(button) {
        button.classList.remove("active");
      });
      document.querySelector(".checkout-flow-step-product.active").querySelectorAll("input[data-title='"+ selected_option + "']").forEach(function(button) {
        button.classList.add("active");
      });
      document.querySelector(".checkout-flow-step-product.active").querySelectorAll(".freebie-product-id").forEach(function(button) {
        button.classList.add("active");
      });
    }

    // TShirt SIZE Button
    if (this.classList.contains("product-button-tshirt-size")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      if (this.classList.contains("product-button-tshirt-size-xs")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'XSmall';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-s")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'Small';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-m")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'Medium';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-l")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'Large';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'XLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-2xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'XXLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-3xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = '3XLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-4xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = '4XLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-5xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = '5XLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-6xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = '6XLarge';
        });
      }

      let selected_size = document.querySelector('.subscription-size').value;
      let selected_option = selected_size;
      document.querySelector(".checkout-flow-step-plan-selection").querySelectorAll("input").forEach(function(button) {
        button.classList.remove("active");
      });
      document.querySelector(".checkout-flow-step-product.active").querySelectorAll("input[data-title='"+ selected_option + "']").forEach(function(button) {
        button.classList.add("active");
      });
      document.querySelector(".checkout-flow-step-product.active").querySelectorAll(".freebie-product-id").forEach(function(button) {
        button.classList.add("active");
      });

      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 
    }

    // Ecchi Button
    if (this.classList.contains("product-button-ecchi")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      document.querySelectorAll('.subscription-ecchi').forEach(function(input) {
        input.value = 'Uncensored';
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 
    }

    // Ecchi NO Button
    if (this.classList.contains("product-button-no-ecchi")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      document.querySelectorAll('.subscription-ecchi').forEach(function(input) {
        input.value = 'Censored';
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 
    }

    // Plan Selection Button
    if (this.classList.contains("plan-box")) {
      // SET ID
      let selected_size = document.querySelector('.subscription-size').value;
      let selected_ecchi = document.querySelector('.subscription-ecchi').value;
      let selected_option = selected_size;
      this.closest(".checkout-flow-step-wrapper").querySelectorAll("input").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll("input[data-title='"+ selected_option + "']").forEach(function(button) {
        button.classList.add("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".freebie-product-id").forEach(function(button) {
        button.classList.add("active");
      });
      // SET PRICE
      if ( !this.closest(".checkout-flow-step-product").classList.contains("active") ) {
        let current_price_rebill = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let current_price_today = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price_today - current_price_rebill;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        //document.getElementById('price-today').setAttribute('data-price', new_price );
        //document.getElementById('price-today').innerHTML = new_price_curr;
        if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-1") ) {
          let step_price = 0;
          this.closest(".checkout-flow-step-product").querySelectorAll(".product-id.active").forEach(function(button) {
            if ( button.value != undefined ) {
              step_price = parseFloat( button.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
            }
          });
          let new_price = step_price;
          let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
          document.getElementById('price-rebill').setAttribute('data-price', new_price );
          document.getElementById('price-rebill').innerHTML = new_price_curr;
          if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-1")  ) {
            document.getElementById('price-rebill-note').innerHTML = "Due Every Month";
          } else {
            document.getElementById('price-rebill-note').innerHTML = "Due Every Year";
          }
        }
        if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-2") ) {
          let step_price = 0;
          this.closest(".checkout-flow-step-product").querySelectorAll(".product-id.active").forEach(function(button) {
            if ( button.value != undefined ) {
              step_price = 3 * parseFloat( button.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
            }
          });
          let new_price = step_price;
          let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
          document.getElementById('price-rebill').setAttribute('data-price', new_price );
          document.getElementById('price-rebill').innerHTML = new_price_curr;
          document.getElementById('price-rebill-note').innerHTML = "Due Every 3 Months";
        }
        if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-3") ) {
          let step_price = 0;
          this.closest(".checkout-flow-step-product").querySelectorAll(".product-id.active").forEach(function(button) {
            if ( button.value != undefined ) {
              step_price = 6 * parseFloat( button.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
            }
          });
          let new_price = step_price;
          let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
          document.getElementById('price-rebill').setAttribute('data-price', new_price );
          document.getElementById('price-rebill').innerHTML = new_price_curr;
          document.getElementById('price-rebill-note').innerHTML = "Due Every 6 Months";
        }
        if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-4") ) {
          let step_price = 0;
          this.closest(".checkout-flow-step-product").querySelectorAll(".product-id.active").forEach(function(button) {
            if ( button.value != undefined ) {
              step_price = 12 * parseFloat( button.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
            }
          });
          let new_price = step_price;
          let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
          document.getElementById('price-rebill').setAttribute('data-price', new_price );
          document.getElementById('price-rebill').innerHTML = new_price_curr;
          document.getElementById('price-rebill-note').innerHTML = "Due Every 12 Months";
        }
        current_price_rebill = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        current_price_today = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        new_price = current_price_today + current_price_rebill;
        new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        //document.getElementById('price-today').setAttribute('data-price', new_price );
        //document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".checkout-flow-step-product").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").classList.add("active");
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 
      // SET BAR
      document.querySelectorAll(".view-items-bar").forEach(function(button) {
        button.classList.remove("active");
      }); 
      if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-2") ) {
        document.getElementById('3months-bar').classList.add("active");
      }
      if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-3") ) {
        document.getElementById('6months-bar').classList.add("active");
      }
      if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-4") ) {
        document.getElementById('12months-bar').classList.add("active");
      }
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }

    // Upsell Button
    if (this.classList.contains("product-button-upsell")) {
      // SET PRICE
      if ( !this.classList.contains("active") ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price + step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.add("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".freebie-product-id").forEach(function(button) {
        button.classList.add("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".teaser-product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
    }

    // Upsell NO Button
    if (this.classList.contains("product-button-no-upsell")) {
      // SET PRICE
      let change_no = true;
      this.closest(".product-button-wrapper").querySelectorAll(".product-button-upsell").forEach(function(button) {
        if ( button != undefined ) {
          if ( !button.classList.contains("active") ) {
            change_no = false;
          }
        }
      });
      if ( !this.classList.contains("active") && change_no ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price - step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".freebie-product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".teaser-product-id").forEach(function(button) {
        button.classList.add("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
    }
    
  });
});

document.querySelectorAll(".no-tshirt").forEach(function(element) {
  element.addEventListener("click", function() {
    document.querySelectorAll('.subscription-size').forEach(function(input) {
      input.value = 'No';
    });




    let selected_size = document.querySelector('.subscription-size').value;
    let selected_option = selected_size;
    document.querySelector(".checkout-flow-step-plan-selection").querySelectorAll("input").forEach(function(button) {
      button.classList.remove("active");
    });
    document.querySelector(".checkout-flow-step-product.active").querySelectorAll("input[data-title='"+ selected_option + "']").forEach(function(button) {
      button.classList.add("active");
    });
    document.querySelector(".checkout-flow-step-product.active").querySelectorAll(".freebie-product-id").forEach(function(button) {
      button.classList.add("active");
    });

    // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      });
      document.querySelector('.checkout-flow-button')?.click();
      document.querySelectorAll(".product-button-tshirt-size").forEach(function(button) {
        button.classList.remove("active");
      });
    
  });
});

document.querySelectorAll(".checkout-flow-button").forEach(function(element) {
  element.addEventListener("click", function() {
    
    // Free Figures NEXT Button
    if (this.classList.contains("flow-step-free")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-free");
      this.classList.add("flow-step-additional-figure");
      this.classList.remove("yaoi-flow-step-free");
      this.classList.add("yaoi-flow-step-additional-figure");
      // STEP
      document.querySelectorAll(".checkout-flow-step-1").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-2").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-1").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-2").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-button-note").forEach(function(button) {
          button.style.display = "none";
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.add("active");
      }); 
    }

    // Additional Figures NEXT Button
    else if (this.classList.contains("flow-step-additional-figure-2")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-additional-figure-2");
      this.classList.add("flow-step-tshirt-size");
      this.classList.remove("yaoi-flow-step-additional-figure-2");
      this.classList.add("yaoi-flow-step-tshirt-size");
      // STEP
      document.querySelectorAll(".checkout-flow-step-3").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-3").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-additional-figure-2");
          button.classList.add("back-tshirt");
      }); 
    }

    // TShirt NEXT Button
    else if (this.classList.contains("flow-step-tshirt")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-tshirt");
      //this.classList.add("flow-step-tshirt-size");
      this.classList.remove("yaoi-flow-step-tshirt");
      //this.classList.add("yaoi-flow-step-tshirt-size");
      // TSHIRT CHANGE
      document.querySelectorAll(".checkout-flow-step-tshirt-1").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
          button.classList.add("active");
      });
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-tshirt");
          button.classList.add("back-tshirt-size");
      }); 
    }

    // TShirt Size NEXT Button
    else if (this.classList.contains("flow-step-tshirt-size")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-tshirt-size");
      this.classList.add("flow-step-finish");
      this.classList.remove("yaoi-flow-step-tshirt-size");
      this.classList.add("yaoi-flow-step-finish");
      document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
          button.classList.remove("active");
      });
      // STEP
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-tshirt-size");
          button.classList.remove("back-tshirt");
          button.classList.add("back-finish");
      }); 
    }

     // Additional Figures NEXT Button
    else if (this.classList.contains("flow-step-additional-figure")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-additional-figure");
      this.classList.add("flow-step-additional-figure-2");
      this.classList.remove("yaoi-flow-step-additional-figure");
      this.classList.add("yaoi-flow-step-additional-figure-2");
      // STEP
      document.querySelectorAll(".checkout-flow-step-2").forEach(function(button) {
          //button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-3").forEach(function(button) {
          //button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-2").forEach(function(button) {
          //button.classList.remove("active");
          //button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-3").forEach(function(button) {
          //button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-additional-figure");
          button.classList.add("back-additional-figure-2");
      }); 



      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?";

      let box_product_id = "";
      document.querySelectorAll(".checkout-flow-step-1 .product-id.active").forEach(function(button) {
          box_product_id = button.value;
      }); 
      let box_product_plan = "";
      document.querySelectorAll(".checkout-flow-step-1 .product-selling-plan.active").forEach(function(button) {
          box_product_plan = button.value;
      }); 
      if ( ( box_product_id != "" ) && ( box_product_plan != "" ) ) {
        checkout_url = checkout_url + "items[][id]=" + box_product_id + "%26items[][selling_plan]=" + box_product_plan + "%26items[][quantity]=1%26";
      } else if ( box_product_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + box_product_id + "%26items[][quantity]=1%26";
      }
      let freebie_id = "";
      document.querySelectorAll(".checkout-flow-step-1 .freebie-product-id.active").forEach(function(button) {
          if ( button.value != undefined ) {
            freebie_id = freebie_id + "items[][id]=" + button.value + "%26items[][quantity]=1%26";
          }
      });
      if ( freebie_id != "" ) {
        checkout_url = checkout_url + freebie_id;
      }

      cookieExpiry = new Date(Date.now() + 86400e3).toUTCString(); // Set expiry to one day
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=.theotakubox.com;path=/;expires=${cookieExpiry};SameSite=None; Secure`;
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=theotakubox.com;expires=${cookieExpiry};SameSite=None; Secure`;
      let checkout_local_url = $("#local_url").val();
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout";
	  jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });	
      setTimeout(function(){  document.querySelectorAll(".the-otaku-box-spinner").forEach(function(button) { button.style.display = "block"; }) }, 100);
      setTimeout(function(){  window.location.href = checkout_url; }, 500);





    }  

    // Ecchi NEXT Button
    else if (this.classList.contains("flow-step-ecchi")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-ecchi");
      this.classList.add("flow-step-plan-selection");
      // STEP
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-6").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-6").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-ecchi");
          button.classList.remove("back-tshirt");
          button.classList.remove("back-tshirt-size");
          button.classList.add("back-plan-selection");
      }); 
    }

    // Plan Selection NEXT Button
    else if (this.classList.contains("flow-step-plan-selection")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-plan-selection");
      this.classList.add("flow-step-finish");
      this.classList.remove("yaoi-flow-step-plan-selection");
      this.classList.add("yaoi-flow-step-finish");
      // STEP
      document.querySelectorAll(".checkout-flow-step-6").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-7").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-6").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-7").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-plan-selection");
          button.classList.add("back-finish");
      }); 
    }

    // Flow Step Finish
    else if (this.classList.contains("flow-step-finish")) {

      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      let free_figure_id = ""
      //document.querySelectorAll(".checkout-flow-step-1 .product-id.active").forEach(function(button) {
      //    free_figure_id = button.value;
      //}); 
      if ( free_figure_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + free_figure_id + "%26items[][quantity]=1%26";
      }
      let additional_figure_id = ""
      document.querySelectorAll(".checkout-flow-step-2 .product-id.active").forEach(function(button) {
          additional_figure_id = button.value;
      }); 
      let additional_figure_plan = "";
      document.querySelectorAll(".checkout-flow-step-2 .product-selling-plan.active").forEach(function(button) {
          additional_figure_plan = button.value;
      }); 
      if ( ( additional_figure_id != "" ) && ( additional_figure_plan != "" ) ) {
        checkout_url = checkout_url + "items[][id]=" + additional_figure_id + "%26items[][selling_plan]=" + additional_figure_plan + "%26items[][quantity]=1%26";
      } else if ( additional_figure_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + additional_figure_id + "%26items[][quantity]=1%26";
      }
      let additional_figure_2_id = ""
      document.querySelectorAll(".checkout-flow-step-3 .product-id.active").forEach(function(button) {
          additional_figure_2_id = button.value;
      }); 
      let additional_figure_2_plan = "";
      document.querySelectorAll(".checkout-flow-step-3 .product-selling-plan.active").forEach(function(button) {
          additional_figure_2_plan = button.value;
      }); 
      if ( ( additional_figure_2_id != "" ) && ( additional_figure_2_plan != "" ) ) {
        checkout_url = checkout_url + "items[][id]=" + additional_figure_2_id + "%26items[][selling_plan]=" + additional_figure_2_plan + "%26items[][quantity]=1%26";
      } else if ( additional_figure_2_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + additional_figure_2_id + "%26items[][quantity]=1%26";
      }


      let box_product_id = "";
      document.querySelectorAll(".checkout-flow-step-5 .product-id.active").forEach(function(button) {
          box_product_id = button.value;
      }); 
      let box_product_plan = "";
      document.querySelectorAll(".checkout-flow-step-5 .product-selling-plan.active").forEach(function(button) {
          box_product_plan = button.value;
      }); 
      if ( ( box_product_id != "" ) && ( box_product_plan != "" ) ) {
        checkout_url = checkout_url + "items[][id]=" + box_product_id + "%26items[][selling_plan]=" + box_product_plan + "%26items[][quantity]=1%26";
      } else if ( box_product_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + box_product_id + "%26items[][quantity]=1%26";
      }
      let freebie_id = "";
      document.querySelectorAll(".checkout-flow-step-5 .freebie-product-id.active").forEach(function(button) {
          if ( button.value != undefined ) {
            freebie_id = freebie_id + "items[][id]=" + button.value + "%26items[][quantity]=1%26";
          }
      });
      if ( freebie_id != "" ) {
        checkout_url = checkout_url + freebie_id;
      }
      let digital_upsell_id = ""
      document.querySelectorAll(".checkout-flow-step-7 .product-id.active").forEach(function(button) {
          digital_upsell_id = button.value;
      }); 
      if ( digital_upsell_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + digital_upsell_id + "%26items[][quantity]=1%26";
      }
      let digital_freebie_id = "";
      document.querySelectorAll(".checkout-flow-step-7 .freebie-product-id.active").forEach(function(button) {
          if ( button.value != undefined ) {
            digital_freebie_id = digital_freebie_id + "items[][id]=" + button.value + "%26items[][quantity]=1%26";
          }
      });
      if ( digital_freebie_id != "" ) {
        checkout_url = checkout_url + digital_freebie_id;
      }
      let teaser_id = "";
      document.querySelectorAll(".checkout-flow-step-7 .teaser-product-id.active").forEach(function(button) {
          if ( button.value != undefined ) {
            teaser_id = teaser_id + "items[][id]=" + button.value + "%26items[][quantity]=1%26";
          }
      });
      if ( teaser_id != "" ) {
        checkout_url = checkout_url + teaser_id;
      }
     
      cookieExpiry = new Date(Date.now() + 86400e3).toUTCString(); // Set expiry to one day
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=.theotakubox.com;path=/;expires=${cookieExpiry}`;
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=theotakubox.com;expires=${cookieExpiry}`;
      let checkout_local_url = $("#local_url").val();
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout";
	  jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });	
      setTimeout(function(){  document.querySelectorAll(".the-otaku-box-spinner").forEach(function(button) { button.style.display = "block"; }) }, 100);
      setTimeout(function(){  window.location.href = checkout_url; }, 500);
      
    }
    
  });
});  


document.querySelectorAll(".back-button").forEach(function(element) {
  element.addEventListener("click", function() {
    
    // Additional Figures BACK Button
    if (this.classList.contains("back-additional-figure")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("active");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-additional-figure");
          button.classList.remove("active");
          button.classList.add("flow-step-free");
          button.classList.remove("yaoi-flow-step-additional-figure");
          button.classList.add("yaoi-flow-step-free");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-2").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-1").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-1").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-2").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-1 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-2 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });

      document.querySelectorAll(".plan-box-wrapper .checkout-flow-step-product").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".view-items-bar").forEach(function(button) {
        button.classList.remove("active");
      }); 
    }  

    // Additional Figures 2 BACK Button
    if (this.classList.contains("back-additional-figure-2")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-additional-figure-2");
          button.classList.add("back-additional-figure");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-additional-figure-2");
          button.classList.remove("active");
          button.classList.add("flow-step-additional-figure");
          button.classList.remove("yaoi-flow-step-additional-figure-2");
          button.classList.add("yaoi-flow-step-additional-figure");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-3").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-2").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-2").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-3").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-2 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-3 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
    }  

    // TSIRT BACK Button
    if (this.classList.contains("back-tshirt")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-tshirt");
          button.classList.add("back-additional-figure-2");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-tshirt");
          button.classList.remove("active");
          button.classList.add("flow-step-additional-figure-2");
          button.classList.remove("yaoi-flow-step-tshirt");
          button.classList.add("yaoi-flow-step-additional-figure-2");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-3").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-3").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-3 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-4 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
    }  

    // TSIRT SIZE BACK Button
    if (this.classList.contains("back-tshirt-size")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-tshirt-size");
          button.classList.add("back-tshirt");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-tshirt-size");
          button.classList.remove("active");
          button.classList.add("flow-step-tshirt");
          button.classList.remove("yaoi-flow-step-tshirt-size");
          button.classList.add("yaoi-flow-step-tshirt");
      });
      // TSHIRT CHANGE
      document.querySelectorAll(".checkout-flow-step-tshirt-1").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-4 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
    }  

    // ECCHI BACK Button
    if (this.classList.contains("back-ecchi")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-ecchi");
          button.classList.add("back-tshirt");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-ecchi");
          button.classList.remove("active");
          button.classList.add("flow-step-tshirt");
          button.classList.remove("yaoi-flow-step-ecchi");
          button.classList.add("yaoi-flow-step-tshirt");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-4 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
      // TSHIRT CHANGE
      document.querySelectorAll(".checkout-flow-step-tshirt-1").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-4 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
    }

    // PLAN SELECTION BACK Button
    if (this.classList.contains("back-plan-selection")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-plan-selection");
          button.classList.add("back-ecchi");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-plan-selection");
          button.classList.remove("active");
          button.classList.add("flow-step-ecchi");
          button.classList.remove("yaoi-flow-step-plan-selection");
          button.classList.add("yaoi-flow-step-ecchi");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-6").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-6").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-6 .checkout-flow-step-product").forEach(function(button) {
          button.classList.remove("active");
      });
    }  

    // PLAN SELECTION BACK Button
    if (this.classList.contains("back-finish")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-finish");
          button.classList.add("back-tshirt");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-finish");
          button.classList.remove("active");
          button.classList.add("flow-step-tshirt-size");
          button.classList.remove("yaoi-flow-step-finish");
          button.classList.add("yaoi-flow-step-tshirt-size");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-4 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-5 .checkout-flow-step-product").forEach(function(button) {
          button.classList.remove("active");
      });
      // SET BAR
      document.querySelectorAll(".view-items-bar").forEach(function(button) {
        button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
          button.classList.add("active");
      });
    }  




    
  }); 
}); 

document.getElementById('tshirt-select').addEventListener('change', function() {
    var selectedSize = this.value;
    var buttons = document.querySelectorAll('.product-button-tshirt-size-' + selectedSize);
    if (buttons.length > 0) {
        buttons[0].click();
    } else {
        console.error('Button not found for size: ' + selectedSize);
    }
});
document.addEventListener("DOMContentLoaded", function() {
  function generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const urgencyNote = document.getElementById('visitors');
  if (urgencyNote) {
    const randomNumber = generateRandomNumber(25, 50);
    urgencyNote.textContent = randomNumber;
  }
});

document.addEventListener("DOMContentLoaded", function() {
  var numberBoxes = document.querySelectorAll('.number-box');
  numberBoxes.forEach(function(box) {
    var randomNumber = Math.floor(Math.random() * 49) + 1; // Generate random number between 1 and 99
    var randomNumberStr = randomNumber < 10 ? String(randomNumber) : String(randomNumber);
    var firstDigit = randomNumberStr[0];
    var secondDigit = randomNumberStr[1];

    var firstNumber = document.createElement('div');
    firstNumber.className = 'number';
    firstNumber.textContent = firstDigit;
    box.appendChild(firstNumber);

    var secondNumber = document.createElement('div');
    secondNumber.className = 'number';
    secondNumber.textContent = secondDigit;
    box.appendChild(secondNumber);
  });
});

function getUrlVars() {
  var vars = {};
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    var hash = hashes[i].split('=');
    vars[hash[0]] = hash[1];
  }
  return vars;
}

document.addEventListener("DOMContentLoaded", function() {
  var urlVars = getUrlVars();
  if (urlVars !== undefined) {
    if (urlVars["figure"] == "first") {
      document.querySelector(".checkout-flow-step-free-figures .checkout-flow-step-product-1 .product-button").click();
      document.querySelector(".checkout-flow-button").click();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (urlVars["figure"] == "second") {
      document.querySelector(".checkout-flow-step-free-figures .checkout-flow-step-product-2 .product-button").click();
      document.querySelector(".checkout-flow-button").click();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (urlVars["figure"] == "third") {
      document.querySelector(".checkout-flow-step-free-figures .checkout-flow-step-product-3 .product-button").click();
      document.querySelector(".checkout-flow-button").click();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-tob_offer_11"] && !Shopify.designMode) return;
  try {
    

let cookiePostUpsell = "yaoi";
  
document.querySelectorAll(".product-button").forEach(function(element) {
  element.addEventListener("click", function() {
    
    // Free Figures Button
    if (this.classList.contains("product-button-free-figures")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.add("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
      // SET ADDITIONAL STEPS
      document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-1").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-2").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-3").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-1").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-2").classList.remove("active");
      document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-3").classList.remove("active");
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-1")) {
        document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-2").classList.add("active");
        document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-3").classList.add("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-2")) {
        document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-1").classList.add("active");
        document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-3").classList.add("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-3")) {
        document.querySelector(".checkout-flow-step-additional-figures .checkout-flow-step-product-1").classList.add("active");
        document.querySelector(".checkout-flow-step-additional-figures-2 .checkout-flow-step-product-2").classList.add("active");
      }
      // SET IMAGES
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-1")) {
        document.querySelector("#figure-image-1").classList.add("active");
        document.querySelector("#figure-image-2").classList.remove("active");
        document.querySelector("#figure-image-3").classList.remove("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-2")) {
        document.querySelector("#figure-image-1").classList.remove("active");
        document.querySelector("#figure-image-2").classList.add("active");
        document.querySelector("#figure-image-3").classList.remove("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-3")) {
        document.querySelector("#figure-image-1").classList.remove("active");
        document.querySelector("#figure-image-2").classList.remove("active");
        document.querySelector("#figure-image-3").classList.add("active");
      }

      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }

    // Additional Figures Button
    if (this.classList.contains("product-button-additional-figures")) {
      // SET PRICE
      if ( !this.classList.contains("active") ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price + step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        //document.getElementById('price-today').setAttribute('data-price', new_price );
        //document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-selling-plan").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.add("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".product-selling-plan").forEach(function(button) {
        button.classList.add("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
      // SET IMAGES
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-1")) {
        document.querySelector("#figure-image-1").classList.add("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-2")) {
        document.querySelector("#figure-image-2").classList.add("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-3")) {
        document.querySelector("#figure-image-3").classList.add("active");
      }
    }

    // Additional Figures NO Button
    if (this.classList.contains("product-button-no-additional-figures")) {
      // SET PRICE
      let change_no = true;
      this.closest(".product-button-wrapper").querySelectorAll(".product-button-additional-figures").forEach(function(button) {
        if ( button != undefined ) {
          if ( !button.classList.contains("active") ) {
            change_no = false;
          }
        }
      });
      if ( !this.classList.contains("active") && change_no ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price - step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-selling-plan").forEach(function(button) {
        button.classList.remove("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
      // SET IMAGES
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-1")) {
        document.querySelector("#figure-image-1").classList.remove("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-2")) {
        document.querySelector("#figure-image-2").classList.remove("active");
      }
      if (this.closest(".checkout-flow-step-product.checkout-flow-step-product-3")) {
        document.querySelector("#figure-image-3").classList.remove("active");
      }
    }

    // TShirt Button
    if (this.classList.contains("product-button-tshirt")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      document.querySelectorAll('.subscription-size').forEach(function(input) {
        input.value = '';
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
        button.classList.add("flow-step-tshirt");
        button.classList.remove("flow-step-tshirt-size");
      }); 
      // SET IMAGE
      document.querySelector("#tshirt-off").classList.remove("active");
      document.querySelector("#tshirt-on").classList.add("active");
    }

    // TShirt NO Button
    if (this.classList.contains("product-button-no-tshirt")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      document.querySelectorAll('.subscription-size').forEach(function(input) {
        input.value = 'No';
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
        button.classList.remove("flow-step-tshirt");
        button.classList.add("flow-step-tshirt-size");
      }); 
      // SET IMAGE
      document.querySelector("#tshirt-off").classList.add("active");
      document.querySelector("#tshirt-on").classList.remove("active");
    }

    // TShirt SIZE Button
    if (this.classList.contains("product-button-tshirt-size")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      if (this.classList.contains("product-button-tshirt-size-xs")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'XSmall';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-s")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'Small';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-m")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'Medium';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-l")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'Large';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'XLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-2xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = 'XXLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-3xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = '3XLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-4xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = '4XLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-5xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = '5XLarge';
        });
      }
      if (this.classList.contains("product-button-tshirt-size-6xl")) {
        document.querySelectorAll('.subscription-size').forEach(function(input) {
          input.value = '6XLarge';
        });
      }
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 
    }

    // Ecchi Button
    if (this.classList.contains("product-button-ecchi")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      document.querySelectorAll('.subscription-ecchi').forEach(function(input) {
        input.value = 'Uncensored';
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 
    }

    // Ecchi NO Button
    if (this.classList.contains("product-button-no-ecchi")) {
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      document.querySelectorAll('.subscription-ecchi').forEach(function(input) {
        input.value = 'Censored';
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 
    }

    // Plan Selection Button
    if (this.classList.contains("plan-box")) {
      // SET ID
      let selected_size = document.querySelector('.subscription-size').value;
      let selected_ecchi = document.querySelector('.subscription-ecchi').value;
      let selected_option = selected_size;
      this.closest(".checkout-flow-step-wrapper").querySelectorAll("input").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll("input[data-title='"+ selected_option + "']").forEach(function(button) {
        button.classList.add("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".freebie-product-id").forEach(function(button) {
        button.classList.add("active");
      });
      // SET PRICE
      if ( !this.closest(".checkout-flow-step-product").classList.contains("active") ) {
        let current_price_rebill = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let current_price_today = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price_today - current_price_rebill;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        //document.getElementById('price-today').setAttribute('data-price', new_price );
        //document.getElementById('price-today').innerHTML = new_price_curr;
        if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-1") ) {
          let step_price = 0;
          this.closest(".checkout-flow-step-product").querySelectorAll(".product-id.active").forEach(function(button) {
            if ( button.value != undefined ) {
              step_price = parseFloat( button.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
            }
          });
          let new_price = step_price;
          let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
          document.getElementById('price-rebill').setAttribute('data-price', new_price );
          document.getElementById('price-rebill').innerHTML = new_price_curr;
          if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-1")  ) {
            document.getElementById('price-rebill-note').innerHTML = "Due Every Month";
          } else {
            document.getElementById('price-rebill-note').innerHTML = "Due Every Year";
          }
        }
        if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-2") ) {
          let step_price = 0;
          this.closest(".checkout-flow-step-product").querySelectorAll(".product-id.active").forEach(function(button) {
            if ( button.value != undefined ) {
              step_price = 3 * parseFloat( button.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
            }
          });
          let new_price = step_price;
          let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
          document.getElementById('price-rebill').setAttribute('data-price', new_price );
          document.getElementById('price-rebill').innerHTML = new_price_curr;
          document.getElementById('price-rebill-note').innerHTML = "Due Every 3 Months";
        }
        if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-3") ) {
          let step_price = 0;
          this.closest(".checkout-flow-step-product").querySelectorAll(".product-id.active").forEach(function(button) {
            if ( button.value != undefined ) {
              step_price = 6 * parseFloat( button.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
            }
          });
          let new_price = step_price;
          let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
          document.getElementById('price-rebill').setAttribute('data-price', new_price );
          document.getElementById('price-rebill').innerHTML = new_price_curr;
          document.getElementById('price-rebill-note').innerHTML = "Due Every 6 Months";
        }
        if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-4") ) {
          let step_price = 0;
          this.closest(".checkout-flow-step-product").querySelectorAll(".product-id.active").forEach(function(button) {
            if ( button.value != undefined ) {
              step_price = 12 * parseFloat( button.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
            }
          });
          let new_price = step_price;
          let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
          document.getElementById('price-rebill').setAttribute('data-price', new_price );
          document.getElementById('price-rebill').innerHTML = new_price_curr;
          document.getElementById('price-rebill-note').innerHTML = "Due Every 12 Months";
        }
        current_price_rebill = parseFloat( document.getElementById('price-rebill').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        current_price_today = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        new_price = current_price_today + current_price_rebill;
        new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        //document.getElementById('price-today').setAttribute('data-price', new_price );
        //document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".checkout-flow-step-product").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").classList.add("active");
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
        button.classList.add("active");
      }); 
      // SET BAR
      document.querySelectorAll(".view-items-bar").forEach(function(button) {
        button.classList.remove("active");
      }); 
      if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-2") ) {
        document.getElementById('3months-bar').classList.add("active");
      }
      if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-3") ) {
        document.getElementById('6months-bar').classList.add("active");
      }
      if ( this.closest(".checkout-flow-step-product").classList.contains("checkout-flow-step-product-4") ) {
        document.getElementById('12months-bar').classList.add("active");
      }
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }

    // Upsell Button
    if (this.classList.contains("product-button-upsell")) {
      // SET PRICE
      if ( !this.classList.contains("active") ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price + step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.add("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".freebie-product-id").forEach(function(button) {
        button.classList.add("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".teaser-product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
    }

    // Upsell NO Button
    if (this.classList.contains("product-button-no-upsell")) {
      // SET PRICE
      let change_no = true;
      this.closest(".product-button-wrapper").querySelectorAll(".product-button-upsell").forEach(function(button) {
        if ( button != undefined ) {
          if ( !button.classList.contains("active") ) {
            change_no = false;
          }
        }
      });
      if ( !this.classList.contains("active") && change_no ) {
        let step_price = parseFloat( this.getAttribute('data-price').replace(/[^\d.-]/g, '') ) / 100;
        let current_price = parseFloat( document.getElementById('price-today').getAttribute('data-price').replace(/[^\d.-]/g, '') ) ;
        let new_price = current_price - step_price;
        let new_price_curr = new_price.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        document.getElementById('price-today').setAttribute('data-price', new_price );
        document.getElementById('price-today').innerHTML = new_price_curr;
      }
      // SET CLASS
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-button").forEach(function(button) {
        button.classList.remove("active");
      });
      this.classList.add("active");
      // SET ID
      this.closest(".checkout-flow-step-wrapper").querySelectorAll(".product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".freebie-product-id").forEach(function(button) {
        button.classList.remove("active");
      });
      this.closest(".checkout-flow-step-product").querySelectorAll(".teaser-product-id").forEach(function(button) {
        button.classList.add("active");
      });
      // SET BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.add("active");
      }); 
    }
    
  });
});


document.querySelectorAll(".checkout-flow-button").forEach(function(element) {
  element.addEventListener("click", function() {
    
    // Free Figures NEXT Button
    if (this.classList.contains("flow-step-free")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-free");
      this.classList.add("flow-step-additional-figure");
      this.classList.remove("yaoi-flow-step-free");
      this.classList.add("yaoi-flow-step-additional-figure");
      // STEP
      document.querySelectorAll(".checkout-flow-step-1").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-2").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-1").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-2").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-button-note").forEach(function(button) {
          button.style.display = "none";
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.add("active");
      }); 
    }

    // Additional Figures NEXT Button
    else if (this.classList.contains("flow-step-additional-figure")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-additional-figure");
      this.classList.add("flow-step-additional-figure-2");
      this.classList.remove("yaoi-flow-step-additional-figure");
      this.classList.add("yaoi-flow-step-additional-figure-2");
      // STEP
      document.querySelectorAll(".checkout-flow-step-2").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-3").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-2").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-3").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-additional-figure");
          button.classList.add("back-additional-figure-2");
      }); 
    }

    // Additional Figures NEXT Button
    else if (this.classList.contains("flow-step-additional-figure-2")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-additional-figure-2");
      this.classList.add("flow-step-tshirt-size");
      this.classList.remove("yaoi-flow-step-additional-figure-2");
      this.classList.add("yaoi-flow-step-tshirt-size");
      // STEP
      document.querySelectorAll(".checkout-flow-step-3").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-3").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-additional-figure-2");
          button.classList.add("back-tshirt");
      }); 
    }

    // TShirt NEXT Button
    else if (this.classList.contains("flow-step-tshirt")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-tshirt");
      this.classList.add("flow-step-tshirt-size");
      this.classList.remove("yaoi-flow-step-tshirt");
      this.classList.add("yaoi-flow-step-tshirt-size");
      // TSHIRT CHANGE
      document.querySelectorAll(".checkout-flow-step-tshirt-1").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
          button.classList.add("active");
      });
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-tshirt");
          button.classList.add("back-tshirt-size");
      }); 
    }

    // TShirt Size NEXT Button
    else if (this.classList.contains("flow-step-tshirt-size")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-tshirt-size");
      this.classList.add("flow-step-finish");
      this.classList.remove("yaoi-flow-step-tshirt-size");
      this.classList.add("yaoi-flow-step-finish");
      document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
          button.classList.remove("active");
      });
      // STEP
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-tshirt-size");
          button.classList.remove("back-tshirt");
          button.classList.add("back-finish");
      }); 
    }

    // Ecchi NEXT Button
    else if (this.classList.contains("flow-step-ecchi")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-ecchi");
      this.classList.add("flow-step-plan-selection");
      // STEP
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-6").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-6").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-ecchi");
          button.classList.remove("back-tshirt");
          button.classList.remove("back-tshirt-size");
          button.classList.add("back-plan-selection");
      }); 
    }

    // Plan Selection NEXT Button
    else if (this.classList.contains("flow-step-plan-selection")) {
      this.classList.remove("active");
      this.classList.remove("flow-step-plan-selection");
      this.classList.add("flow-step-finish");
      this.classList.remove("yaoi-flow-step-plan-selection");
      this.classList.add("yaoi-flow-step-finish");
      // STEP
      document.querySelectorAll(".checkout-flow-step-6").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-7").forEach(function(button) {
          button.classList.add("active");
      }); 
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-6").forEach(function(button) {
          button.classList.remove("active");
          button.classList.add("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-7").forEach(function(button) {
          button.classList.add("active");
      }); 
      //BACK
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-plan-selection");
          button.classList.add("back-finish");
      }); 
    }

    // Flow Step Finish
    else if (this.classList.contains("flow-step-finish")) {

      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      let free_figure_id = ""
      document.querySelectorAll(".checkout-flow-step-1 .product-id.active").forEach(function(button) {
          free_figure_id = button.value;
      }); 
      if ( free_figure_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + free_figure_id + "%26items[][quantity]=1%26";
      }
      let additional_figure_id = ""
      document.querySelectorAll(".checkout-flow-step-2 .product-id.active").forEach(function(button) {
          additional_figure_id = button.value;
      }); 
      let additional_figure_plan = "";
      document.querySelectorAll(".checkout-flow-step-2 .product-selling-plan.active").forEach(function(button) {
          additional_figure_plan = button.value;
      }); 
      if ( ( additional_figure_id != "" ) && ( additional_figure_plan != "" ) ) {
        checkout_url = checkout_url + "items[][id]=" + additional_figure_id + "%26items[][selling_plan]=" + additional_figure_plan + "%26items[][quantity]=1%26";
      } else if ( additional_figure_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + additional_figure_id + "%26items[][quantity]=1%26";
      }
      let additional_figure_2_id = ""
      document.querySelectorAll(".checkout-flow-step-3 .product-id.active").forEach(function(button) {
          additional_figure_2_id = button.value;
      }); 
      let additional_figure_2_plan = "";
      document.querySelectorAll(".checkout-flow-step-3 .product-selling-plan.active").forEach(function(button) {
          additional_figure_2_plan = button.value;
      }); 
      if ( ( additional_figure_2_id != "" ) && ( additional_figure_2_plan != "" ) ) {
        checkout_url = checkout_url + "items[][id]=" + additional_figure_2_id + "%26items[][selling_plan]=" + additional_figure_2_plan + "%26items[][quantity]=1%26";
      } else if ( additional_figure_2_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + additional_figure_2_id + "%26items[][quantity]=1%26";
      }


      let box_product_id = "";
      document.querySelectorAll(".checkout-flow-step-5 .product-id.active").forEach(function(button) {
          box_product_id = button.value;
      }); 
      let box_product_plan = "";
      document.querySelectorAll(".checkout-flow-step-5 .product-selling-plan.active").forEach(function(button) {
          box_product_plan = button.value;
      }); 
      if ( ( box_product_id != "" ) && ( box_product_plan != "" ) ) {
        checkout_url = checkout_url + "items[][id]=" + box_product_id + "%26items[][selling_plan]=" + box_product_plan + "%26items[][quantity]=1%26";
      } else if ( box_product_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + box_product_id + "%26items[][quantity]=1%26";
      }
      let freebie_id = "";
      document.querySelectorAll(".checkout-flow-step-5 .freebie-product-id.active").forEach(function(button) {
          if ( button.value != undefined ) {
            freebie_id = freebie_id + "items[][id]=" + button.value + "%26items[][quantity]=1%26";
          }
      });
      if ( freebie_id != "" ) {
        checkout_url = checkout_url + freebie_id;
      }
      let digital_upsell_id = ""
      document.querySelectorAll(".checkout-flow-step-7 .product-id.active").forEach(function(button) {
          digital_upsell_id = button.value;
      }); 
      if ( digital_upsell_id != "" ) {
        checkout_url = checkout_url + "items[][id]=" + digital_upsell_id + "%26items[][quantity]=1%26";
      }
      let digital_freebie_id = "";
      document.querySelectorAll(".checkout-flow-step-7 .freebie-product-id.active").forEach(function(button) {
          if ( button.value != undefined ) {
            digital_freebie_id = digital_freebie_id + "items[][id]=" + button.value + "%26items[][quantity]=1%26";
          }
      });
      if ( digital_freebie_id != "" ) {
        checkout_url = checkout_url + digital_freebie_id;
      }
      let teaser_id = "";
      document.querySelectorAll(".checkout-flow-step-7 .teaser-product-id.active").forEach(function(button) {
          if ( button.value != undefined ) {
            teaser_id = teaser_id + "items[][id]=" + button.value + "%26items[][quantity]=1%26";
          }
      });
      if ( teaser_id != "" ) {
        checkout_url = checkout_url + teaser_id;
      }
     
      cookieExpiry = new Date(Date.now() + 86400e3).toUTCString(); // Set expiry to one day
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=.theotakubox.com;path=/;expires=${cookieExpiry};SameSite=None; Secure`;
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=theotakubox.com;expires=${cookieExpiry};SameSite=None; Secure`;
      let checkout_local_url = $("#local_url").val();
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout";
	  jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });	
      setTimeout(function(){  document.querySelectorAll(".the-otaku-box-spinner").forEach(function(button) { button.style.display = "block"; }) }, 100);
      setTimeout(function(){  window.location.href = checkout_url; }, 500);
      
    }
    
  });
});  


document.querySelectorAll(".back-button").forEach(function(element) {
  element.addEventListener("click", function() {
    
    // Additional Figures BACK Button
    if (this.classList.contains("back-additional-figure")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("active");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-additional-figure");
          button.classList.remove("active");
          button.classList.add("flow-step-free");
          button.classList.remove("yaoi-flow-step-additional-figure");
          button.classList.add("yaoi-flow-step-free");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-2").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-1").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-1").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-2").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-1 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-2 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
    }  

    // Additional Figures 2 BACK Button
    if (this.classList.contains("back-additional-figure-2")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-additional-figure-2");
          button.classList.add("back-additional-figure");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-additional-figure-2");
          button.classList.remove("active");
          button.classList.add("flow-step-additional-figure");
          button.classList.remove("yaoi-flow-step-additional-figure-2");
          button.classList.add("yaoi-flow-step-additional-figure");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-3").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-2").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-2").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-3").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-2 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-3 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
    }  

    // TSIRT BACK Button
    if (this.classList.contains("back-tshirt")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-tshirt");
          button.classList.add("back-additional-figure-2");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-tshirt");
          button.classList.remove("active");
          button.classList.add("flow-step-additional-figure-2");
          button.classList.remove("yaoi-flow-step-tshirt");
          button.classList.add("yaoi-flow-step-additional-figure-2");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-3").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-3").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-3 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-4 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
    }  

    // TSIRT SIZE BACK Button
    if (this.classList.contains("back-tshirt-size")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-tshirt-size");
          button.classList.add("back-tshirt");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-tshirt-size");
          button.classList.remove("active");
          button.classList.add("flow-step-tshirt");
          button.classList.remove("yaoi-flow-step-tshirt-size");
          button.classList.add("yaoi-flow-step-tshirt");
      });
      // TSHIRT CHANGE
      document.querySelectorAll(".checkout-flow-step-tshirt-1").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-4 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
    }  

    // ECCHI BACK Button
    if (this.classList.contains("back-ecchi")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-ecchi");
          button.classList.add("back-tshirt");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-ecchi");
          button.classList.remove("active");
          button.classList.add("flow-step-tshirt");
          button.classList.remove("yaoi-flow-step-ecchi");
          button.classList.add("yaoi-flow-step-tshirt");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-4 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
      // TSHIRT CHANGE
      document.querySelectorAll(".checkout-flow-step-tshirt-1").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-title").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle").forEach(function(button) {
          button.classList.add("active");
      });
      document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-title-2").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-subtitle-2").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-4 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
    }

    // PLAN SELECTION BACK Button
    if (this.classList.contains("back-plan-selection")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-plan-selection");
          button.classList.add("back-ecchi");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-plan-selection");
          button.classList.remove("active");
          button.classList.add("flow-step-ecchi");
          button.classList.remove("yaoi-flow-step-plan-selection");
          button.classList.add("yaoi-flow-step-ecchi");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-6").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-6").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-6 .checkout-flow-step-product").forEach(function(button) {
          button.classList.remove("active");
      });
    }  

    // PLAN SELECTION BACK Button
    if (this.classList.contains("back-finish")) {
      // BACK BUTTON
      document.querySelectorAll(".back-button").forEach(function(button) {
          button.classList.remove("back-finish");
          button.classList.add("back-tshirt");
      });
      // FLOW BUTTON
      document.querySelectorAll(".checkout-flow-button").forEach(function(button) {
          button.classList.remove("flow-step-finish");
          button.classList.remove("active");
          button.classList.add("flow-step-tshirt-size");
          button.classList.remove("yaoi-flow-step-finish");
          button.classList.add("yaoi-flow-step-tshirt-size");
      });
      // NAV
      document.querySelectorAll(".checkout-flow-step-nav-5").forEach(function(button) {
          button.classList.remove("active");
          button.classList.remove("past");
      }); 
      document.querySelectorAll(".checkout-flow-step-nav-4").forEach(function(button) {
          button.classList.remove("past");  
          button.classList.add("active");
      }); 
      // GO BACK
      document.querySelectorAll(".checkout-flow-step-4").forEach(function(button) {
          button.classList.add("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5").forEach(function(button) {
          button.classList.remove("active");
      });
      // PRODUCT BUTTON
      document.querySelectorAll(".checkout-flow-step-4 .product-button").forEach(function(button) {
          button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-5 .product-button").forEach(function(button) {
          button.classList.remove("active");
      });
      document.querySelectorAll(".checkout-flow-step-5 .checkout-flow-step-product").forEach(function(button) {
          button.classList.remove("active");
      });
      // SET BAR
      document.querySelectorAll(".view-items-bar").forEach(function(button) {
        button.classList.remove("active");
      }); 
      document.querySelectorAll(".checkout-flow-step-tshirt-2").forEach(function(button) {
          button.classList.add("active");
      });
    }  




    
  }); 
}); 

document.getElementById('tshirt-select').addEventListener('change', function() {
    var selectedSize = this.value;
    var buttons = document.querySelectorAll('.product-button-tshirt-size-' + selectedSize);
    if (buttons.length > 0) {
        buttons[0].click();
    } else {
        console.error('Button not found for size: ' + selectedSize);
    }
});
document.addEventListener("DOMContentLoaded", function() {
  function generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const urgencyNote = document.getElementById('visitors');
  if (urgencyNote) {
    const randomNumber = generateRandomNumber(25, 50);
    urgencyNote.textContent = randomNumber;
  }
});

document.addEventListener("DOMContentLoaded", function() {
  var numberBoxes = document.querySelectorAll('.number-box');
  numberBoxes.forEach(function(box) {
    var randomNumber = Math.floor(Math.random() * 49) + 1; // Generate random number between 1 and 99
    var randomNumberStr = randomNumber < 10 ? String(randomNumber) : String(randomNumber);
    var firstDigit = randomNumberStr[0];
    var secondDigit = randomNumberStr[1];

    var firstNumber = document.createElement('div');
    firstNumber.className = 'number';
    firstNumber.textContent = firstDigit;
    box.appendChild(firstNumber);

    var secondNumber = document.createElement('div');
    secondNumber.className = 'number';
    secondNumber.textContent = secondDigit;
    box.appendChild(secondNumber);
  });
});

function getUrlVars() {
  var vars = {};
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    var hash = hashes[i].split('=');
    vars[hash[0]] = hash[1];
  }
  return vars;
}

document.addEventListener("DOMContentLoaded", function() {
  var urlVars = getUrlVars();
  if (urlVars !== undefined) {
    if (urlVars["figure"] == "first") {
      document.querySelector(".checkout-flow-step-free-figures .checkout-flow-step-product-1 .product-button").click();
      document.querySelector(".checkout-flow-button").click();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (urlVars["figure"] == "second") {
      document.querySelector(".checkout-flow-step-free-figures .checkout-flow-step-product-2 .product-button").click();
      document.querySelector(".checkout-flow-button").click();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (urlVars["figure"] == "third") {
      document.querySelector(".checkout-flow-step-free-figures .checkout-flow-step-product-3 .product-button").click();
      document.querySelector(".checkout-flow-button").click();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section-tob_offer_12"] && !Shopify.designMode) return;
  try {
    

let cookiePostUpsell = false;
  

if ( getUrlVars() !== undefined ) {
  if ( getUrlVars()["figure"] ==  "rias" || getUrlVars()["figure"] ==  "rem" || getUrlVars()["figure"] ==  "rias-rem"  ) {

  } else {
    $(".otaku-box-selected-offer-pre-step").show();
  }
} else {
  $(".otaku-box-selected-offer-pre-step").show();
}
  
$( document ).ready(function() { 
  $( ".otaku-box-offer-btn" ).click(function() {
    if ( $(this).hasClass("otaku-box-offer-btn-initial") ) {
   	  $(".otaku-box-offer-boxes").hide();   
      $(".otaku-box-offer-info").hide();
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info").addClass("selected");
      $(this).removeClass("otaku-box-offer-btn-initial");
      $(this).addClass("otaku-box-offer-btn-next");
      if ( $(this).closest(".the-otaku-box-body-v2").find(".post-purchase-step").hasClass("selected") ) {
        $(this).addClass("otaku-box-offer-btn-post-purchase");
      } else {
        $(this).attr("disabled","disabled");	
        $(this).closest(".the-otaku-box-body-v2").find(".start-post-purchase").removeClass("selected");
      }
      $(".otaku-box-body-image-container-back").removeClass("box-selection");
      $(".otaku-box-body-image-container-back").addClass("box-selected");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
      window.scrollTo({ top: 0, behavior: 'smooth' });
     
      $(".otaku-box-plan-title-1").hide();
      $(".otaku-box-plan-title-2").show();


      if ( ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) && ( $(this).closest(".the-otaku-box-container").find(".scale-figure-step").hasClass("active") ) ) {
        $(this).closest(".the-otaku-box-container").find(".scale-figure-step .otaku-box-questions-select:not(.no-option)").click();
      }
      
    } else if ( $(this).hasClass("otaku-box-offer-btn-show-retail-price") ) {
      $(this).removeClass("otaku-box-offer-btn-show-retail-price");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select.show-retail-price").removeClass("show-retail-price");
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
        if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Kasse");
         } else {
           $(".otaku-box-offer-btn").html("Vérifier");
         }
      } else {
        $(this).html("Checkout");
      }
      $(".retail-price-step").addClass("selected");
      $(".retail-price-section").addClass("show");
      $(".otaku-box-selected-offer-info-footer-price").addClass("show");
      $(".otaku-box-offer-footer").addClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").hide();
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 

 
      
    } else if ( $(this).hasClass("otaku-box-offer-btn-edit") ) {
      $(".otaku-box-selected-offer-step.edit").removeClass("edit");
      $(this).removeClass("otaku-box-offer-btn-edit");

    } else if ( $(this).hasClass("otaku-box-offer-btn-multi") ) {
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi"); 
      $(".main-digital-image-1").addClass("hide-digital");
      $(".main-digital-image-2").removeClass("hide-digital");

      $(".otaku-box-body-image-container-back").addClass("multi-back-1");
    
      $("body").addClass("fixed");
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);
      $(this).attr("disabled","disabled");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").addClass("selected");
 	  $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").next().addClass("active");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active.selected").removeClass("active");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 

    } else if ( $(this).hasClass("otaku-box-offer-btn-post-purchase-multi") ) {
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase-multi"); 
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").hide();
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").hide();
      $(".the-otaku-box-body.selected .otaku-box-plan-title").hide();
      $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-header-text").hide();
      $(".main-product-image").addClass("remove-main-image");
      $(".main-digital-image").removeClass("remove-digital-image");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-body-image-container").addClass("post_purchase_step_image");
      $(".otaku-box-body-image-container-back").removeClass("box-selected");
      $(".otaku-box-body-image-container-back").addClass("box-checkout");
      // $(".otaku-box-body-offer-container").addClass("post_purchase_step_offer");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
	  $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
      $(".post_purchase_step").addClass("active");
      $(".end-post-purchase").removeClass("selected");
      $(".multi-upsell-step").addClass("active");

      if ( $(this).closest(".the-otaku-box-container").find(".post_purchase_step.post_purchase_step_next").length > 0 ) {
        $(this).addClass("otaku-box-offer-btn-post-purchase-start");
      } 
 	 
      window.scrollTo({ top: 0, behavior: 'smooth' });

      if ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") )  {    
       $(this).closest(".the-otaku-box-container").find(".otaku-box-selected-offer-step-final .end-post-purchase:not(.no-option)").click();
      }
    
    } else if ( $(this).hasClass("otaku-box-offer-btn-post-purchase") ) {
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase"); 
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").hide();
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").hide();
      $(".the-otaku-box-body.selected .otaku-box-plan-title").hide();
      $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-header-text").hide();
      $(".main-product-image").addClass("remove-main-image");
      $(".main-digital-image").removeClass("remove-digital-image");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-body-image-container").addClass("post_purchase_step_image");
      $(".otaku-box-body-image-container-back").removeClass("box-selected");
      $(".otaku-box-body-image-container-back").addClass("box-checkout");
      // $(".otaku-box-body-offer-container").addClass("post_purchase_step_offer");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
	  $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
      $(".post_purchase_step").addClass("active");
      $(".end-post-purchase").removeClass("selected");

      if ( $(this).closest(".the-otaku-box-container").find(".post_purchase_step.post_purchase_step_next").length > 0 ) {
        $(this).addClass("otaku-box-offer-btn-post-purchase-start");
      } 
 	 
      window.scrollTo({ top: 0, behavior: 'smooth' });

      if ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") )  {    
       $(this).closest(".the-otaku-box-container").find(".otaku-box-selected-offer-step-final .end-post-purchase:not(.no-option)").click();
      }

      
    } else if ( $(this).hasClass("otaku-box-offer-btn-pre-purchase") ) {
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
        if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Weiter");
         } else {
           $(".otaku-box-offer-btn").html("Suivant");
         }
      } else {
        $(this).html("Next");
      }
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-edit"); 
	  $(this).closest(".the-otaku-box-body").find(".btn-start-pre-purchase").click();
      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $( ".otaku-box-selected-offer-step" ).each(function() {
        if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();
        }
        if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }		
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		}
      });
      let checkout_local_url = $("#local_url").val();
      let checkout_digtial_all_url = ''; 
      $( ".the-otaku-box-body.selected .digital-step" ).each(function() {
        checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-answer-select-main-input-id" ).val() + "%26items[][quantity]=1%26";
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
          checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
          checkout_digtial_all_url = checkout_digtial_all_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() + "%26items[][quantity]=1%26";
        }
      });
      checkout_digtial_all_url = checkout_url + checkout_digtial_all_url + "return_to=" + checkout_local_url + "checkout";
      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout";
      jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });
      $("#digital-all").attr("href", checkout_digtial_all_url); 
      $(".otaku-box-offer-footer-cancel-digital").attr("href", checkout_url);   
    } else if ( $(this).hasClass("otaku-box-offer-btn-final") ) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $(".the-otaku-box-spinner").show(); $("body").addClass("fixed"); }, 100);
      $(this).attr("style","pointer-events:none;");
      $(".otaku-box-selected-offer-info-header-digital").addClass("finished-test");
      let checkout_url = "https://shop.theotakubox.com/cart/clear?return_to=/cart/add?"; 
      $(this).closest(".the-otaku-box-body.selected").find( ".otaku-box-selected-offer-step" ).each(function() {
       if ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val();         
        }
        if ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != '' ) {
          checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val();
        }
	    if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          checkout_url = checkout_url + "%26items[][quantity]=1%26";
        }
        if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(0).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(0).val() != ''  ) ) {
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(1).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(1).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(2).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(2).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(3).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(3).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(4).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(4).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(5).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(5).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	
		  if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(6).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(6).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }		
          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(7).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(7).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	

          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(8).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(8).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(8).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(8).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(8).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(8).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(8).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(8).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(8).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(8).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	

          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(9).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(9).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(9).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(9).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(9).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(9).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(9).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(9).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(9).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(9).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	

          if ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(10).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(10).val() != null ) ) {
            checkout_url = checkout_url + "items[][id]=" + $( this ).find( ".otaku-box-step-select-input-id" ).eq(10).val();
          }
          if ( ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(10).val() != '' ) && ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(10).val() != null ) ) {
            checkout_url = checkout_url + "%26items[][selling_plan]=" + $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(10).val();
          }
          if ( ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(10).val() != '' ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(10).val() != ''  ) ) 
          && ( ( $( this ).find( ".otaku-box-step-select-input-id" ).eq(10).val() != null ) || ( $( this ).find( ".otaku-box-step-select-input-selling-plan" ).eq(10).val() != null  ) ) ) {
            checkout_url = checkout_url + "%26items[][quantity]=1%26";
          }	


          
		}
      });

      cookieExpiry = new Date(Date.now() + 86400e3).toUTCString(); // Set expiry to one day
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=.theotakubox.com;path=/;expires=${cookieExpiry};SameSite=None; Secure`;
      document.cookie = `postPurchaseTOB=${cookiePostUpsell};domain=theotakubox.com;expires=${cookieExpiry};SameSite=None; Secure`;
      
      console.log(cookiePostUpsell);
      let checkout_local_url = $("#local_url").val();
      let email_val = $("#email-input").val();

      checkout_url = checkout_url + "return_to=" + checkout_local_url + "checkout?checkout[email]=" + email_val;
      console.log(checkout_url);
	  jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
        }
      });	

   
      
       window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function(){  $("body").removeClass("fixed") }, 500);
      setTimeout(function(){  window.location.href = checkout_url; }, 500);
    } else if ( $(this).hasClass("otaku-box-offer-btn-next") ) {         
      $(this).attr("disabled","disabled");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").addClass("selected");
 	  $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active").next().addClass("active");
      $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-step.active.selected").removeClass("active");
      let trustpilot_step = parseInt($(".trustpilot-text.selected").attr("data-review")) + 1;
      $(".trustpilot-text").removeClass("selected");  
      $(".trustpilot-text[data-review=" + trustpilot_step + "]").addClass("selected"); 
      if ( $(this).hasClass("otaku-box-offer-btn-post-purchase-start") ) {
        if ( $(this).closest(".the-otaku-box-container").find(".main-digital-image-2").hasClass("hide-digital") ) {
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-1").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-3").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-2").removeClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").addClass("post_purchase_step_image_2");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").removeClass("post_purchase_step_image_3");
          $(this).closest(".the-otaku-box-container").find(".box-checkout").addClass("box-checkout-2");
        } else {
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-1").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-2").addClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".main-digital-image-3").removeClass("hide-digital");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").removeClass("post_purchase_step_image_2");
          $(this).closest(".the-otaku-box-container").find(".post_purchase_step_image").addClass("post_purchase_step_image_3");
          $(this).closest(".the-otaku-box-container").find(".box-checkout").removeClass("box-checkout-2");
          $(this).closest(".the-otaku-box-container").find(".box-checkout").addClass("box-checkout-3");
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }   


       if ( ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step").hasClass("selected") ) && ( $(this).closest(".the-otaku-box-container").find(".ecchi-step").hasClass("selected") == false ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step .otaku-box-questions-select-variations.selected").length > 0 ) ) {    
        $(this).closest(".the-otaku-box-container").find(".ecchi-step .otaku-box-questions-select.yes-option").click();
       }

      if ( ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step").hasClass("selected") ) && ( $(this).closest(".the-otaku-box-container").find(".ecchi-step").hasClass("selected") == false ) && ( $(this).closest(".the-otaku-box-container").find(".tshirt-step .otaku-box-questions-select.selected").length > 0 ) ) {    
        $(this).closest(".the-otaku-box-container").find(".ecchi-step .otaku-box-questions-select.yes-option").click();
       }

      if ( $(this).hasClass("otaku-box-offer-btn-multi-1") ) {
        $("body").addClass("fixed");
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function(){  $("body").removeClass("fixed") }, 500);
        $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-1");
        $(".main-digital-image-2").addClass("hide-digital");
        $(".main-digital-image-3").removeClass("hide-digital");
        $(".otaku-box-body-image-container-back").addClass("multi-back-2");
      }

      if ( $(this).hasClass("otaku-box-offer-btn-multi-2") ) {
        $("body").addClass("fixed");
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function(){  $("body").removeClass("fixed") }, 500);
        $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-2");
        $(".main-digital-image-3").addClass("hide-digital");
        $(".main-digital-image-4").removeClass("hide-digital");
        $(".otaku-box-body-image-container-back").addClass("multi-back-3");
      }
    }
 });
});  
$( document ).ready(function() {
  $( ".otaku-box-questions-select" ).click(function() {
    let current_step = 	$(this).closest(".otaku-box-selected-offer-step").attr("data-step");
    if ( $(this).hasClass("multi-step-1") ) {
      $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").addClass("otaku-box-offer-btn-multi-1");
      $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-2");
      $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-3");
    }
    if ( $(this).hasClass("multi-step-2") ) {
      $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-1");
      $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").addClass("otaku-box-offer-btn-multi-2");
      $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-3");
    }
    if ( $(this).hasClass("multi-step-3") ) {
      $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-1");
      $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-2");
      $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").addClass("otaku-box-offer-btn-multi-3");
    }
    if ( $(this).hasClass("multi-step-yes") ) {
      $(".otaku-box-offer-btn").removeAttr("disabled");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-multi");
    } else if ( $(this).hasClass("multi-step-no") ) {
      $(".otaku-box-offer-btn").removeAttr("disabled");
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi");
    } else if ( $(this).hasClass("show-neither") ) {
      $(".otaku-box-selected-offer-step[data-step='3']").addClass("active");
      $(".otaku-box-offer-pre-btn").removeAttr("disabled");
      $(".otaku-box-offer-pre-btn").addClass("otaku-box-offer-pre-btn-lv2");
      $(".otaku-box-offer-pre-btn.otaku-box-offer-pre-btn-lv2").click();
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(".otaku-box-offer-pre-btn").removeClass("otaku-box-offer-pre-btn-lv2");
    } else if ( $(this).hasClass("otaku-box-questions-select-pre-step") ) {
      let combination_step = $(this).attr("data-combination");
      $( ".the-otaku-box-container" ).each(function() {
        $( this ).find( ".free-pre-step .otaku-box-questions-combination .otaku-box-questions-select[data-combination=" + combination_step + "]" ).click();
      });
      $(".otaku-box-selected-offer-step[data-step='3']").addClass("active");
      $(".otaku-box-offer-pre-btn").removeAttr("disabled");
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".otaku-box-offer-pre-btn").offset().top - $(window).height() + 180
       }, 500); 
    } else if ( $(this).hasClass("no-option") ) {
	  $(this).closest(".otaku-box-selected-offer-step").addClass("deny-offer");
      setTimeout(function(){  $('.step-image[data-step=' + current_step + ']').removeClass("show-image");  }, 500);
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
	  if ( $('.step-image-remove[data-step=' + current_step + ']').length > 0 ) {
        setTimeout(function(){  $('.step-image-remove[data-step=' + current_step + ']').removeClass("remove-image");  }, 500);
        $('.step-image-remove[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
	  }
      if ( $(this).hasClass("end-post-purchase") ) {
        $('.otaku-box-step-select-input-id.ecchitoons-teaser').val("41606325829803");
      }  
      if ( $(this).hasClass("end-post-purchase-ecchitoons") ) {
        cookiePostUpsell = false;
      }  
    } else if ( $(this).hasClass("otaku-box-combination-product") ) {
	  let current_combination = 	$(this).attr("data-combination");
      $('.step-image-combination.step-image-combination-' + current_step).removeClass("show-image");
      $('.step-image-combination.step-image-combination-' + current_step).removeAttr( 'style' );
      $('.step-image[data-step_' + current_combination + '=' + current_step + ']').addClass("show-image");
	  $('.step-image[data-step_' + current_combination + '=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
    } else {
	  $(this).closest(".otaku-box-selected-offer-step").removeClass("deny-offer");
	  $('.step-image[data-step=' + current_step + ']').addClass("show-image");
	  $('.step-image[data-step=' + current_step + ']').css({"animation":"image-animation-on 0.5s"});
	  if ( $('.step-image-remove[data-step=' + current_step + ']').length > 0 ) {
        $('.step-image-remove[data-step=' + current_step + ']').addClass("remove-image");
        $('.step-image-remove[data-step=' + current_step + ']').css({"animation":"image-animation-off 0.5s"});
	   }
      if ( $(this).hasClass("end-post-purchase") ) {
        $('.otaku-box-step-select-input-id.ecchitoons-teaser').val("");
      }  
      if ( $(this).hasClass("end-post-purchase-ecchitoons") ) {
        cookiePostUpsell = true;
      }  
      if ( $(this).hasClass("end-post-purchase-waifu") ) {
        cookiePostUpsell = "waifu";
      }  
    }
    
    if ( $(this).hasClass("otaku-box-questions-select-variations") ) {
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      let selected_var_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price") ); 
       if ( selected_currency == "€") {
        selected_var_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
       }
      if ( $(this).hasClass("otaku-box-questions-select-variations-quarterly") ) {
        selected_var_price = selected_var_price / 3;
        selected_var_price = selected_var_price.toFixed(2);
      }
      if ( selected_var_price == 0 ) {
        selected_var_price = "0.00";
         if ( selected_currency == "€") {
          selected_var_price = "0,00";
         }
      }
      if ( selected_currency == "€") {
        $(this).closest(".otaku-box-selected-offer-step-info").find(".otaku-box-selected-offer-step-price span").text("€" + selected_var_price.toString().replace(/\./g, ',') );
      } else {
        $(this).closest(".otaku-box-selected-offer-step-info").find(".otaku-box-selected-offer-step-price span").text("$" + selected_var_price.toString());
      }
    }

    if ( ( $(window).scrollTop() + $(window).height() != $(document).height() ) && ( $(".the-otaku-box-body.selected .otaku-box-offer-btn").length > 0 ) ) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".the-otaku-box-body.selected .otaku-box-offer-btn").offset().top - $(window).height() + 180
       }, 500); 
    }

    
    if ( $(this).hasClass("otaku-box-questions-select-pre-step") ) {
      $(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select" ).removeClass("selected");
      $(this).addClass("selected");
   } else {
    let current_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price") );
    let selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price") ); 
    let current_rrp_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price") );
    let selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price") ); 
    let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
    if ( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected").length != 0 ) {
	  let step_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-price"));
      let new_price = current_price - step_price + selected_price;
      new_price = new_price.toFixed(2);
      let step_rrp_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-rrp-price"));
      let new_rrp_price = current_rrp_price - step_rrp_price + selected_rrp_price;
      new_rrp_price = new_rrp_price.toFixed(2);
      if ( selected_currency == "€") {
       current_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price").replace(/\,/g, '.') );
       selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
	   step_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') );
	   new_price = current_price - step_price + selected_price;
	   new_price = new_price.toFixed(2).toString().replace(/\./g, ',');
       if ( (".retail-price-title span").lenght > 0 ) { 
         current_rrp_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price").replace(/\,/g, '.') );
         selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') ); 
  	     step_rrp_price = parseFloat( $(this).closest(".otaku-box-questions").find(".otaku-box-questions-select.selected .otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') );
  	     new_rrp_price = current_rrp_price - step_rrp_price + selected_rrp_price;
  	     new_rrp_price = new_rrp_price.toFixed(2).toString().replace(/\./g, ',');
       }  
	  } 
      if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false && $(this).hasClass("end-post-purchase-ecchitoons") == false && $(this).closest(".otaku-box-selected-offer-step").hasClass("additional-pre-step") == false ) {
        $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
        $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text(selected_currency + new_price.toString());
        $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
        $(this).closest(".the-otaku-box-body").find(".retail-price-title span").text( selected_currency + new_rrp_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      }
    } else {     
      let new_price = current_price + selected_price;
      new_price = new_price.toFixed(2);
      let new_rrp_price = current_rrp_price + selected_rrp_price;
      new_rrp_price = new_rrp_price.toFixed(2);
      if ( selected_currency == "€") {
		current_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price").replace(/\,/g, '.') );
        selected_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-price").replace(/\,/g, '.') ); 
	    new_price = current_price + selected_price;
        new_price = new_price.toFixed(2).toString().replace(/\./g, ',');
        if ( (".retail-price-title span").lenght > 0 ) {
          current_rrp_price = parseFloat( $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price").replace(/\,/g, '.') );
          selected_rrp_price = parseFloat( $(this).find(".otaku-box-questions-select-inner").attr("data-rrp-price").replace(/\,/g, '.') ); 
  	      new_rrp_price = current_rrp_price + selected_rrp_price;
          new_rrp_price = new_rrp_price.toFixed(2).toString().replace(/\./g, ',');
        }  


         if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false && $(this).hasClass("end-post-purchase-ecchitoons") == false && $(this).closest(".otaku-box-selected-offer-step").hasClass("additional-pre-step") == false ) {
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toString());
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").text( selected_currency + new_rrp_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        }
        
	  } else {
        if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("free-pre-step") == false && $(this).hasClass("end-post-purchase-ecchitoons") == false && $(this).closest(".otaku-box-selected-offer-step").hasClass("additional-pre-step") == false ) {
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").attr("data-price",new_price);
          $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text( selected_currency + new_price.toString());
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").attr("data-rrp-price",new_rrp_price);
          $(this).closest(".the-otaku-box-body").find(".retail-price-title span").text( selected_currency + new_rrp_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        }
      }
    }
    $(".otaku-box-offer-btn").removeAttr("disabled");
	$(this).closest(".otaku-box-questions").find( ".otaku-box-questions-select" ).removeClass("selected");
    $(this).addClass("selected");
	if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("otaku-box-selected-offer-step-final") ) {
	  $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    }
	if ( $(this).hasClass("start-pre-purchase") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-pre-purchase");
    }
    if ( $(this).hasClass("start-multi-upsell-step") ) {
         $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-post-purchase-multi");
    } else if ( $(this).hasClass("start-post-purchase") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-post-purchase");
      if ( $(this).hasClass("yes-option") ) {
        $(this).closest(".otaku-box-selected-offer-step").find( ".otaku-box-selected-offer-step-title-selected" ).text("Uncensored");
      } else {
        $(this).closest(".otaku-box-selected-offer-step").find( ".otaku-box-selected-offer-step-title-selected" ).text("Censored");
      }
    }
    if ( $(this).hasClass("show-retail-price") ) {
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-show-retail-price");
    }
    $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).find(".otaku-box-answer-select-input-id").val() );
    $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).find(".otaku-box-answer-select-input-selling-plan").val() );
    if ( $(this).closest(".otaku-box-selected-offer-step").hasClass("tob-variant-final") ) {
      let combined_options = '';
      $( ".the-otaku-box-body.selected .otaku-box-selected-offer-step" ).each(function() {
	    if ( ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != '' ) &&
		     ( $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val() != null ) ) {
          combined_options = combined_options + $(this).find(".otaku-box-questions-select.selected").find( ".otaku-box-step-option-name" ).val();
        }
      });
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-id").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-id.variant-title-" + combined_options ).val() );
      $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-step-select-input-selling-plan").eq(0).val( $(this).closest(".otaku-box-selected-offer-step").find(".otaku-box-answer-select-input-selling-plan.variant-title-" + combined_options).val() );
    }
    
    }
 });
}); 
$( document ).ready(function() {
  $( ".otaku-box-selected-offer-step-change" ).click(function() {
    $(".otaku-box-selected-offer-step").removeClass("edit"); 
    $(this).closest(".otaku-box-selected-offer-step").addClass("edit");  
    $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-edit");
    //$(".otaku-box-offer-btn").attr("disabled","disabled");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-monthly-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-monthly-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-monthly-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-three-months-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-three-months-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-three-months-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-six-months-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-six-months-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-six-months-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-annual-offer-box" ).click(function() {
    $(".the-otaku-box-body").removeClass("selected");
    $("#the-otaku-box-annual-offer").addClass("selected");
    $(".otaku-box-body-image-container-back").removeClass("digital-back");
    $("#the-otaku-box-annual-offer .otaku-box-body-image-container-back").addClass("digital-back");
 });
});
$( document ).ready(function() {
  $( ".otaku-box-monthly-offer-box" ).click(function() {
   $(".the-otaku-box-body").removeClass("pre-select-no");
 });
});  
$( document ).ready(function() {
  $( "#digital-no" ).click(function() {
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-edit");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn-final").click();
    $('#pre-purchase').css('pointer-events','none');
    $("#pre-purchase .modal-dialog").hide();
  });
  $( "#digital-yes" ).click(function() {
    $(".otaku-box-offer-footer-cancel-digital").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
    $("#pre-purchase .close").click();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-price").removeClass("otaku-box-selected-offer-info-price");
    $(".the-otaku-box-body.selected").find(".otaku-box-pre-purchase-offer-price").addClass("otaku-box-selected-offer-info-price");
    $(".main-product-image").addClass("remove-main-image");
    $(".main-digital-image").removeClass("remove-digital-image");
    $(".otaku-box-body-image-container").addClass("digital-image-container");
    $(".otaku-box-selected-offer-info-header").addClass("otaku-box-selected-offer-info-digital-header");
    let info_title = $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").attr("data-title");	
    $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").html("You have the TOB <span>" + info_title + "</span>" );
    $(".the-otaku-box-body.selected .otaku-box-plan-title").hide();
    $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-digital-title").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }); 
  $( ".digital-back" ).click(function() {
    $(".otaku-box-offer-footer-cancel-digital").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-pre-purchase"); 
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.selected").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.active").show();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital").hide();
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-price").addClass("otaku-box-selected-offer-info-price");
    $(".the-otaku-box-body.selected").find(".otaku-box-pre-purchase-offer-price").removeClass("otaku-box-selected-offer-info-price");
    $(".main-product-image").removeClass("remove-main-image");
    $(".main-digital-image").addClass("remove-digital-image");
    $(".main-digital-image").removeClass("show-image");
    $(".main-digital-image").removeAttr("style")
    $(".otaku-box-body-image-container").removeClass("digital-image-container");
    $(".otaku-box-selected-offer-info-header").removeClass("otaku-box-selected-offer-info-digital-header");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step").removeClass("active");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step .otaku-box-step-select-main-input").val("");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.digital-step .otaku-box-questions-select").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.pre-purchase-step").removeClass("selected");
    $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-step.pre-purchase-step").addClass("active");
    $(".otaku-box-offer-btn").removeAttr("disabled");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
    let selected_currency = $(this).closest(".otaku-box-body-offer-container").find(".otaku-box-selected-offer-info-price").text().slice(0,1);
    if ( selected_currency == "€") {
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").attr("data-price","0,00");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").html("€0,00");
    } else {
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").attr("data-price","0.00");
      $(".the-otaku-box-body.selected").find(".otaku-box-selected-offer-info-header-digital .otaku-box-pre-purchase-offer-price").html("$0.00");
    }
    let info_title = $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").attr("data-title");		
    $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-title:not(.otaku-box-pre-purchase-offer-title)").html(info_title);
    $(".the-otaku-box-body.selected .otaku-box-plan-title").show();
    $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-digital-title").hide(); 
    if ( selected_currency == "€") {
      if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Kasse");
         } else {
           $(".otaku-box-offer-btn").html("Vérifier");
         }
    } else {
      $(".otaku-box-offer-btn").html("Checkout");
    }
    
    $(".otaku-box-offer-btn").html("Checkout");
    $(".retail-price-step").addClass("selected");
    $(".retail-price-section").addClass("show");
    $(".otaku-box-selected-offer-info-footer-price").addClass("show"); 
    $(".otaku-box-selected-offer-step.retail-price-step .otaku-box-questions-select").removeClass("show-retail-price"); 
    $(".otaku-box-offer-footer").addClass("hide-border"); 
  });
  $( "#cancel-digital" ).click(function() {
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-final");
    $(".the-otaku-box-body.selected").find(".otaku-box-offer-btn").click();
  }); 
}); 


// EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE  

document.getElementById('email-input').addEventListener('input', function(event) {
  $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
  const emailInput = event.target.value;
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if ( (emailPattern.test(emailInput)) && !( document.querySelector('.pre-offer-email')?.style.display === 'none' ) ) {
    $(".otaku-box-offer-pre-btn").removeAttr("disabled");
  }
});  

document.addEventListener('DOMContentLoaded', (event) => {
  const sourceEmailInput = document.getElementById('email-input');
  const targetEmailInput = document.getElementById('ap3w-form-input-email-666c6e29b33be36895a580b0');

  const updateTargetEmailInput = () => {
    targetEmailInput.value = sourceEmailInput.value;
  };

  // Listen for various events that might change the input's value
  sourceEmailInput.addEventListener('input', updateTargetEmailInput);
  sourceEmailInput.addEventListener('change', updateTargetEmailInput);
  sourceEmailInput.addEventListener('keyup', updateTargetEmailInput);
  sourceEmailInput.addEventListener('paste', updateTargetEmailInput);
  sourceEmailInput.addEventListener('blur', updateTargetEmailInput);
});


function validateEmail(email) {
  // 96dfd31386d6ba5e858743410b313b74-51356527-d625367c
  // pubkey-9ccb66ed454695cd7b9a8cf70f99b4d3
  var apiKey = '96dfd31386d6ba5e858743410b313b74-51356527-d625367c';  // Replace with your Mailgun public API key
    
  console.log(`Validating email: ${email}`);
  fetch(`https://api.mailgun.net/v4/address/validate?address=${email}`, {
    method: 'GET',
    headers: {
      'Authorization': 'Basic ' + btoa('api:' + apiKey)
    }
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    console.log('Validation response data:', data);
    displayValidationResult(data);
  })
  .catch(error => {
    console.error('Error:', error);
    displayValidationError(error);
  });
}
            
function displayValidationResult(data) {
  var validationResult = document.getElementById('validationResult');
  //if (data.is_valid) {
  if (data.result == "deliverable") {  
    //validationResult.textContent = 'The email address is valid.';
    //validationResult.style.color = 'green';
    $(".otaku-box-offer-pre-btn").removeClass("otaku-box-offer-pre-btn-email");
    $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-title").show();
    $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-subtitle").show();
    $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-questions.otaku-box-questions-combination").show();
    $(".otaku-box-offer-footer-lv-2").show();
    $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
    $(".pre-offer-email").hide();
    $("#ap3w-form-button-666c6e29b33be36895a580b0").click();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    validationResult.textContent = 'The email address is invalid.';
    validationResult.style.color = 'red';
  }
}
function displayValidationError(error) {
    var validationResult = document.getElementById('validationResult');
    validationResult.textContent = `There was an error validating the email address: ${error.message}`;
    validationResult.style.color = 'red';
}  
   
$( document ).ready(function() {
  $( ".otaku-box-offer-pre-btn" ).click(function() {
    if ( $(this).hasClass("otaku-box-offer-pre-btn-email") ) {

      var email = document.getElementById('email-input').value;
      //validateEmail(email);

      $(".otaku-box-offer-pre-btn").removeClass("otaku-box-offer-pre-btn-email");
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-title").show();
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-subtitle").show();
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-questions.otaku-box-questions-combination").show();
      $(".otaku-box-offer-footer-lv-2").show();
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(".pre-offer-email").hide();
      $(".pre-offer-email").addClass("populated")
      $("#ap3w-form-button-666c6e29b33be36895a580b0").click();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
    } else {
    $(".pre-offer-email").hide();
    $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long").show();  
    if ( $(".single-offer-body").length > 0 ) {
      if ( $(this).hasClass("otaku-box-offer-pre-btn-lv3") ) {
        $(".single-offer-body").addClass("selected");
        $(".otaku-box-selected-offer-pre-step").hide();
        $("body").removeClass("black-friday-offer");
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else if ( $(this).hasClass("otaku-box-offer-pre-btn-lv2") ) {
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).removeClass("otaku-box-offer-pre-btn-lv2");
          $(this).addClass("otaku-box-offer-pre-btn-lv3");
          $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v2");
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v3");
          $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
          $(".otaku-box-offer-footer-lv-2-btn").addClass("otaku-box-offer-footer-lv-3-btn");
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step == 1 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          }
          if ( selected_step == 2 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='1']").hide();
          }
          if ( selected_step ==  3) {
            $(".otaku-box-questions-select-pre-step[data-combination='2']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='1']").hide();
          }
          $(".step-back-initial").addClass("step-back-initial-2");

          window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-title").text( $(".additional-pre-step .otaku-box-selected-offer-step-title").first().text().trim() );
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-subtitle").text( $(".additional-pre-step .otaku-box-selected-offer-step-subtitle").first().text().replace(/\s+/g, ' ').trim() );
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).addClass("otaku-box-offer-pre-btn-lv2");
          $(".otaku-box-questions-select-pre-step.selected").hide();
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step == 1 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          }
          if ( selected_step == 2 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          }
          if ( selected_step ==  3) {
            $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          }
          $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").hide();
          $(".otaku-box-offer-footer-lv-2").show();
          $(".step-back-initial").show();
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v2");
          $(".show-neither").hide();

          window.scrollTo({ top: 0, behavior: 'smooth' });

      }  
      
    } else {
      if ( $(this).hasClass("otaku-box-offer-pre-btn-lv3") ) {
        $("#the-otaku-box-six-months-offer").addClass("selected");
        $(".otaku-box-selected-offer-pre-step").hide();
        $("body").removeClass("black-friday-offer");
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else if ( $(this).hasClass("otaku-box-offer-pre-btn-lv2") ) {
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).removeClass("otaku-box-offer-pre-btn-lv2");
          $(this).addClass("otaku-box-offer-pre-btn-lv3");
          $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v2");
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v3");
          $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
          $(".otaku-box-offer-footer-lv-2-btn").addClass("otaku-box-offer-footer-lv-3-btn");
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step == 1 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          }
          if ( selected_step == 2 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='1']").hide();
          }
          if ( selected_step ==  3) {
            $(".otaku-box-questions-select-pre-step[data-combination='2']").show();
            $(".otaku-box-questions-select-pre-step[data-combination='1']").hide();
          }
          $(".step-back-initial").addClass("step-back-initial-2");
          window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {        
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-title").text( $(".additional-pre-step .otaku-box-selected-offer-step-title").first().text().trim() );
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-subtitle").text( $(".additional-pre-step .otaku-box-selected-offer-step-subtitle").first().text().replace(/\s+/g, ' ').trim() );
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          $(this).addClass("otaku-box-offer-pre-btn-lv2");
          $(".otaku-box-questions-select-pre-step.selected").hide();
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step == 1 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          }
          if ( selected_step == 2 ) {
            $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          }
          if ( selected_step ==  3) {
            $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          }
          $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").hide();
          $(".otaku-box-offer-footer-lv-2").show();
          $(".step-back-initial").show();
          $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v2");
          $(".show-neither").hide();

          // Only difference
          if ( $(this).closest(".the-otaku-box-container").hasClass("pre-select-options") ) {
            $(".otaku-box-selected-offer-pre-step-v2 .otaku-box-offer-footer-lv-2-btn-yes").click();
          }

          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-title").hide();
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-subtitle").hide();
          $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-questions.otaku-box-questions-combination").hide();
          $(".otaku-box-offer-footer-lv-2").hide();
          $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
         
          setTimeout(function(){  
            let emailInput = document.getElementById('email-input').value;
            let emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if ( (emailPattern.test(emailInput)) && !( document.querySelector('.pre-offer-email')?.style.display === 'none' ) ) {
              $(".otaku-box-offer-pre-btn").removeAttr("disabled");
            }               
          }, 10);
        
          if ( $(".pre-offer-email").hasClass("populated") ) {
            $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-title").show();
            $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-subtitle").show();
            $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-questions.otaku-box-questions-combination").show();
            $(".otaku-box-offer-footer-lv-2").show();
            $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
          } else {
            $(".pre-offer-email").show();
            $(".otaku-box-offer-pre-btn").addClass("otaku-box-offer-pre-btn-email");
          }  
        window.scrollTo({ top: 0, behavior: 'smooth' });

      }  
      
    }
    }

    $(".free-offer-note").hide();

  });
  $(".otaku-box-offer-footer-lv-2-btn").click(function() {
    if ( $(this).hasClass("otaku-box-offer-footer-lv-3-btn") ) {
      $(".otaku-box-offer-pre-btn-lv3").removeAttr("disabled");
    } else {
      $(".otaku-box-offer-pre-btn-lv2").removeAttr("disabled");
    }
    $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
    $(this).addClass("selected");
  });
  $(".otaku-box-offer-footer-lv-2-btn-yes").click(function() {
    let combination_step = $(this).closest(".otaku-box-selected-offer-pre-step").find(".otaku-box-questions-select-pre-step:not(.selected)").attr("data-combination");
    if ( $(this).hasClass("otaku-box-offer-footer-lv-3-btn") ) {
      let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
      let combination_step = 3;
      if ( selected_step == 3 ) {
        combination_step = 2;
      }
      $( ".the-otaku-box-container" ).each(function() {
      let combination_product_id = $(this).find(".additional-pre-step .otaku-box-combination-product[data-combination=" + combination_step + "] .otaku-box-answer-select-input-id").val();
      $('.step-image[data-step_' + combination_step + '=2]').addClass("show-image");
	  $('.step-image[data-step_' + combination_step + '=2]').css({"animation":"image-animation-on 0.5s"});
        if ( ( $(this).find(".additional-pre-step .all-two").val() != '' ) && ( $(this).find(".additional-pre-step .all-two").val() != combination_product_id ) ) {
          $( this ).find( ".additional-pre-step .all-three").val(combination_product_id);
        } else {
          $( this ).find( ".additional-pre-step .all-two").val(combination_product_id);
        }
      });
    } else {
      $( ".the-otaku-box-container" ).each(function() {
        $( this ).find( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select[data-combination=" + combination_step + "]" ).click();
      });
    }
  });
  $(".otaku-box-offer-footer-lv-2-btn-no").click(function() {
    if ( $(this).hasClass("otaku-box-offer-footer-lv-3-btn") ) {
      if ( $(".additional-pre-step .all-three").val() != '' ) {
        $( ".additional-pre-step .all-three").val("");
      } else {
        let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
        let combination_step = 3;
        if ( selected_step == 3 ) {
          combination_step = 2;
        } 
        let combination_product_id = $(".additional-pre-step .otaku-box-combination-product[data-combination=" + combination_step + "] .otaku-box-answer-select-input-id").val();
        if ( ( $(".additional-pre-step .all-two").val() != '' ) && ( $(".additional-pre-step .all-two").val() == combination_product_id ) ) {  
          $( ".additional-pre-step .all-two").val("");
        }
      }
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step ==  3) {
            $(".step-image-combination.step-image[data-step_2='2']").removeClass("show-image");
            $(".step-image-combination.step-image[data-step_2='2']").removeAttr( 'style' );
          } else {
            $(".step-image-combination.step-image[data-step_3='2']").removeClass("show-image");
          $(".step-image-combination.step-image[data-step_3='2']").removeAttr( 'style' );
          }
    } else {
      $( ".additional-pre-step .otaku-box-step-select-input-id").val("");
          let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
          if ( selected_step ==  1) {
            $(".step-image-combination.step-image[data-step_2='2']").removeClass("show-image");
            $(".step-image-combination.step-image[data-step_2='2']").removeAttr( 'style' );
          } else {
            $(".step-image-combination.step-image[data-step_1='2']").removeClass("show-image");
            $(".step-image-combination.step-image[data-step_1='2']").removeAttr( 'style' );
          }
    }
    $( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select").removeClass("selected");
  });
  $(".step-back-initial").click(function() {
    if ( $(this).hasClass("step-back-initial-2") ) {
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
        $(".otaku-box-offer-pre-btn").addClass("otaku-box-offer-pre-btn-lv2");
        $(".otaku-box-offer-pre-btn").removeClass("otaku-box-offer-pre-btn-lv3");
        $(".otaku-box-selected-offer-pre-step").addClass("otaku-box-selected-offer-pre-step-v2");
        $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v3");
        $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
        $(".otaku-box-offer-footer-lv-2-btn").removeClass("otaku-box-offer-footer-lv-3-btn");
        let selected_step = parseInt($(".otaku-box-questions-select-pre-step.selected").attr("data-combination"));
        if ( selected_step == 1 ) {
          $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          $(".otaku-box-questions-select-pre-step[data-combination='2']").show();
        }
        if ( selected_step == 2 ) {
          $(".otaku-box-questions-select-pre-step[data-combination='3']").hide();
          $(".otaku-box-questions-select-pre-step[data-combination='1']").show();
        }
        if ( selected_step ==  3) {
          $(".otaku-box-questions-select-pre-step[data-combination='2']").hide();
          $(".otaku-box-questions-select-pre-step[data-combination='1']").show();
        }
        $(".step-back-initial").removeClass("step-back-initial-2");
    } else {
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-title").text( $(".free-pre-step .otaku-box-selected-offer-step-title").first().text().trim() );
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-subtitle").text( $(".free-pre-step .otaku-box-selected-offer-step-subtitle").first().text().trim() );
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $( ".otaku-box-offer-pre-btn" ).removeClass("otaku-box-offer-pre-btn-lv2");
      $(".otaku-box-questions-select-pre-step").show();
      $(".otaku-box-questions-select-pre-step .otaku-box-questions-select-inner").show();
      $(".otaku-box-offer-footer-lv-2").hide();
      $(".step-back-initial").hide();
      $( ".additional-pre-step .otaku-box-questions-combination .otaku-box-questions-select").removeClass("selected");
      $( ".additional-pre-step .otaku-box-step-select-input-id").val("");
      $(".otaku-box-selected-offer-pre-step").removeClass("otaku-box-selected-offer-pre-step-v2");
      $(".otaku-box-offer-footer-lv-2 .otaku-box-offer-footer-lv-2-btn").removeClass("selected");
      $(".otaku-box-selected-offer-pre-step .otaku-box-questions-select-pre-step").removeClass("selected"); 
      $(".show-neither").show(); 
      $("body").addClass("black-friday-offer");
      $(".free-offer-note").show();

      $(".otaku-box-offer-pre-btn").removeClass("otaku-box-offer-pre-btn-email");
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-title").show();
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-selected-offer-step-subtitle").show();
      $(".otaku-box-selected-offer-pre-step .otaku-box-selected-offer-step-long .otaku-box-questions.otaku-box-questions-combination").show();
      $(".pre-offer-email").hide();

      
    }
  });
}); 


// EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE
  
$( document ).ready(function() {
  $( ".step-back" ).click(function() {
    if ( $(this).hasClass("box-selection") ) {
      $(".the-otaku-box-body").removeClass("selected");
      $("body").addClass("black-friday-offer");
      $(".otaku-box-selected-offer-pre-step").show();
      $(".otaku-box-offer-pre-btn").attr("disabled","disabled");
      $(".otaku-box-offer-footer-lv-2-btn").removeClass("selected");
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( $(this).hasClass("box-selected") ) {
      $(".otaku-box-offer-boxes").show();   
      $(".otaku-box-offer-info").show();
      $(".otaku-box-selected-offer-info").removeClass("selected");
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-initial");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-show-retail-price");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase");
      $(".otaku-box-offer-btn").removeAttr("disabled");	
      $(".otaku-box-body-image-container-back").addClass("box-selection");
      $(".otaku-box-body-image-container-back").removeClass("box-selected");
      $(".otaku-box-plan-title-1").show();
      $(".otaku-box-plan-title-2").hide();

      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase-multi");
      
      //$(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select").addClass("show-retail-price");
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
         if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Weiter");
         } else {
           $(".otaku-box-offer-btn").html("Suivant");
         }
      } else {
         $(".otaku-box-offer-btn").html("Next");
      }
      $(".retail-price-step").removeClass("selected");
      $(".retail-price-section").removeClass("show");
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").show();
   
      
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    
    if ( $(this).hasClass("multi-back-3") ) {
        $("body").addClass("fixed");
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function(){  $("body").removeClass("fixed") }, 500);
         $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
        $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-3");
        $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").addClass("otaku-box-offer-btn-multi-2");
        $(".main-digital-image-3").removeClass("hide-digital");
        $(".main-digital-image-4").addClass("hide-digital");
        $(".otaku-box-body-image-container-back").removeClass("multi-back-3");

        $(".upsell-step-3").removeClass("active");
        $(".multi-step-3").removeClass("selected");
        $(".upsell-step-2").addClass("active");
        $(".upsell-step-2").removeClass("selected");
        $(".multi-step-2").removeClass("selected");
        $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").attr("disabled","true");
        $(".upsell-step-3 .otaku-box-step-select-main-input").val("");
  
    } else if ( $(this).hasClass("multi-back-2") ) {
        $("body").addClass("fixed");
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function(){  $("body").removeClass("fixed") }, 500);
        $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-2");
        $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").addClass("otaku-box-offer-btn-multi-1");
        $(".main-digital-image-2").removeClass("hide-digital");
        $(".main-digital-image-3").addClass("hide-digital");
        $(".otaku-box-body-image-container-back").removeClass("multi-back-2");

        $(".upsell-step-2").removeClass("active");
        $(".multi-step-2").removeClass("selected");
        $(".upsell-step-1").addClass("active");
        $(".upsell-step-1").removeClass("selected");
        $(".multi-step-1").removeClass("selected");
        $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").attr("disabled","true");
        $(".upsell-step-2 .otaku-box-step-select-main-input").val("");

     } else if ( $(this).hasClass("multi-back-1") ) {
        $("body").addClass("fixed");
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function(){  $("body").removeClass("fixed") }, 500);
        $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-1");
        $(".the-otaku-box-body-v2.selected .otaku-box-offer-btn").addClass("otaku-box-offer-btn-multi");
        $(".main-digital-image-1").removeClass("hide-digital");
        $(".main-digital-image-2").addClass("hide-digital");
        $(".otaku-box-body-image-container-back").removeClass("multi-back-1");

        $(".upsell-step-1").removeClass("active");
        $(".multi-step-1").removeClass("selected");
        $(".multi-upsell-step").addClass("active");
        $(".multi-upsell-step").removeClass("selected");
        $(".multi-step-yes").removeClass("selected");
        $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").attr("disabled","true");  
        $(".upsell-step-1 .otaku-box-step-select-main-input").val("");
      
    } else if ( $(this).hasClass("box-checkout-2") ) {
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next_2").removeClass("active");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step-final").removeClass("active");
      
      
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next").removeClass("selected");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next").addClass("active");
      
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-1").removeClass("hide-digital");
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-2").addClass("hide-digital");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").removeClass("post_purchase_step_image_2");

      
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").attr("disabled","true");

      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step .otaku-box-questions-select.selected").removeClass("selected");
      
      $(this).removeClass("box-checkout-2");
    } else if ( $(this).hasClass("box-checkout-3") ) {
      
      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step-final").removeClass("active");
      
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next_2").removeClass("selected");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step.post_purchase_step_next_2").addClass("active");
      
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-2").removeClass("hide-digital");
      $(this).closest(".the-otaku-box-body").find(".main-digital-image-3").addClass("hide-digital");

      $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").addClass("post_purchase_step_image_2");
      $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").removeClass("post_purchase_step_image_3");

      
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").attr("disabled","true");

      $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step .otaku-box-questions-select.selected").removeClass("selected");
      
      $(this).removeClass("box-checkout-3");
      $(this).addClass("box-checkout-2"); 
    } else if ( $(this).hasClass("box-checkout") ) {
      
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-post-purchase"); 
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-next");
      $(".otaku-box-selected-offer-step.selected").show();
      $(".otaku-box-selected-offer-step.active").show();
      $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-plan-title-2").show();
      $(".the-otaku-box-body.selected .otaku-box-plan-title.otaku-box-plan-title-1").hide();
      $(".the-otaku-box-body.selected .otaku-box-selected-offer-info-header-text").show();
      $(".main-product-image").removeClass("remove-main-image");
      $(".main-digital-image").addClass("remove-digital-image");
  
    
      $(".otaku-box-body-image-container").removeClass("post_purchase_step_image");
      $(".otaku-box-body-image-container-back").addClass("box-selected");
      $(".otaku-box-body-image-container-back").removeClass("box-checkout");
      $(".post_purchase_step").removeClass("active");
      $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-final");
      $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-next");
      //$(".otaku-box-offer-btn").attr("disabled","disabled");
      $(".otaku-box-offer-btn").removeAttr("disabled");
      $(".otaku-box-plan-title.otaku-box-digital-title").hide();

      
      if ( $(this).closest(".the-otaku-box-body").hasClass("retail-price-body") ) {
        $(this).closest(".the-otaku-box-body").find(".retail-price-step").addClass("active");
        $(this).closest(".the-otaku-box-body").find(".otaku-box-questions-select").addClass("show-retail-price");
        $(".retail-price-step").removeClass("selected");
        $(".retail-price-section").removeClass("show");
      }

      
      let selected_currency = $(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-info-price").text().slice(0,1);  
      if ( selected_currency == "€") {
         if ( $("#local_url").val() == "/de-de/" ) {
           $(".otaku-box-offer-btn").html("Weiter");
         } else {
           $(".otaku-box-offer-btn").html("Suivant");
         }
      } else {
         $(".otaku-box-offer-btn").html("Next");
      }
     
      $(".otaku-box-selected-offer-info-footer-price").removeClass("show");
      $(".otaku-box-offer-footer").removeClass("hide-border");
      $(".otaku-box-selected-offer-info-header-main .otaku-box-selected-offer-info-header-text .otaku-box-selected-offer-monthly-info-price").show(); 


      if ( $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").hasClass("otaku-box-offer-btn-post-purchase-start") ) {
        $(this).closest(".the-otaku-box-body").find(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase-start");
        $(this).closest(".the-otaku-box-body").find(".main-digital-image-1").removeClass("hide-digital");
        $(this).closest(".the-otaku-box-body").find(".main-digital-image-2").addClass("hide-digital");
        $(this).closest(".the-otaku-box-body").find(".main-digital-image-3").addClass("hide-digital");
        $(this).closest(".the-otaku-box-body").find(".post_purchase_step_image").removeClass("post_purchase_step_image_2");
      }

      //$(this).closest(".the-otaku-box-body").find(".otaku-box-selected-offer-step .otaku-box-questions-select.selected").removeClass("selected");

      if ( $(".start-multi-upsell-step").length ) {
        $(".multi-upsell-step").removeClass("active");
        $(".multi-upsell-step").removeClass("selected");
        $(".multi-upsell-step").removeAttr("style");
        $(".upsell-step-1").removeClass("active");
        $(".upsell-step-1").removeClass("selected");
        $(".upsell-step-1").removeAttr("style");
        $(".upsell-step-2").removeClass("active");
        $(".upsell-step-2").removeClass("selected");
        $(".upsell-step-2").removeAttr("style");
        $(".upsell-step-3").removeClass("active");
        $(".upsell-step-3").removeClass("selected");
        $(".upsell-step-3").removeAttr("style");
        $(".multi-upsell-step .otaku-box-questions-select").removeClass("selected");
        $(".upsell-step-1 .otaku-box-questions-select").removeClass("selected");
        $(".upsell-step-2 .otaku-box-questions-select").removeClass("selected");
        $(".upsell-step-3 .otaku-box-questions-select").removeClass("selected");
        $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-post-purchase"); 
        $(".otaku-box-offer-btn").addClass("otaku-box-offer-btn-post-purchase-multi"); 
        $(".main-digital-image-1").removeClass("hide-digital");
        $(".main-digital-image-2").addClass("hide-digital");
        $(".main-digital-image-3").addClass("hide-digital");
        $(".main-digital-image-4").addClass("hide-digital");
        $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi");
        $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-1");
        $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-2");
        $(".otaku-box-offer-btn").removeClass("otaku-box-offer-btn-multi-3");
      }
      
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
});   
function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
if ( getUrlVars() !== undefined ) {
if ( $("#tripwire-url-1").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-1").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-1").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-2").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-2").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-2").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-3").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-3").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-3").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-4").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-4").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-4").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-5").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-5").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-5").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-6").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-6").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-6").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-7").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-7").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-7").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-8").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-8").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-8").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-9").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-9").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-9").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
if ( $("#tripwire-url-10").val() !== undefined ) {
  if ( getUrlVars()["freefigure"] ==  $("#tripwire-url-10").val() ) {
    $( ".otaku-box-selected-offer-step-final" ).append( '<input type="hidden" name="select-single" class="otaku-box-step-select-input-id" value="' + $("#tripwire-url-id-10").val() + '"><input type="hidden" name="select-single" class="otaku-box-step-select-input-selling-plan" value="">' ); 
  }
}
}

$( document ).ready(function() {
  if ( getUrlVars() !== undefined ) {
    if ( ( getUrlVars()["figure"] ==  "rias" ) || ( getUrlVars()["figure"] ==  "first" ) ) {
      $(".otaku-box-selected-offer-pre-step:not(.otaku-box-selected-offer-pre-step-v2) .otaku-box-questions-select[data-combination='1']").click();
      $(".otaku-box-offer-pre-btn").click();
      $(".otaku-box-selected-offer-pre-step").show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( ( getUrlVars()["figure"] ==  "leafa" ) || ( getUrlVars()["figure"] ==  "rem" ) || ( getUrlVars()["figure"] ==  "albedo" ) || ( getUrlVars()["figure"] ==  "second" ) ) {
      $(".otaku-box-selected-offer-pre-step:not(.otaku-box-selected-offer-pre-step-v2) .otaku-box-questions-select[data-combination='2']").click();
      $(".otaku-box-offer-pre-btn").click();
      $(".otaku-box-selected-offer-pre-step").show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ( ( getUrlVars()["figure"] ==  "rias-maid" ) || ( getUrlVars()["figure"] ==  "third" ) ) {
      $(".otaku-box-selected-offer-pre-step:not(.otaku-box-selected-offer-pre-step-v2) .otaku-box-questions-select[data-combination='3']").click();
      $(".otaku-box-offer-pre-btn").click();
      $(".otaku-box-selected-offer-pre-step").show();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}); 

$(document).ready(function() {
  function generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const urgencyNote = $('.urgency-note');
  if (urgencyNote.length > 0) {
    const randomNumber = generateRandomNumber(25, 50);
    urgencyNote.find('span').text(randomNumber);
  }
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
